webpackJsonp([4],{

/***/ "/6zp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration7/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var main = ({
  name: 'DvDecoration7',
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      defaultColor: ['#1dc1f5', '#1dc1f5'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration7/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var src_main = ({
  name: 'DvDecoration7',
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      defaultColor: ['#1dc1f5', '#1dc1f5'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a40c4f44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration7/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dv-decoration-7"},[_c('svg',{attrs:{"width":"21px","height":"20px"}},[_c('polyline',{attrs:{"stroke-width":"4","fill":"transparent","stroke":_vm.mergedColor[0],"points":"10, 0 19, 10 10, 20"}}),_vm._v(" "),_c('polyline',{attrs:{"stroke-width":"2","fill":"transparent","stroke":_vm.mergedColor[1],"points":"2, 0 11, 10 2, 20"}})]),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('svg',{attrs:{"width":"21px","height":"20px"}},[_c('polyline',{attrs:{"stroke-width":"4","fill":"transparent","stroke":_vm.mergedColor[0],"points":"11, 0 2, 10 11, 20"}}),_vm._v(" "),_c('polyline',{attrs:{"stroke-width":"2","fill":"transparent","stroke":_vm.mergedColor[1],"points":"19, 0 10, 10 19, 20"}})])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var decoration7_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/decoration7/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  decoration7_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_decoration7_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/Q7J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/conicalColumnChart/src/main.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvConicalColumnChart',
  mixins: [autoResize_default.a],
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      ref: 'conical-column-chart',

      defaultConfig: {
        /**
         * @description Chart data
         * @type {Array<Object>}
         * @default data = []
         */
        data: [],
        /**
         * @description Chart img
         * @type {Array<String>}
         * @default img = []
         */
        img: [],
        /**
         * @description Chart font size
         * @type {Number}
         * @default fontSize = 12
         */
        fontSize: 12,
        /**
         * @description Img side length
         * @type {Number}
         * @default imgSideLength = 30
         */
        imgSideLength: 30,
        /**
         * @description Column color
         * @type {String}
         * @default columnColor = 'rgba(0, 194, 255, 0.4)'
         */
        columnColor: 'rgba(0, 194, 255, 0.4)',
        /**
         * @description Text color
         * @type {String}
         * @default textColor = '#fff'
         */
        textColor: '#fff',
        /**
         * @description Show value
         * @type {Boolean}
         * @default showValue = false
         */
        showValue: false
      },

      mergedConfig: null,

      column: []
    };
  },

  watch: {
    config: function config() {
      var calcData = this.calcData;


      calcData();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcData = this.calcData;


      calcData();
    },
    onResize: function onResize() {
      var calcData = this.calcData;


      calcData();
    },
    calcData: function calcData() {
      var mergeConfig = this.mergeConfig,
          initData = this.initData,
          calcSVGPath = this.calcSVGPath;


      mergeConfig();

      initData();

      calcSVGPath();
    },
    mergeConfig: function mergeConfig() {
      var defaultConfig = this.defaultConfig,
          config = this.config;


      this.mergedConfig = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config || {});
    },
    initData: function initData() {
      var mergedConfig = this.mergedConfig;
      var data = mergedConfig.data;


      data = Object(plugin_util["deepClone"])(data, true);

      data.sort(function (_ref, _ref2) {
        var a = _ref.value;
        var b = _ref2.value;

        if (a > b) return -1;
        if (a < b) return 1;
        if (a === b) return 0;
      });

      var max = data[0] ? data[0].value : 10;

      data = data.map(function (item) {
        return extends_default()({}, item, {
          percent: item.value / max
        });
      });

      mergedConfig.data = data;
    },
    calcSVGPath: function calcSVGPath() {
      var mergedConfig = this.mergedConfig,
          width = this.width,
          height = this.height;
      var imgSideLength = mergedConfig.imgSideLength,
          fontSize = mergedConfig.fontSize,
          data = mergedConfig.data;


      var itemNum = data.length;
      var gap = width / (itemNum + 1);

      var useAbleHeight = height - imgSideLength - fontSize - 5;
      var svgBottom = height - fontSize - 5;

      this.column = data.map(function (item, i) {
        var percent = item.percent;


        var middleXPos = gap * (i + 1);
        var leftXPos = gap * i;
        var rightXpos = gap * (i + 2);

        var middleYPos = svgBottom - useAbleHeight * percent;
        var controlYPos = useAbleHeight * percent * 0.6 + middleYPos;

        var d = '\n          M' + leftXPos + ', ' + svgBottom + '\n          Q' + middleXPos + ', ' + controlYPos + ' ' + middleXPos + ',' + middleYPos + '\n          M' + middleXPos + ',' + middleYPos + '\n          Q' + middleXPos + ', ' + controlYPos + ' ' + rightXpos + ',' + svgBottom + '\n          L' + leftXPos + ', ' + svgBottom + '\n          Z\n        ';

        var textY = (svgBottom + middleYPos) / 2 + fontSize / 2;

        return extends_default()({}, item, {
          d: d,
          x: middleXPos,
          y: middleYPos,
          textY: textY
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/conicalColumnChart/src/main.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvConicalColumnChart',
  mixins: [autoResize_default.a],
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      ref: 'conical-column-chart',

      defaultConfig: {
        /**
         * @description Chart data
         * @type {Array<Object>}
         * @default data = []
         */
        data: [],
        /**
         * @description Chart img
         * @type {Array<String>}
         * @default img = []
         */
        img: [],
        /**
         * @description Chart font size
         * @type {Number}
         * @default fontSize = 12
         */
        fontSize: 12,
        /**
         * @description Img side length
         * @type {Number}
         * @default imgSideLength = 30
         */
        imgSideLength: 30,
        /**
         * @description Column color
         * @type {String}
         * @default columnColor = 'rgba(0, 194, 255, 0.4)'
         */
        columnColor: 'rgba(0, 194, 255, 0.4)',
        /**
         * @description Text color
         * @type {String}
         * @default textColor = '#fff'
         */
        textColor: '#fff',
        /**
         * @description Show value
         * @type {Boolean}
         * @default showValue = false
         */
        showValue: false
      },

      mergedConfig: null,

      column: []
    };
  },

  watch: {
    config: function config() {
      var calcData = this.calcData;


      calcData();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcData = this.calcData;


      calcData();
    },
    onResize: function onResize() {
      var calcData = this.calcData;


      calcData();
    },
    calcData: function calcData() {
      var mergeConfig = this.mergeConfig,
          initData = this.initData,
          calcSVGPath = this.calcSVGPath;


      mergeConfig();

      initData();

      calcSVGPath();
    },
    mergeConfig: function mergeConfig() {
      var defaultConfig = this.defaultConfig,
          config = this.config;


      this.mergedConfig = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config || {});
    },
    initData: function initData() {
      var mergedConfig = this.mergedConfig;
      var data = mergedConfig.data;


      data = Object(plugin_util["deepClone"])(data, true);

      data.sort(function (_ref, _ref2) {
        var a = _ref.value;
        var b = _ref2.value;

        if (a > b) return -1;
        if (a < b) return 1;
        if (a === b) return 0;
      });

      var max = data[0] ? data[0].value : 10;

      data = data.map(function (item) {
        return extends_default()({}, item, {
          percent: item.value / max
        });
      });

      mergedConfig.data = data;
    },
    calcSVGPath: function calcSVGPath() {
      var mergedConfig = this.mergedConfig,
          width = this.width,
          height = this.height;
      var imgSideLength = mergedConfig.imgSideLength,
          fontSize = mergedConfig.fontSize,
          data = mergedConfig.data;


      var itemNum = data.length;
      var gap = width / (itemNum + 1);

      var useAbleHeight = height - imgSideLength - fontSize - 5;
      var svgBottom = height - fontSize - 5;

      this.column = data.map(function (item, i) {
        var percent = item.percent;


        var middleXPos = gap * (i + 1);
        var leftXPos = gap * i;
        var rightXpos = gap * (i + 2);

        var middleYPos = svgBottom - useAbleHeight * percent;
        var controlYPos = useAbleHeight * percent * 0.6 + middleYPos;

        var d = '\n          M' + leftXPos + ', ' + svgBottom + '\n          Q' + middleXPos + ', ' + controlYPos + ' ' + middleXPos + ',' + middleYPos + '\n          M' + middleXPos + ',' + middleYPos + '\n          Q' + middleXPos + ', ' + controlYPos + ' ' + rightXpos + ',' + svgBottom + '\n          L' + leftXPos + ', ' + svgBottom + '\n          Z\n        ';

        var textY = (svgBottom + middleYPos) / 2 + fontSize / 2;

        return extends_default()({}, item, {
          d: d,
          x: middleXPos,
          y: middleYPos,
          textY: textY
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c00d6fd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/conicalColumnChart/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-conical-column-chart"},[_c('svg',{attrs:{"width":_vm.width,"height":_vm.height}},_vm._l((_vm.column),function(item,i){return _c('g',{key:i},[_c('path',{attrs:{"d":item.d,"fill":_vm.mergedConfig.columnColor}}),_vm._v(" "),_c('text',{style:(("fontSize:" + (_vm.mergedConfig.fontSize) + "px")),attrs:{"fill":_vm.mergedConfig.textColor,"x":item.x,"y":_vm.height - 4}},[_vm._v("\n        "+_vm._s(item.name)+"\n      ")]),_vm._v(" "),(_vm.mergedConfig.img.length)?_c('image',{attrs:{"xlink:href":_vm.mergedConfig.img[i % _vm.mergedConfig.img.length],"width":_vm.mergedConfig.imgSideLength,"height":_vm.mergedConfig.imgSideLength,"x":item.x - _vm.mergedConfig.imgSideLength / 2,"y":item.y - _vm.mergedConfig.imgSideLength}}):_vm._e(),_vm._v(" "),(_vm.mergedConfig.showValue)?_c('text',{style:(("fontSize:" + (_vm.mergedConfig.fontSize) + "px")),attrs:{"fill":_vm.mergedConfig.textColor,"x":item.x,"y":item.textY}},[_vm._v("\n        "+_vm._s(item.value)+"\n      ")]):_vm._e()])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var conicalColumnChart_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/conicalColumnChart/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  conicalColumnChart_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_conicalColumnChart_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "00cv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "11IE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "17FL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1BEG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration1/src/main.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvDecoration1',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var pointSideLength = 2.5;

    return {
      ref: 'decoration-1',

      svgWH: [200, 50],

      svgScale: [1, 1],

      rowNum: 4,
      rowPoints: 20,

      pointSideLength: pointSideLength,
      halfPointSideLength: pointSideLength / 2,

      points: [],

      rects: [],

      defaultColor: ['#fff', '#0de7c2'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    calcSVGData: function calcSVGData() {
      var calcPointsPosition = this.calcPointsPosition,
          calcRectsPosition = this.calcRectsPosition,
          calcScale = this.calcScale;


      calcPointsPosition();

      calcRectsPosition();

      calcScale();
    },
    calcPointsPosition: function calcPointsPosition() {
      var svgWH = this.svgWH,
          rowNum = this.rowNum,
          rowPoints = this.rowPoints;

      var _svgWH = slicedToArray_default()(svgWH, 2),
          w = _svgWH[0],
          h = _svgWH[1];

      var horizontalGap = w / (rowPoints + 1);
      var verticalGap = h / (rowNum + 1);

      var points = new Array(rowNum).fill(0).map(function (foo, i) {
        return new Array(rowPoints).fill(0).map(function (foo, j) {
          return [horizontalGap * (j + 1), verticalGap * (i + 1)];
        });
      });

      this.points = points.reduce(function (all, item) {
        return [].concat(toConsumableArray_default()(all), toConsumableArray_default()(item));
      }, []);
    },
    calcRectsPosition: function calcRectsPosition() {
      var points = this.points,
          rowPoints = this.rowPoints;


      var rect1 = points[rowPoints * 2 - 1];
      var rect2 = points[rowPoints * 2 - 3];

      this.rects = [rect1, rect2];
    },
    calcScale: function calcScale() {
      var width = this.width,
          height = this.height,
          svgWH = this.svgWH;

      var _svgWH2 = slicedToArray_default()(svgWH, 2),
          w = _svgWH2[0],
          h = _svgWH2[1];

      this.svgScale = [width / w, height / h];
    },
    onResize: function onResize() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration1/src/main.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvDecoration1',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var pointSideLength = 2.5;

    return {
      ref: 'decoration-1',

      svgWH: [200, 50],

      svgScale: [1, 1],

      rowNum: 4,
      rowPoints: 20,

      pointSideLength: pointSideLength,
      halfPointSideLength: pointSideLength / 2,

      points: [],

      rects: [],

      defaultColor: ['#fff', '#0de7c2'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    calcSVGData: function calcSVGData() {
      var calcPointsPosition = this.calcPointsPosition,
          calcRectsPosition = this.calcRectsPosition,
          calcScale = this.calcScale;


      calcPointsPosition();

      calcRectsPosition();

      calcScale();
    },
    calcPointsPosition: function calcPointsPosition() {
      var svgWH = this.svgWH,
          rowNum = this.rowNum,
          rowPoints = this.rowPoints;

      var _svgWH = slicedToArray_default()(svgWH, 2),
          w = _svgWH[0],
          h = _svgWH[1];

      var horizontalGap = w / (rowPoints + 1);
      var verticalGap = h / (rowNum + 1);

      var points = new Array(rowNum).fill(0).map(function (foo, i) {
        return new Array(rowPoints).fill(0).map(function (foo, j) {
          return [horizontalGap * (j + 1), verticalGap * (i + 1)];
        });
      });

      this.points = points.reduce(function (all, item) {
        return [].concat(toConsumableArray_default()(all), toConsumableArray_default()(item));
      }, []);
    },
    calcRectsPosition: function calcRectsPosition() {
      var points = this.points,
          rowPoints = this.rowPoints;


      var rect1 = points[rowPoints * 2 - 1];
      var rect2 = points[rowPoints * 2 - 3];

      this.rects = [rect1, rect2];
    },
    calcScale: function calcScale() {
      var width = this.width,
          height = this.height,
          svgWH = this.svgWH;

      var _svgWH2 = slicedToArray_default()(svgWH, 2),
          w = _svgWH2[0],
          h = _svgWH2[1];

      this.svgScale = [width / w, height / h];
    },
    onResize: function onResize() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-295bc631","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration1/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-decoration-1"},[_c('svg',{style:(("transform:scale(" + (_vm.svgScale[0]) + "," + (_vm.svgScale[1]) + ");")),attrs:{"width":((_vm.svgWH[0]) + "px"),"height":((_vm.svgWH[1]) + "px")}},[_vm._l((_vm.points),function(point,i){return [(Math.random() > 0.6)?_c('rect',{key:i,attrs:{"fill":_vm.mergedColor[0],"x":point[0] - _vm.halfPointSideLength,"y":point[1] - _vm.halfPointSideLength,"width":_vm.pointSideLength,"height":_vm.pointSideLength}},[(Math.random() > 0.6)?_c('animate',{attrs:{"attributeName":"fill","values":((_vm.mergedColor[0]) + ";transparent"),"dur":"1s","begin":Math.random() * 2,"repeatCount":"indefinite"}}):_vm._e()]):_vm._e()]}),_vm._v(" "),(_vm.rects[0])?_c('rect',{attrs:{"fill":_vm.mergedColor[1],"x":_vm.rects[0][0] - _vm.pointSideLength,"y":_vm.rects[0][1] - _vm.pointSideLength,"width":_vm.pointSideLength * 2,"height":_vm.pointSideLength * 2}},[_c('animate',{attrs:{"attributeName":"width","values":("0;" + (_vm.pointSideLength * 2)),"dur":"2s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"height","values":("0;" + (_vm.pointSideLength * 2)),"dur":"2s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"x","values":((_vm.rects[0][0]) + ";" + (_vm.rects[0][0] - _vm.pointSideLength)),"dur":"2s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"y","values":((_vm.rects[0][1]) + ";" + (_vm.rects[0][1] - _vm.pointSideLength)),"dur":"2s","repeatCount":"indefinite"}})]):_vm._e(),_vm._v(" "),(_vm.rects[1])?_c('rect',{attrs:{"fill":_vm.mergedColor[1],"x":_vm.rects[1][0] - 40,"y":_vm.rects[1][1] - _vm.pointSideLength,"width":40,"height":_vm.pointSideLength * 2}},[_c('animate',{attrs:{"attributeName":"width","values":"0;40;0","dur":"2s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"x","values":((_vm.rects[1][0]) + ";" + (_vm.rects[1][0] - 40) + ";" + (_vm.rects[1][0])),"dur":"2s","repeatCount":"indefinite"}})]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var decoration1_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/decoration1/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  decoration1_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_decoration1_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "46Ky":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/fullScreenContainer/src/main.vue
//
//
//
//
//
//
//
//



/* harmony default export */ var main = ({
  name: 'DvFullScreenContainer',
  mixins: [autoResize_default.a],
  data: function data() {
    return {
      ref: 'full-screen-container',
      allWidth: 0,
      scale: 0,
      datavRoot: '',
      ready: false
    };
  },

  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var initConfig = this.initConfig,
          setAppScale = this.setAppScale;


      initConfig();

      setAppScale();

      this.ready = true;
    },
    initConfig: function initConfig() {
      var dom = this.dom;
      var _screen = screen,
          width = _screen.width,
          height = _screen.height;


      this.allWidth = width;

      dom.style.width = width + 'px';
      dom.style.height = height + 'px';
    },
    setAppScale: function setAppScale() {
      var allWidth = this.allWidth,
          dom = this.dom;


      var currentWidth = document.body.clientWidth;

      dom.style.transform = 'scale(' + currentWidth / allWidth + ')';
    },
    onResize: function onResize() {
      var setAppScale = this.setAppScale;


      setAppScale();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/fullScreenContainer/src/main.vue
//
//
//
//
//
//
//
//



/* harmony default export */ var src_main = ({
  name: 'DvFullScreenContainer',
  mixins: [autoResize_default.a],
  data: function data() {
    return {
      ref: 'full-screen-container',
      allWidth: 0,
      scale: 0,
      datavRoot: '',
      ready: false
    };
  },

  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var initConfig = this.initConfig,
          setAppScale = this.setAppScale;


      initConfig();

      setAppScale();

      this.ready = true;
    },
    initConfig: function initConfig() {
      var dom = this.dom;
      var _screen = screen,
          width = _screen.width,
          height = _screen.height;


      this.allWidth = width;

      dom.style.width = width + 'px';
      dom.style.height = height + 'px';
    },
    setAppScale: function setAppScale() {
      var allWidth = this.allWidth,
          dom = this.dom;


      var currentWidth = document.body.clientWidth;

      dom.style.transform = 'scale(' + currentWidth / allWidth + ')';
    },
    onResize: function onResize() {
      var setAppScale = this.setAppScale;


      setAppScale();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe03f55e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/fullScreenContainer/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,attrs:{"id":"dv-full-screen-container"}},[(_vm.ready)?[_vm._t("default")]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var fullScreenContainer_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/fullScreenContainer/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  fullScreenContainer_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_fullScreenContainer_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4LX4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5NCg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5iwl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// JavaScript Document
(function (doc, win) {
  var docEl = doc.documentElement,
      resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
      recalc = function recalc() {
    var clientWidth = docEl.clientWidth; //获取设备尺寸
    var shejiWidth = 375; //设计稿的宽度
    if (clientWidth < 600) {
      docEl.style.fontSize = 100 * (clientWidth / shejiWidth) + 'px';
    };
  };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false); //绑定事件
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);

/***/ }),

/***/ "5o8e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox2/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvBorderBox2',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-2',

      defaultColor: ['#fff', 'rgba(255, 255, 255, 0.6)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox2/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvBorderBox2',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-2',

      defaultColor: ['#fff', 'rgba(255, 255, 255, 0.6)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ed8b580","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox2/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-border-box-2"},[_c('svg',{staticClass:"dv-border-svg-container",attrs:{"width":_vm.width,"height":_vm.height}},[_c('polygon',{attrs:{"fill":_vm.backgroundColor,"points":("\n      7, 7 " + (_vm.width - 7) + ", 7 " + (_vm.width - 7) + ", " + (_vm.height - 7) + " 7, " + (_vm.height - 7) + "\n    ")}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"points":("2, 2 " + (_vm.width - 2) + " ,2 " + (_vm.width - 2) + ", " + (_vm.height - 2) + " 2, " + (_vm.height - 2) + " 2, 2")}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[1],"points":("6, 6 " + (_vm.width - 6) + ", 6 " + (_vm.width - 6) + ", " + (_vm.height - 6) + " 6, " + (_vm.height - 6) + " 6, 6")}}),_vm._v(" "),_c('circle',{attrs:{"fill":_vm.mergedColor[0],"cx":"11","cy":"11","r":"1"}}),_vm._v(" "),_c('circle',{attrs:{"fill":_vm.mergedColor[0],"cx":_vm.width - 11,"cy":"11","r":"1"}}),_vm._v(" "),_c('circle',{attrs:{"fill":_vm.mergedColor[0],"cx":_vm.width - 11,"cy":_vm.height - 11,"r":"1"}}),_vm._v(" "),_c('circle',{attrs:{"fill":_vm.mergedColor[0],"cx":"11","cy":_vm.height - 11,"r":"1"}})]),_vm._v(" "),_c('div',{staticClass:"border-box-content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var borderBox2_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/borderBox2/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  borderBox2_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_borderBox2_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "80xR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/util/index.js
var util = __webpack_require__("3e7c");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var lib_util = __webpack_require__("9A4f");
var lib_util_default = /*#__PURE__*/__webpack_require__.n(lib_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox8/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var main = ({
  name: 'DvBorderBox8',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dur: {
      type: Number,
      default: 3
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      ref: 'border-box-8',
      path: 'border-box-8-path-' + id,
      gradient: 'border-box-8-gradient-' + id,
      mask: 'border-box-8-mask-' + id,

      defaultColor: ['#235fa7', '#4fd2dd'],

      mergedColor: []
    };
  },

  computed: {
    length: function length() {
      var width = this.width,
          height = this.height;


      return (width + height - 5) * 2;
    },
    pathD: function pathD() {
      var reverse = this.reverse,
          width = this.width,
          height = this.height;


      if (reverse) return 'M 2.5, 2.5 L 2.5, ' + (height - 2.5) + ' L ' + (width - 2.5) + ', ' + (height - 2.5) + ' L ' + (width - 2.5) + ', 2.5 L 2.5, 2.5';

      return 'M2.5, 2.5 L' + (width - 2.5) + ', 2.5 L' + (width - 2.5) + ', ' + (height - 2.5) + ' L2.5, ' + (height - 2.5) + ' L2.5, 2.5';
    }
  },
  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox8/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var src_main = ({
  name: 'DvBorderBox8',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dur: {
      type: Number,
      default: 3
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      ref: 'border-box-8',
      path: 'border-box-8-path-' + id,
      gradient: 'border-box-8-gradient-' + id,
      mask: 'border-box-8-mask-' + id,

      defaultColor: ['#235fa7', '#4fd2dd'],

      mergedColor: []
    };
  },

  computed: {
    length: function length() {
      var width = this.width,
          height = this.height;


      return (width + height - 5) * 2;
    },
    pathD: function pathD() {
      var reverse = this.reverse,
          width = this.width,
          height = this.height;


      if (reverse) return 'M 2.5, 2.5 L 2.5, ' + (height - 2.5) + ' L ' + (width - 2.5) + ', ' + (height - 2.5) + ' L ' + (width - 2.5) + ', 2.5 L 2.5, 2.5';

      return 'M2.5, 2.5 L' + (width - 2.5) + ', 2.5 L' + (width - 2.5) + ', ' + (height - 2.5) + ' L2.5, ' + (height - 2.5) + ' L2.5, 2.5';
    }
  },
  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-667924e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox8/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-border-box-8"},[_c('svg',{staticClass:"dv-border-svg-container",attrs:{"width":_vm.width,"height":_vm.height}},[_c('defs',[_c('path',{attrs:{"id":_vm.path,"d":_vm.pathD,"fill":"transparent"}}),_vm._v(" "),_c('radialGradient',{attrs:{"id":_vm.gradient,"cx":"50%","cy":"50%","r":"50%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#fff","stop-opacity":"1"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#fff","stop-opacity":"0"}})],1),_vm._v(" "),_c('mask',{attrs:{"id":_vm.mask}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":"150","fill":("url(#" + _vm.gradient + ")")}},[_c('animateMotion',{attrs:{"dur":(_vm.dur + "s"),"path":_vm.pathD,"rotate":"auto","repeatCount":"indefinite"}})],1)])],1),_vm._v(" "),_c('polygon',{attrs:{"fill":_vm.backgroundColor,"points":("5, 5 " + (_vm.width - 5) + ", 5 " + (_vm.width - 5) + " " + (_vm.height - 5) + " 5, " + (_vm.height - 5))}}),_vm._v(" "),_c('use',{attrs:{"stroke":_vm.mergedColor[0],"stroke-width":"1","xlink:href":("#" + _vm.path)}}),_vm._v(" "),_c('use',{attrs:{"stroke":_vm.mergedColor[1],"stroke-width":"3","xlink:href":("#" + _vm.path),"mask":("url(#" + _vm.mask + ")")}},[_c('animate',{attrs:{"attributeName":"stroke-dasharray","from":("0, " + _vm.length),"to":(_vm.length + ", 0"),"dur":(_vm.dur + "s"),"repeatCount":"indefinite"}})])]),_vm._v(" "),_c('div',{staticClass:"border-box-content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var borderBox8_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/borderBox8/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  borderBox8_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_borderBox8_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8epE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8slu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration8/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvDecoration8',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      ref: 'decoration-8',

      defaultColor: ['#3f96a5', '#3f96a5'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    xPos: function xPos(pos) {
      var reverse = this.reverse,
          width = this.width;


      if (!reverse) return pos;

      return width - pos;
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration8/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvDecoration8',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      ref: 'decoration-8',

      defaultColor: ['#3f96a5', '#3f96a5'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    xPos: function xPos(pos) {
      var reverse = this.reverse,
          width = this.width;


      if (!reverse) return pos;

      return width - pos;
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8cf9c33e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration8/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-decoration-8"},[_c('svg',{attrs:{"width":_vm.width,"height":_vm.height}},[_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"stroke-width":"2","fill":"transparent","points":((_vm.xPos(0)) + ", 0 " + (_vm.xPos(30)) + ", " + (_vm.height / 2))}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"stroke-width":"2","fill":"transparent","points":((_vm.xPos(20)) + ", 0 " + (_vm.xPos(50)) + ", " + (_vm.height / 2) + " " + (_vm.xPos(_vm.width)) + ", " + (_vm.height / 2))}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[1],"fill":"transparent","stroke-width":"3","points":((_vm.xPos(0)) + ", " + (_vm.height - 3) + ", " + (_vm.xPos(200)) + ", " + (_vm.height - 3))}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var decoration8_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/decoration8/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  decoration8_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_decoration8_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "977A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Eed":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BNBy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox13/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvBorderBox13',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-13',

      defaultColor: ['#6586ec', '#2cf7fe'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox13/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvBorderBox13',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-13',

      defaultColor: ['#6586ec', '#2cf7fe'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-886c55d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox13/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-border-box-13"},[_c('svg',{staticClass:"dv-border-svg-container",attrs:{"width":_vm.width,"height":_vm.height}},[_c('path',{attrs:{"fill":_vm.backgroundColor,"stroke":_vm.mergedColor[0],"d":("\n        M 5 20 L 5 10 L 12 3  L 60 3 L 68 10\n        L " + (_vm.width - 20) + " 10 L " + (_vm.width - 5) + " 25\n        L " + (_vm.width - 5) + " " + (_vm.height - 5) + " L 20 " + (_vm.height - 5) + "\n        L 5 " + (_vm.height - 20) + " L 5 20\n      ")}}),_vm._v(" "),_c('path',{attrs:{"fill":"transparent","stroke-width":"3","stroke-linecap":"round","stroke-dasharray":"10, 5","stroke":_vm.mergedColor[0],"d":"M 16 9 L 61 9"}}),_vm._v(" "),_c('path',{attrs:{"fill":"transparent","stroke":_vm.mergedColor[1],"d":"M 5 20 L 5 10 L 12 3  L 60 3 L 68 10"}}),_vm._v(" "),_c('path',{attrs:{"fill":"transparent","stroke":_vm.mergedColor[1],"d":("M " + (_vm.width - 5) + " " + (_vm.height - 30) + " L " + (_vm.width - 5) + " " + (_vm.height - 5) + " L " + (_vm.width - 30) + " " + (_vm.height - 5))}})]),_vm._v(" "),_c('div',{staticClass:"border-box-content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var borderBox13_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/borderBox13/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  borderBox13_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_borderBox13_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a79aa162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("00cv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BvmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration5/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var main = ({
  name: 'DvDecoration5',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dur: {
      type: Number,
      default: 1.2
    }
  },
  data: function data() {
    return {
      ref: 'decoration-5',

      line1Points: '',
      line2Points: '',

      line1Length: 0,
      line2Length: 0,

      defaultColor: ['#3f96a5', '#3f96a5'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    calcSVGData: function calcSVGData() {
      var width = this.width,
          height = this.height;


      var line1Points = [[0, height * 0.2], [width * 0.18, height * 0.2], [width * 0.2, height * 0.4], [width * 0.25, height * 0.4], [width * 0.27, height * 0.6], [width * 0.72, height * 0.6], [width * 0.75, height * 0.4], [width * 0.8, height * 0.4], [width * 0.82, height * 0.2], [width, height * 0.2]];

      var line2Points = [[width * 0.3, height * 0.8], [width * 0.7, height * 0.8]];

      var line1Length = Object(util["getPolylineLength"])(line1Points);
      var line2Length = Object(util["getPolylineLength"])(line2Points);

      line1Points = line1Points.map(function (point) {
        return point.join(',');
      }).join(' ');
      line2Points = line2Points.map(function (point) {
        return point.join(',');
      }).join(' ');

      this.line1Points = line1Points;
      this.line2Points = line2Points;

      this.line1Length = line1Length;
      this.line2Length = line2Length;
    },
    onResize: function onResize() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration5/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var src_main = ({
  name: 'DvDecoration5',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dur: {
      type: Number,
      default: 1.2
    }
  },
  data: function data() {
    return {
      ref: 'decoration-5',

      line1Points: '',
      line2Points: '',

      line1Length: 0,
      line2Length: 0,

      defaultColor: ['#3f96a5', '#3f96a5'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    calcSVGData: function calcSVGData() {
      var width = this.width,
          height = this.height;


      var line1Points = [[0, height * 0.2], [width * 0.18, height * 0.2], [width * 0.2, height * 0.4], [width * 0.25, height * 0.4], [width * 0.27, height * 0.6], [width * 0.72, height * 0.6], [width * 0.75, height * 0.4], [width * 0.8, height * 0.4], [width * 0.82, height * 0.2], [width, height * 0.2]];

      var line2Points = [[width * 0.3, height * 0.8], [width * 0.7, height * 0.8]];

      var line1Length = Object(util["getPolylineLength"])(line1Points);
      var line2Length = Object(util["getPolylineLength"])(line2Points);

      line1Points = line1Points.map(function (point) {
        return point.join(',');
      }).join(' ');
      line2Points = line2Points.map(function (point) {
        return point.join(',');
      }).join(' ');

      this.line1Points = line1Points;
      this.line2Points = line2Points;

      this.line1Length = line1Length;
      this.line2Length = line2Length;
    },
    onResize: function onResize() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-791c9101","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration5/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-decoration-5"},[_c('svg',{attrs:{"width":_vm.width,"height":_vm.height}},[_c('polyline',{attrs:{"fill":"transparent","stroke":_vm.mergedColor[0],"stroke-width":"3","points":_vm.line1Points}},[_c('animate',{attrs:{"attributeName":"stroke-dasharray","attributeType":"XML","from":("0, " + (_vm.line1Length / 2) + ", 0, " + (_vm.line1Length / 2)),"to":("0, 0, " + _vm.line1Length + ", 0"),"dur":(_vm.dur + "s"),"begin":"0s","calcMode":"spline","keyTimes":"0;1","keySplines":"0.4,1,0.49,0.98","repeatCount":"indefinite"}})]),_vm._v(" "),_c('polyline',{attrs:{"fill":"transparent","stroke":_vm.mergedColor[1],"stroke-width":"2","points":_vm.line2Points}},[_c('animate',{attrs:{"attributeName":"stroke-dasharray","attributeType":"XML","from":("0, " + (_vm.line2Length / 2) + ", 0, " + (_vm.line2Length / 2)),"to":("0, 0, " + _vm.line2Length + ", 0"),"dur":(_vm.dur + "s"),"begin":"0s","calcMode":"spline","keyTimes":"0;1","keySplines":".4,1,.49,.98","repeatCount":"indefinite"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var decoration5_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/decoration5/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  decoration5_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_decoration5_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Bwl3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BySr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/scrollBoard/src/main.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvScrollBoard',
  mixins: [autoResize_default.a],
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      ref: 'scroll-board',

      defaultConfig: {
        /**
         * @description Board header
         * @type {Array<String>}
         * @default header = []
         * @example header = ['column1', 'column2', 'column3']
         */
        header: [],
        /**
         * @description Board data
         * @type {Array<Array>}
         * @default data = []
         */
        data: [],
        /**
         * @description Row num
         * @type {Number}
         * @default rowNum = 5
         */
        rowNum: 5,
        /**
         * @description Header background color
         * @type {String}
         * @default headerBGC = '#00BAFF'
         */
        headerBGC: '#00BAFF',
        /**
         * @description Odd row background color
         * @type {String}
         * @default oddRowBGC = '#003B51'
         */
        oddRowBGC: '#003B51',
        /**
         * @description Even row background color
         * @type {String}
         * @default evenRowBGC = '#003B51'
         */
        evenRowBGC: '#0A2732',
        /**
         * @description Scroll wait time
         * @type {Number}
         * @default waitTime = 2000
         */
        waitTime: 2000,
        /**
         * @description Header height
         * @type {Number}
         * @default headerHeight = 35
         */
        headerHeight: 35,
        /**
         * @description Column width
         * @type {Array<Number>}
         * @default columnWidth = []
         */
        columnWidth: [],
        /**
         * @description Column align
         * @type {Array<String>}
         * @default align = []
         * @example align = ['left', 'center', 'right']
         */
        align: [],
        /**
         * @description Show index
         * @type {Boolean}
         * @default index = false
         */
        index: false,
        /**
         * @description index Header
         * @type {String}
         * @default indexHeader = '#'
         */
        indexHeader: '#',
        /**
         * @description Carousel type
         * @type {String}
         * @default carousel = 'single'
         * @example carousel = 'single' | 'page'
         */
        carousel: 'single',
        /**
         * @description Pause scroll when mouse hovered
         * @type {Boolean}
         * @default hoverPause = true
         * @example hoverPause = true | false
         */
        hoverPause: true
      },

      mergedConfig: null,

      header: [],

      rowsData: [],

      rows: [],

      widths: [],

      heights: [],

      avgHeight: 0,

      aligns: [],

      animationIndex: 0,

      animationHandler: '',

      updater: 0,

      needCalc: false
    };
  },

  watch: {
    config: function config() {
      var stopAnimation = this.stopAnimation,
          calcData = this.calcData;


      stopAnimation();

      this.animationIndex = 0;

      calcData();
    }
  },
  methods: {
    handleHover: function handleHover(enter, ri, ci, row, ceil) {
      var mergedConfig = this.mergedConfig,
          emitEvent = this.emitEvent,
          stopAnimation = this.stopAnimation,
          animation = this.animation;


      if (enter) emitEvent('mouseover', ri, ci, row, ceil);
      if (!mergedConfig.hoverPause) return;

      if (enter) {
        stopAnimation();
      } else {
        animation(true);
      }
    },
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcData = this.calcData;


      calcData();
    },
    onResize: function onResize() {
      var mergedConfig = this.mergedConfig,
          calcWidths = this.calcWidths,
          calcHeights = this.calcHeights;


      if (!mergedConfig) return;

      calcWidths();

      calcHeights();
    },
    calcData: function calcData() {
      var mergeConfig = this.mergeConfig,
          calcHeaderData = this.calcHeaderData,
          calcRowsData = this.calcRowsData;


      mergeConfig();

      calcHeaderData();

      calcRowsData();

      var calcWidths = this.calcWidths,
          calcHeights = this.calcHeights,
          calcAligns = this.calcAligns;


      calcWidths();

      calcHeights();

      calcAligns();

      var animation = this.animation;


      animation(true);
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      this.mergedConfig = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config || {});
    },
    calcHeaderData: function calcHeaderData() {
      var _mergedConfig = this.mergedConfig,
          header = _mergedConfig.header,
          index = _mergedConfig.index,
          indexHeader = _mergedConfig.indexHeader;


      if (!header.length) {
        this.header = [];

        return;
      }

      header = [].concat(toConsumableArray_default()(header));

      if (index) header.unshift(indexHeader);

      this.header = header;
    },
    calcRowsData: function calcRowsData() {
      var _mergedConfig2 = this.mergedConfig,
          data = _mergedConfig2.data,
          index = _mergedConfig2.index,
          headerBGC = _mergedConfig2.headerBGC,
          rowNum = _mergedConfig2.rowNum;


      if (index) {
        data = data.map(function (row, i) {
          row = [].concat(toConsumableArray_default()(row));

          var indexTag = '<span class="index" style="background-color: ' + headerBGC + ';">' + (i + 1) + '</span>';

          row.unshift(indexTag);

          return row;
        });
      }

      data = data.map(function (ceils, i) {
        return { ceils: ceils, rowIndex: i };
      });

      var rowLength = data.length;

      if (rowLength > rowNum && rowLength < 2 * rowNum) {
        data = [].concat(toConsumableArray_default()(data), toConsumableArray_default()(data));
      }

      data = data.map(function (d, i) {
        return extends_default()({}, d, { scroll: i });
      });

      this.rowsData = data;
      this.rows = data;
    },
    calcWidths: function calcWidths() {
      var width = this.width,
          mergedConfig = this.mergedConfig,
          rowsData = this.rowsData;
      var columnWidth = mergedConfig.columnWidth,
          header = mergedConfig.header;


      var usedWidth = columnWidth.reduce(function (all, w) {
        return all + w;
      }, 0);

      var columnNum = 0;
      if (rowsData[0]) {
        columnNum = rowsData[0].ceils.length;
      } else if (header.length) {
        columnNum = header.length;
      }

      var avgWidth = (width - usedWidth) / (columnNum - columnWidth.length);

      var widths = new Array(columnNum).fill(avgWidth);

      this.widths = Object(util["deepMerge"])(widths, columnWidth);
    },
    calcHeights: function calcHeights() {
      var onresize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var height = this.height,
          mergedConfig = this.mergedConfig,
          header = this.header;
      var headerHeight = mergedConfig.headerHeight,
          rowNum = mergedConfig.rowNum,
          data = mergedConfig.data;


      var allHeight = height;

      if (header.length) allHeight -= headerHeight;

      var avgHeight = allHeight / rowNum;

      this.avgHeight = avgHeight;

      if (!onresize) this.heights = new Array(data.length).fill(avgHeight);
    },
    calcAligns: function calcAligns() {
      var header = this.header,
          mergedConfig = this.mergedConfig;


      var columnNum = header.length;

      var aligns = new Array(columnNum).fill('left');

      var align = mergedConfig.align;


      this.aligns = Object(util["deepMerge"])(aligns, align);
    },
    animation: function animation() {
      var _this = this;

      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _heights;

        var needCalc, calcHeights, calcRowsData, avgHeight, animationIndex, mergedConfig, rowsData, animation, updater, waitTime, carousel, rowNum, rowLength, animationNum, rows, back;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                needCalc = _this.needCalc, calcHeights = _this.calcHeights, calcRowsData = _this.calcRowsData;


                if (needCalc) {
                  calcRowsData();
                  calcHeights();
                  _this.needCalc = false;
                }

                avgHeight = _this.avgHeight, animationIndex = _this.animationIndex, mergedConfig = _this.mergedConfig, rowsData = _this.rowsData, animation = _this.animation, updater = _this.updater;
                waitTime = mergedConfig.waitTime, carousel = mergedConfig.carousel, rowNum = mergedConfig.rowNum;
                rowLength = rowsData.length;

                if (!(rowNum >= rowLength)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return');

              case 7:
                if (!start) {
                  _context.next = 12;
                  break;
                }

                _context.next = 10;
                return new promise_default.a(function (resolve) {
                  return setTimeout(resolve, waitTime);
                });

              case 10:
                if (!(updater !== _this.updater)) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt('return');

              case 12:
                animationNum = carousel === 'single' ? 1 : rowNum;
                rows = rowsData.slice(animationIndex);

                rows.push.apply(rows, toConsumableArray_default()(rowsData.slice(0, animationIndex)));

                _this.rows = rows.slice(0, carousel === 'page' ? rowNum * 2 : rowNum + 1);
                _this.heights = new Array(rowLength).fill(avgHeight);

                _context.next = 19;
                return new promise_default.a(function (resolve) {
                  return setTimeout(resolve, 300);
                });

              case 19:
                if (!(updater !== _this.updater)) {
                  _context.next = 21;
                  break;
                }

                return _context.abrupt('return');

              case 21:

                (_heights = _this.heights).splice.apply(_heights, [0, animationNum].concat(toConsumableArray_default()(new Array(animationNum).fill(0))));

                animationIndex += animationNum;

                back = animationIndex - rowLength;

                if (back >= 0) animationIndex = back;

                _this.animationIndex = animationIndex;
                _this.animationHandler = setTimeout(animation, waitTime - 300);

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    stopAnimation: function stopAnimation() {
      var animationHandler = this.animationHandler,
          updater = this.updater;


      this.updater = (updater + 1) % 999999;

      if (!animationHandler) return;

      clearTimeout(animationHandler);
    },
    emitEvent: function emitEvent(type, ri, ci, row, ceil) {
      var ceils = row.ceils,
          rowIndex = row.rowIndex;


      this.$emit(type, {
        row: ceils,
        ceil: ceil,
        rowIndex: rowIndex,
        columnIndex: ci
      });
    },
    updateRows: function updateRows(rows, animationIndex) {
      var mergedConfig = this.mergedConfig,
          animationHandler = this.animationHandler,
          animation = this.animation;


      this.mergedConfig = extends_default()({}, mergedConfig, {
        data: [].concat(toConsumableArray_default()(rows))
      });

      this.needCalc = true;

      if (typeof animationIndex === 'number') this.animationIndex = animationIndex;
      if (!animationHandler) animation(true);
    }
  },
  destroyed: function destroyed() {
    var stopAnimation = this.stopAnimation;


    stopAnimation();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/scrollBoard/src/main.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvScrollBoard',
  mixins: [autoResize_default.a],
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      ref: 'scroll-board',

      defaultConfig: {
        /**
         * @description Board header
         * @type {Array<String>}
         * @default header = []
         * @example header = ['column1', 'column2', 'column3']
         */
        header: [],
        /**
         * @description Board data
         * @type {Array<Array>}
         * @default data = []
         */
        data: [],
        /**
         * @description Row num
         * @type {Number}
         * @default rowNum = 5
         */
        rowNum: 5,
        /**
         * @description Header background color
         * @type {String}
         * @default headerBGC = '#00BAFF'
         */
        headerBGC: '#00BAFF',
        /**
         * @description Odd row background color
         * @type {String}
         * @default oddRowBGC = '#003B51'
         */
        oddRowBGC: '#003B51',
        /**
         * @description Even row background color
         * @type {String}
         * @default evenRowBGC = '#003B51'
         */
        evenRowBGC: '#0A2732',
        /**
         * @description Scroll wait time
         * @type {Number}
         * @default waitTime = 2000
         */
        waitTime: 2000,
        /**
         * @description Header height
         * @type {Number}
         * @default headerHeight = 35
         */
        headerHeight: 35,
        /**
         * @description Column width
         * @type {Array<Number>}
         * @default columnWidth = []
         */
        columnWidth: [],
        /**
         * @description Column align
         * @type {Array<String>}
         * @default align = []
         * @example align = ['left', 'center', 'right']
         */
        align: [],
        /**
         * @description Show index
         * @type {Boolean}
         * @default index = false
         */
        index: false,
        /**
         * @description index Header
         * @type {String}
         * @default indexHeader = '#'
         */
        indexHeader: '#',
        /**
         * @description Carousel type
         * @type {String}
         * @default carousel = 'single'
         * @example carousel = 'single' | 'page'
         */
        carousel: 'single',
        /**
         * @description Pause scroll when mouse hovered
         * @type {Boolean}
         * @default hoverPause = true
         * @example hoverPause = true | false
         */
        hoverPause: true
      },

      mergedConfig: null,

      header: [],

      rowsData: [],

      rows: [],

      widths: [],

      heights: [],

      avgHeight: 0,

      aligns: [],

      animationIndex: 0,

      animationHandler: '',

      updater: 0,

      needCalc: false
    };
  },

  watch: {
    config: function config() {
      var stopAnimation = this.stopAnimation,
          calcData = this.calcData;


      stopAnimation();

      this.animationIndex = 0;

      calcData();
    }
  },
  methods: {
    handleHover: function handleHover(enter, ri, ci, row, ceil) {
      var mergedConfig = this.mergedConfig,
          emitEvent = this.emitEvent,
          stopAnimation = this.stopAnimation,
          animation = this.animation;


      if (enter) emitEvent('mouseover', ri, ci, row, ceil);
      if (!mergedConfig.hoverPause) return;

      if (enter) {
        stopAnimation();
      } else {
        animation(true);
      }
    },
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcData = this.calcData;


      calcData();
    },
    onResize: function onResize() {
      var mergedConfig = this.mergedConfig,
          calcWidths = this.calcWidths,
          calcHeights = this.calcHeights;


      if (!mergedConfig) return;

      calcWidths();

      calcHeights();
    },
    calcData: function calcData() {
      var mergeConfig = this.mergeConfig,
          calcHeaderData = this.calcHeaderData,
          calcRowsData = this.calcRowsData;


      mergeConfig();

      calcHeaderData();

      calcRowsData();

      var calcWidths = this.calcWidths,
          calcHeights = this.calcHeights,
          calcAligns = this.calcAligns;


      calcWidths();

      calcHeights();

      calcAligns();

      var animation = this.animation;


      animation(true);
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      this.mergedConfig = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config || {});
    },
    calcHeaderData: function calcHeaderData() {
      var _mergedConfig = this.mergedConfig,
          header = _mergedConfig.header,
          index = _mergedConfig.index,
          indexHeader = _mergedConfig.indexHeader;


      if (!header.length) {
        this.header = [];

        return;
      }

      header = [].concat(toConsumableArray_default()(header));

      if (index) header.unshift(indexHeader);

      this.header = header;
    },
    calcRowsData: function calcRowsData() {
      var _mergedConfig2 = this.mergedConfig,
          data = _mergedConfig2.data,
          index = _mergedConfig2.index,
          headerBGC = _mergedConfig2.headerBGC,
          rowNum = _mergedConfig2.rowNum;


      if (index) {
        data = data.map(function (row, i) {
          row = [].concat(toConsumableArray_default()(row));

          var indexTag = '<span class="index" style="background-color: ' + headerBGC + ';">' + (i + 1) + '</span>';

          row.unshift(indexTag);

          return row;
        });
      }

      data = data.map(function (ceils, i) {
        return { ceils: ceils, rowIndex: i };
      });

      var rowLength = data.length;

      if (rowLength > rowNum && rowLength < 2 * rowNum) {
        data = [].concat(toConsumableArray_default()(data), toConsumableArray_default()(data));
      }

      data = data.map(function (d, i) {
        return extends_default()({}, d, { scroll: i });
      });

      this.rowsData = data;
      this.rows = data;
    },
    calcWidths: function calcWidths() {
      var width = this.width,
          mergedConfig = this.mergedConfig,
          rowsData = this.rowsData;
      var columnWidth = mergedConfig.columnWidth,
          header = mergedConfig.header;


      var usedWidth = columnWidth.reduce(function (all, w) {
        return all + w;
      }, 0);

      var columnNum = 0;
      if (rowsData[0]) {
        columnNum = rowsData[0].ceils.length;
      } else if (header.length) {
        columnNum = header.length;
      }

      var avgWidth = (width - usedWidth) / (columnNum - columnWidth.length);

      var widths = new Array(columnNum).fill(avgWidth);

      this.widths = Object(util["deepMerge"])(widths, columnWidth);
    },
    calcHeights: function calcHeights() {
      var onresize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var height = this.height,
          mergedConfig = this.mergedConfig,
          header = this.header;
      var headerHeight = mergedConfig.headerHeight,
          rowNum = mergedConfig.rowNum,
          data = mergedConfig.data;


      var allHeight = height;

      if (header.length) allHeight -= headerHeight;

      var avgHeight = allHeight / rowNum;

      this.avgHeight = avgHeight;

      if (!onresize) this.heights = new Array(data.length).fill(avgHeight);
    },
    calcAligns: function calcAligns() {
      var header = this.header,
          mergedConfig = this.mergedConfig;


      var columnNum = header.length;

      var aligns = new Array(columnNum).fill('left');

      var align = mergedConfig.align;


      this.aligns = Object(util["deepMerge"])(aligns, align);
    },
    animation: function animation() {
      var _this = this;

      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _heights;

        var needCalc, calcHeights, calcRowsData, avgHeight, animationIndex, mergedConfig, rowsData, animation, updater, waitTime, carousel, rowNum, rowLength, animationNum, rows, back;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                needCalc = _this.needCalc, calcHeights = _this.calcHeights, calcRowsData = _this.calcRowsData;


                if (needCalc) {
                  calcRowsData();
                  calcHeights();
                  _this.needCalc = false;
                }

                avgHeight = _this.avgHeight, animationIndex = _this.animationIndex, mergedConfig = _this.mergedConfig, rowsData = _this.rowsData, animation = _this.animation, updater = _this.updater;
                waitTime = mergedConfig.waitTime, carousel = mergedConfig.carousel, rowNum = mergedConfig.rowNum;
                rowLength = rowsData.length;

                if (!(rowNum >= rowLength)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return');

              case 7:
                if (!start) {
                  _context.next = 12;
                  break;
                }

                _context.next = 10;
                return new promise_default.a(function (resolve) {
                  return setTimeout(resolve, waitTime);
                });

              case 10:
                if (!(updater !== _this.updater)) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt('return');

              case 12:
                animationNum = carousel === 'single' ? 1 : rowNum;
                rows = rowsData.slice(animationIndex);

                rows.push.apply(rows, toConsumableArray_default()(rowsData.slice(0, animationIndex)));

                _this.rows = rows.slice(0, carousel === 'page' ? rowNum * 2 : rowNum + 1);
                _this.heights = new Array(rowLength).fill(avgHeight);

                _context.next = 19;
                return new promise_default.a(function (resolve) {
                  return setTimeout(resolve, 300);
                });

              case 19:
                if (!(updater !== _this.updater)) {
                  _context.next = 21;
                  break;
                }

                return _context.abrupt('return');

              case 21:

                (_heights = _this.heights).splice.apply(_heights, [0, animationNum].concat(toConsumableArray_default()(new Array(animationNum).fill(0))));

                animationIndex += animationNum;

                back = animationIndex - rowLength;

                if (back >= 0) animationIndex = back;

                _this.animationIndex = animationIndex;
                _this.animationHandler = setTimeout(animation, waitTime - 300);

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    stopAnimation: function stopAnimation() {
      var animationHandler = this.animationHandler,
          updater = this.updater;


      this.updater = (updater + 1) % 999999;

      if (!animationHandler) return;

      clearTimeout(animationHandler);
    },
    emitEvent: function emitEvent(type, ri, ci, row, ceil) {
      var ceils = row.ceils,
          rowIndex = row.rowIndex;


      this.$emit(type, {
        row: ceils,
        ceil: ceil,
        rowIndex: rowIndex,
        columnIndex: ci
      });
    },
    updateRows: function updateRows(rows, animationIndex) {
      var mergedConfig = this.mergedConfig,
          animationHandler = this.animationHandler,
          animation = this.animation;


      this.mergedConfig = extends_default()({}, mergedConfig, {
        data: [].concat(toConsumableArray_default()(rows))
      });

      this.needCalc = true;

      if (typeof animationIndex === 'number') this.animationIndex = animationIndex;
      if (!animationHandler) animation(true);
    }
  },
  destroyed: function destroyed() {
    var stopAnimation = this.stopAnimation;


    stopAnimation();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c0d0428","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/scrollBoard/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-scroll-board"},[(_vm.header.length && _vm.mergedConfig)?_c('div',{staticClass:"header",style:(("background-color: " + (_vm.mergedConfig.headerBGC) + ";"))},_vm._l((_vm.header),function(headerItem,i){return _c('div',{key:("" + headerItem + i),staticClass:"header-item",style:(("\n        height: " + (_vm.mergedConfig.headerHeight) + "px;\n        line-height: " + (_vm.mergedConfig.headerHeight) + "px;\n        width: " + (_vm.widths[i]) + "px;\n      ")),attrs:{"align":_vm.aligns[i]},domProps:{"innerHTML":_vm._s(headerItem)}})}),0):_vm._e(),_vm._v(" "),(_vm.mergedConfig)?_c('div',{staticClass:"rows",style:(("height: " + (_vm.height - (_vm.header.length ? _vm.mergedConfig.headerHeight : 0)) + "px;"))},_vm._l((_vm.rows),function(row,ri){return _c('div',{key:("" + (row.toString()) + (row.scroll)),staticClass:"row-item",style:(("\n        height: " + (_vm.heights[ri]) + "px;\n        line-height: " + (_vm.heights[ri]) + "px;\n        background-color: " + (_vm.mergedConfig[row.rowIndex % 2 === 0 ? 'evenRowBGC' : 'oddRowBGC']) + ";\n      "))},_vm._l((row.ceils),function(ceil,ci){return _c('div',{key:("" + ceil + ri + ci),staticClass:"ceil",style:(("width: " + (_vm.widths[ci]) + "px;")),attrs:{"align":_vm.aligns[ci]},domProps:{"innerHTML":_vm._s(ceil)},on:{"click":function($event){return _vm.emitEvent('click', ri, ci, row, ceil)},"mouseenter":function($event){return _vm.handleHover(true, ri, ci, row, ceil)},"mouseleave":function($event){return _vm.handleHover(false)}}})}),0)}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var scrollBoard_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/scrollBoard/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  scrollBoard_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_scrollBoard_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DTqG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DgXS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox4/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvBorderBox4',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    reverse: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-4',

      defaultColor: ['red', 'rgba(0,0,255,0.8)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox4/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvBorderBox4',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    reverse: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-4',

      defaultColor: ['red', 'rgba(0,0,255,0.8)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5527428","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox4/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-border-box-4"},[_c('svg',{class:("dv-border-svg-container " + (_vm.reverse && 'dv-reverse')),attrs:{"width":_vm.width,"height":_vm.height}},[_c('polygon',{attrs:{"fill":_vm.backgroundColor,"points":("\n      " + (_vm.width - 15) + ", 22 170, 22 150, 7 40, 7 28, 21 32, 24\n      16, 42 16, " + (_vm.height - 32) + " 41, " + (_vm.height - 7) + " " + (_vm.width - 15) + ", " + (_vm.height - 7) + "\n    ")}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb4-line-1",attrs:{"stroke":_vm.mergedColor[0],"points":("145, " + (_vm.height - 5) + " 40, " + (_vm.height - 5) + " 10, " + (_vm.height - 35) + "\n        10, 40 40, 5 150, 5 170, 20 " + (_vm.width - 15) + ", 20")}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb4-line-2",attrs:{"stroke":_vm.mergedColor[1],"points":("245, " + (_vm.height - 1) + " 36, " + (_vm.height - 1) + " 14, " + (_vm.height - 23) + "\n        14, " + (_vm.height - 100))}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb4-line-3",attrs:{"stroke":_vm.mergedColor[0],"points":("7, " + (_vm.height - 40) + " 7, " + (_vm.height - 75))}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb4-line-4",attrs:{"stroke":_vm.mergedColor[0],"points":"28, 24 13, 41 13, 64"}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb4-line-5",attrs:{"stroke":_vm.mergedColor[0],"points":"5, 45 5, 140"}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb4-line-6",attrs:{"stroke":_vm.mergedColor[1],"points":"14, 75 14, 180"}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb4-line-7",attrs:{"stroke":_vm.mergedColor[1],"points":"55, 11 147, 11 167, 26 250, 26"}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb4-line-8",attrs:{"stroke":_vm.mergedColor[1],"points":"158, 5 173, 16"}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb4-line-9",attrs:{"stroke":_vm.mergedColor[0],"points":("200, 17 " + (_vm.width - 10) + ", 17")}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb4-line-10",attrs:{"stroke":_vm.mergedColor[1],"points":("385, 17 " + (_vm.width - 10) + ", 17")}})]),_vm._v(" "),_c('div',{staticClass:"border-box-content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var borderBox4_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/borderBox4/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  borderBox4_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_borderBox4_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F5G8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gh+6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HJfr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox10/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvBorderBox10',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-10',

      border: ['left-top', 'right-top', 'left-bottom', 'right-bottom'],

      defaultColor: ['#1d48c4', '#d3e1f8'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox10/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvBorderBox10',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-10',

      border: ['left-top', 'right-top', 'left-bottom', 'right-bottom'],

      defaultColor: ['#1d48c4', '#d3e1f8'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de1fc3cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox10/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-border-box-10",style:(("box-shadow: inset 0 0 25px 3px " + (_vm.mergedColor[0])))},[_c('svg',{staticClass:"dv-border-svg-container",attrs:{"width":_vm.width,"height":_vm.height}},[_c('polygon',{attrs:{"fill":_vm.backgroundColor,"points":("\n      4, 0 " + (_vm.width - 4) + ", 0 " + _vm.width + ", 4 " + _vm.width + ", " + (_vm.height - 4) + " " + (_vm.width - 4) + ", " + _vm.height + "\n      4, " + _vm.height + " 0, " + (_vm.height - 4) + " 0, 4\n    ")}})]),_vm._v(" "),_vm._l((_vm.border),function(item){return _c('svg',{key:item,class:(item + " dv-border-svg-container"),attrs:{"width":"150px","height":"150px"}},[_c('polygon',{attrs:{"fill":_vm.mergedColor[1],"points":"40, 0 5, 0 0, 5 0, 16 3, 19 3, 7 7, 3 35, 3"}})])}),_vm._v(" "),_c('div',{staticClass:"border-box-content"},[_vm._t("default")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var borderBox10_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/borderBox10/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  borderBox10_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_borderBox10_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HMS8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/util/index.js
var util = __webpack_require__("3e7c");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var lib_util = __webpack_require__("9A4f");
var lib_util_default = /*#__PURE__*/__webpack_require__.n(lib_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/percentPond/src/main.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvPercentPond',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      gradientId1: 'percent-pond-gradientId1-' + id,
      gradientId2: 'percent-pond-gradientId2-' + id,

      width: 0,
      height: 0,

      defaultConfig: {
        /**
         * @description Value
         * @type {Number}
         * @default value = 0
         */
        value: 0,
        /**
         * @description Colors (hex|rgb|rgba|color keywords)
         * @type {Array<String>}
         * @default colors = ['#00BAFF', '#3DE7C9']
         * @example colors = ['#000', 'rgb(0, 0, 0)', 'rgba(0, 0, 0, 1)', 'red']
         */
        colors: ['#3DE7C9', '#00BAFF'],
        /**
         * @description Border width
         * @type {Number}
         * @default borderWidth = 3
         */
        borderWidth: 3,
        /**
         * @description Gap between border and pond
         * @type {Number}
         * @default borderGap = 3
         */
        borderGap: 3,
        /**
         * @description Line dash
         * @type {Array<Number>}
         * @default lineDash = [5, 1]
         */
        lineDash: [5, 1],
        /**
         * @description Text color
         * @type {String}
         * @default textColor = '#fff'
         */
        textColor: '#fff',
        /**
         * @description Border radius
         * @type {Number}
         * @default borderRadius = 5
         */
        borderRadius: 5,
        /**
         * @description Local Gradient
         * @type {Boolean}
         * @default localGradient = false
         * @example localGradient = false | true
         */
        localGradient: false,
        /**
         * @description Formatter
         * @type {String}
         * @default formatter = '{value}%'
         */
        formatter: '{value}%'
      },

      mergedConfig: null
    };
  },

  computed: {
    rectWidth: function rectWidth() {
      var mergedConfig = this.mergedConfig,
          width = this.width;


      if (!mergedConfig) return 0;

      var borderWidth = mergedConfig.borderWidth;


      return width - borderWidth;
    },
    rectHeight: function rectHeight() {
      var mergedConfig = this.mergedConfig,
          height = this.height;


      if (!mergedConfig) return 0;

      var borderWidth = mergedConfig.borderWidth;


      return height - borderWidth;
    },
    points: function points() {
      var mergedConfig = this.mergedConfig,
          width = this.width,
          height = this.height;


      var halfHeight = height / 2;

      if (!mergedConfig) return '0, ' + halfHeight + ' 0, ' + halfHeight;

      var borderWidth = mergedConfig.borderWidth,
          borderGap = mergedConfig.borderGap,
          value = mergedConfig.value;


      var polylineLength = (width - (borderWidth + borderGap) * 2) / 100 * value;

      return '\n        ' + (borderWidth + borderGap) + ', ' + halfHeight + '\n        ' + (borderWidth + borderGap + polylineLength) + ', ' + (halfHeight + 0.001) + '\n      ';
    },
    polylineWidth: function polylineWidth() {
      var mergedConfig = this.mergedConfig,
          height = this.height;


      if (!mergedConfig) return 0;

      var borderWidth = mergedConfig.borderWidth,
          borderGap = mergedConfig.borderGap;


      return height - (borderWidth + borderGap) * 2;
    },
    linearGradient: function linearGradient() {
      var mergedConfig = this.mergedConfig;


      if (!mergedConfig) return [];

      var colors = mergedConfig.colors;


      var colorNum = colors.length;

      var colorOffsetGap = 100 / (colorNum - 1);

      return colors.map(function (c, i) {
        return [colorOffsetGap * i, c];
      });
    },
    polylineGradient: function polylineGradient() {
      var gradientId1 = this.gradientId1,
          gradientId2 = this.gradientId2,
          mergedConfig = this.mergedConfig;


      if (!mergedConfig) return gradientId2;

      if (mergedConfig.localGradient) return gradientId1;

      return gradientId2;
    },
    gradient2XPos: function gradient2XPos() {
      var mergedConfig = this.mergedConfig;


      if (!mergedConfig) return '100%';

      var value = mergedConfig.value;


      return 200 - value + '%';
    },
    details: function details() {
      var mergedConfig = this.mergedConfig;


      if (!mergedConfig) return '';

      var value = mergedConfig.value,
          formatter = mergedConfig.formatter;


      return formatter.replace('{value}', value);
    }
  },
  watch: {
    config: function config() {
      var mergeConfig = this.mergeConfig;


      mergeConfig();
    }
  },
  methods: {
    init: function init() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var initWH, config, mergeConfig;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                initWH = _this.initWH, config = _this.config, mergeConfig = _this.mergeConfig;
                _context.next = 3;
                return initWH();

              case 3:
                if (config) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:

                mergeConfig();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    initWH: function initWH() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var $nextTick, $refs, _$refs$percentPond, clientWidth, clientHeight;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                $nextTick = _this2.$nextTick, $refs = _this2.$refs;
                _context2.next = 3;
                return $nextTick();

              case 3:
                _$refs$percentPond = $refs['percent-pond'], clientWidth = _$refs$percentPond.clientWidth, clientHeight = _$refs$percentPond.clientHeight;


                _this2.width = clientWidth;
                _this2.height = clientHeight;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      this.mergedConfig = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config || {});
    }
  },
  mounted: function mounted() {
    var init = this.init;


    init();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/percentPond/src/main.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvPercentPond',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      gradientId1: 'percent-pond-gradientId1-' + id,
      gradientId2: 'percent-pond-gradientId2-' + id,

      width: 0,
      height: 0,

      defaultConfig: {
        /**
         * @description Value
         * @type {Number}
         * @default value = 0
         */
        value: 0,
        /**
         * @description Colors (hex|rgb|rgba|color keywords)
         * @type {Array<String>}
         * @default colors = ['#00BAFF', '#3DE7C9']
         * @example colors = ['#000', 'rgb(0, 0, 0)', 'rgba(0, 0, 0, 1)', 'red']
         */
        colors: ['#3DE7C9', '#00BAFF'],
        /**
         * @description Border width
         * @type {Number}
         * @default borderWidth = 3
         */
        borderWidth: 3,
        /**
         * @description Gap between border and pond
         * @type {Number}
         * @default borderGap = 3
         */
        borderGap: 3,
        /**
         * @description Line dash
         * @type {Array<Number>}
         * @default lineDash = [5, 1]
         */
        lineDash: [5, 1],
        /**
         * @description Text color
         * @type {String}
         * @default textColor = '#fff'
         */
        textColor: '#fff',
        /**
         * @description Border radius
         * @type {Number}
         * @default borderRadius = 5
         */
        borderRadius: 5,
        /**
         * @description Local Gradient
         * @type {Boolean}
         * @default localGradient = false
         * @example localGradient = false | true
         */
        localGradient: false,
        /**
         * @description Formatter
         * @type {String}
         * @default formatter = '{value}%'
         */
        formatter: '{value}%'
      },

      mergedConfig: null
    };
  },

  computed: {
    rectWidth: function rectWidth() {
      var mergedConfig = this.mergedConfig,
          width = this.width;


      if (!mergedConfig) return 0;

      var borderWidth = mergedConfig.borderWidth;


      return width - borderWidth;
    },
    rectHeight: function rectHeight() {
      var mergedConfig = this.mergedConfig,
          height = this.height;


      if (!mergedConfig) return 0;

      var borderWidth = mergedConfig.borderWidth;


      return height - borderWidth;
    },
    points: function points() {
      var mergedConfig = this.mergedConfig,
          width = this.width,
          height = this.height;


      var halfHeight = height / 2;

      if (!mergedConfig) return '0, ' + halfHeight + ' 0, ' + halfHeight;

      var borderWidth = mergedConfig.borderWidth,
          borderGap = mergedConfig.borderGap,
          value = mergedConfig.value;


      var polylineLength = (width - (borderWidth + borderGap) * 2) / 100 * value;

      return '\n        ' + (borderWidth + borderGap) + ', ' + halfHeight + '\n        ' + (borderWidth + borderGap + polylineLength) + ', ' + (halfHeight + 0.001) + '\n      ';
    },
    polylineWidth: function polylineWidth() {
      var mergedConfig = this.mergedConfig,
          height = this.height;


      if (!mergedConfig) return 0;

      var borderWidth = mergedConfig.borderWidth,
          borderGap = mergedConfig.borderGap;


      return height - (borderWidth + borderGap) * 2;
    },
    linearGradient: function linearGradient() {
      var mergedConfig = this.mergedConfig;


      if (!mergedConfig) return [];

      var colors = mergedConfig.colors;


      var colorNum = colors.length;

      var colorOffsetGap = 100 / (colorNum - 1);

      return colors.map(function (c, i) {
        return [colorOffsetGap * i, c];
      });
    },
    polylineGradient: function polylineGradient() {
      var gradientId1 = this.gradientId1,
          gradientId2 = this.gradientId2,
          mergedConfig = this.mergedConfig;


      if (!mergedConfig) return gradientId2;

      if (mergedConfig.localGradient) return gradientId1;

      return gradientId2;
    },
    gradient2XPos: function gradient2XPos() {
      var mergedConfig = this.mergedConfig;


      if (!mergedConfig) return '100%';

      var value = mergedConfig.value;


      return 200 - value + '%';
    },
    details: function details() {
      var mergedConfig = this.mergedConfig;


      if (!mergedConfig) return '';

      var value = mergedConfig.value,
          formatter = mergedConfig.formatter;


      return formatter.replace('{value}', value);
    }
  },
  watch: {
    config: function config() {
      var mergeConfig = this.mergeConfig;


      mergeConfig();
    }
  },
  methods: {
    init: function init() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var initWH, config, mergeConfig;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                initWH = _this.initWH, config = _this.config, mergeConfig = _this.mergeConfig;
                _context.next = 3;
                return initWH();

              case 3:
                if (config) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:

                mergeConfig();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    initWH: function initWH() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var $nextTick, $refs, _$refs$percentPond, clientWidth, clientHeight;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                $nextTick = _this2.$nextTick, $refs = _this2.$refs;
                _context2.next = 3;
                return $nextTick();

              case 3:
                _$refs$percentPond = $refs['percent-pond'], clientWidth = _$refs$percentPond.clientWidth, clientHeight = _$refs$percentPond.clientHeight;


                _this2.width = clientWidth;
                _this2.height = clientHeight;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      this.mergedConfig = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config || {});
    }
  },
  mounted: function mounted() {
    var init = this.init;


    init();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea653244","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/percentPond/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"percent-pond",staticClass:"dv-percent-pond"},[_c('svg',[_c('defs',[_c('linearGradient',{attrs:{"id":_vm.gradientId1,"x1":"0%","y1":"0%","x2":"100%","y2":"0%"}},_vm._l((_vm.linearGradient),function(lc){return _c('stop',{key:lc[0],attrs:{"offset":((lc[0]) + "%"),"stop-color":lc[1]}})}),1),_vm._v(" "),_c('linearGradient',{attrs:{"id":_vm.gradientId2,"x1":"0%","y1":"0%","x2":_vm.gradient2XPos,"y2":"0%"}},_vm._l((_vm.linearGradient),function(lc){return _c('stop',{key:lc[0],attrs:{"offset":((lc[0]) + "%"),"stop-color":lc[1]}})}),1)],1),_vm._v(" "),_c('rect',{attrs:{"x":_vm.mergedConfig ? _vm.mergedConfig.borderWidth / 2 : '0',"y":_vm.mergedConfig ? _vm.mergedConfig.borderWidth / 2 : '0',"rx":_vm.mergedConfig ? _vm.mergedConfig.borderRadius : '0',"ry":_vm.mergedConfig ? _vm.mergedConfig.borderRadius : '0',"fill":"transparent","stroke-width":_vm.mergedConfig ? _vm.mergedConfig.borderWidth : '0',"stroke":("url(#" + _vm.gradientId1 + ")"),"width":_vm.rectWidth > 0 ? _vm.rectWidth : 0,"height":_vm.rectHeight > 0 ? _vm.rectHeight : 0}}),_vm._v(" "),_c('polyline',{attrs:{"stroke-width":_vm.polylineWidth,"stroke-dasharray":_vm.mergedConfig ? _vm.mergedConfig.lineDash.join(',') : '0',"stroke":("url(#" + _vm.polylineGradient + ")"),"points":_vm.points}}),_vm._v(" "),_c('text',{attrs:{"stroke":_vm.mergedConfig ? _vm.mergedConfig.textColor : '#fff',"fill":_vm.mergedConfig ? _vm.mergedConfig.textColor : '#fff',"x":_vm.width / 2,"y":_vm.height / 2}},[_vm._v("\n      "+_vm._s(_vm.details)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var percentPond_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/percentPond/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  percentPond_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_percentPond_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HX3G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/util/index.js
var util = __webpack_require__("3e7c");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var lib_util = __webpack_require__("9A4f");
var lib_util_default = /*#__PURE__*/__webpack_require__.n(lib_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/color/lib/index.js
var lib = __webpack_require__("glc7");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration12/src/main.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var main = ({
  name: 'DvDecoration12',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * @description Scan animation dur
     */
    scanDur: {
      type: Number,
      default: 3
    },
    /**
     * @description Halo animation dur
     */
    haloDur: {
      type: Number,
      default: 2
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      ref: 'decoration-12',
      gId: 'decoration-12-g-' + id,
      gradientId: 'decoration-12-gradient-' + id,

      defaultColor: ['#2783ce', '#2cf7fe'],

      mergedColor: [],

      pathD: [],

      pathColor: [],

      circleR: [],

      splitLinePoints: [],

      arcD: [],

      segment: 30,

      sectorAngle: Math.PI / 3,

      ringNum: 3,

      ringWidth: 1,

      showSplitLine: true
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  computed: {
    x: function x() {
      var width = this.width;


      return width / 2;
    },
    y: function y() {
      var height = this.height;


      return height / 2;
    }
  },
  methods: {
    init: function init() {
      var mergeColor = this.mergeColor,
          calcPathD = this.calcPathD,
          calcPathColor = this.calcPathColor,
          calcCircleR = this.calcCircleR,
          calcSplitLinePoints = this.calcSplitLinePoints,
          calcArcD = this.calcArcD;


      mergeColor();

      calcPathD();

      calcPathColor();

      calcCircleR();

      calcSplitLinePoints();

      calcArcD();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    },
    calcPathD: function calcPathD() {
      var x = this.x,
          y = this.y,
          width = this.width,
          segment = this.segment,
          sectorAngle = this.sectorAngle;


      var startAngle = -Math.PI / 2;
      var angleGap = sectorAngle / segment;
      var r = width / 4;
      var lastEndPoints = Object(plugin_util["getCircleRadianPoint"])(x, y, r, startAngle);

      this.pathD = new Array(segment).fill('').map(function (_, i) {
        var endPoints = Object(plugin_util["getCircleRadianPoint"])(x, y, r, startAngle - (i + 1) * angleGap).map(function (_) {
          return _.toFixed(5);
        });
        var d = 'M' + lastEndPoints.join(',') + ' A' + r + ', ' + r + ' 0 0 0 ' + endPoints.join(',');
        lastEndPoints = endPoints;

        return d;
      });
    },
    calcPathColor: function calcPathColor() {
      var _mergedColor = slicedToArray_default()(this.mergedColor, 1),
          color = _mergedColor[0],
          segment = this.segment;

      var colorGap = 100 / (segment - 1);

      this.pathColor = new Array(segment).fill(color).map(function (_, i) {
        return Object(lib["fade"])(color, 100 - i * colorGap);
      });
    },
    calcCircleR: function calcCircleR() {
      var segment = this.segment,
          ringNum = this.ringNum,
          width = this.width,
          ringWidth = this.ringWidth;


      var radiusGap = (width / 2 - ringWidth / 2) / ringNum;

      this.circleR = new Array(ringNum).fill(0).map(function (_, i) {
        return radiusGap * (i + 1);
      });
    },
    calcSplitLinePoints: function calcSplitLinePoints() {
      var x = this.x,
          y = this.y,
          width = this.width;


      var angleGap = Math.PI / 6;
      var r = width / 2;

      this.splitLinePoints = new Array(6).fill('').map(function (_, i) {
        var startAngle = angleGap * (i + 1);
        var endAngle = startAngle + Math.PI;
        var startPoint = Object(plugin_util["getCircleRadianPoint"])(x, y, r, startAngle);
        var endPoint = Object(plugin_util["getCircleRadianPoint"])(x, y, r, endAngle);

        return startPoint.join(',') + ' ' + endPoint.join(',');
      });
    },
    calcArcD: function calcArcD() {
      var x = this.x,
          y = this.y,
          width = this.width;


      var angleGap = Math.PI / 6;
      var r = width / 2 - 1;

      this.arcD = new Array(4).fill('').map(function (_, i) {
        var startAngle = angleGap * (3 * i + 1);
        var endAngle = startAngle + angleGap;
        var startPoint = Object(plugin_util["getCircleRadianPoint"])(x, y, r, startAngle);
        var endPoint = Object(plugin_util["getCircleRadianPoint"])(x, y, r, endAngle);

        return 'M' + startPoint.join(',') + ' A' + x + ', ' + y + ' 0 0 1 ' + endPoint.join(',');
      });
    },
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var init = this.init;


      init();
    },

    fade: lib["fade"]
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration12/src/main.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var src_main = ({
  name: 'DvDecoration12',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * @description Scan animation dur
     */
    scanDur: {
      type: Number,
      default: 3
    },
    /**
     * @description Halo animation dur
     */
    haloDur: {
      type: Number,
      default: 2
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      ref: 'decoration-12',
      gId: 'decoration-12-g-' + id,
      gradientId: 'decoration-12-gradient-' + id,

      defaultColor: ['#2783ce', '#2cf7fe'],

      mergedColor: [],

      pathD: [],

      pathColor: [],

      circleR: [],

      splitLinePoints: [],

      arcD: [],

      segment: 30,

      sectorAngle: Math.PI / 3,

      ringNum: 3,

      ringWidth: 1,

      showSplitLine: true
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  computed: {
    x: function x() {
      var width = this.width;


      return width / 2;
    },
    y: function y() {
      var height = this.height;


      return height / 2;
    }
  },
  methods: {
    init: function init() {
      var mergeColor = this.mergeColor,
          calcPathD = this.calcPathD,
          calcPathColor = this.calcPathColor,
          calcCircleR = this.calcCircleR,
          calcSplitLinePoints = this.calcSplitLinePoints,
          calcArcD = this.calcArcD;


      mergeColor();

      calcPathD();

      calcPathColor();

      calcCircleR();

      calcSplitLinePoints();

      calcArcD();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    },
    calcPathD: function calcPathD() {
      var x = this.x,
          y = this.y,
          width = this.width,
          segment = this.segment,
          sectorAngle = this.sectorAngle;


      var startAngle = -Math.PI / 2;
      var angleGap = sectorAngle / segment;
      var r = width / 4;
      var lastEndPoints = Object(plugin_util["getCircleRadianPoint"])(x, y, r, startAngle);

      this.pathD = new Array(segment).fill('').map(function (_, i) {
        var endPoints = Object(plugin_util["getCircleRadianPoint"])(x, y, r, startAngle - (i + 1) * angleGap).map(function (_) {
          return _.toFixed(5);
        });
        var d = 'M' + lastEndPoints.join(',') + ' A' + r + ', ' + r + ' 0 0 0 ' + endPoints.join(',');
        lastEndPoints = endPoints;

        return d;
      });
    },
    calcPathColor: function calcPathColor() {
      var _mergedColor = slicedToArray_default()(this.mergedColor, 1),
          color = _mergedColor[0],
          segment = this.segment;

      var colorGap = 100 / (segment - 1);

      this.pathColor = new Array(segment).fill(color).map(function (_, i) {
        return Object(lib["fade"])(color, 100 - i * colorGap);
      });
    },
    calcCircleR: function calcCircleR() {
      var segment = this.segment,
          ringNum = this.ringNum,
          width = this.width,
          ringWidth = this.ringWidth;


      var radiusGap = (width / 2 - ringWidth / 2) / ringNum;

      this.circleR = new Array(ringNum).fill(0).map(function (_, i) {
        return radiusGap * (i + 1);
      });
    },
    calcSplitLinePoints: function calcSplitLinePoints() {
      var x = this.x,
          y = this.y,
          width = this.width;


      var angleGap = Math.PI / 6;
      var r = width / 2;

      this.splitLinePoints = new Array(6).fill('').map(function (_, i) {
        var startAngle = angleGap * (i + 1);
        var endAngle = startAngle + Math.PI;
        var startPoint = Object(plugin_util["getCircleRadianPoint"])(x, y, r, startAngle);
        var endPoint = Object(plugin_util["getCircleRadianPoint"])(x, y, r, endAngle);

        return startPoint.join(',') + ' ' + endPoint.join(',');
      });
    },
    calcArcD: function calcArcD() {
      var x = this.x,
          y = this.y,
          width = this.width;


      var angleGap = Math.PI / 6;
      var r = width / 2 - 1;

      this.arcD = new Array(4).fill('').map(function (_, i) {
        var startAngle = angleGap * (3 * i + 1);
        var endAngle = startAngle + angleGap;
        var startPoint = Object(plugin_util["getCircleRadianPoint"])(x, y, r, startAngle);
        var endPoint = Object(plugin_util["getCircleRadianPoint"])(x, y, r, endAngle);

        return 'M' + startPoint.join(',') + ' A' + x + ', ' + y + ' 0 0 1 ' + endPoint.join(',');
      });
    },
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var init = this.init;


      init();
    },

    fade: lib["fade"]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b5d7dd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration12/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-decoration-12"},[_c('svg',{attrs:{"width":_vm.width,"height":_vm.height}},[_c('defs',[_c('g',{attrs:{"id":_vm.gId}},_vm._l((_vm.pathD),function(d,i){return _c('path',{key:d,attrs:{"stroke":_vm.pathColor[i],"stroke-width":_vm.width / 2,"fill":"transparent","d":d}})}),0),_vm._v(" "),_c('radialGradient',{attrs:{"id":_vm.gradientId,"cx":"50%","cy":"50%","r":"50%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"transparent","stop-opacity":"1"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":_vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 30),"stop-opacity":"1"}})],1)],1),_vm._v(" "),_vm._l((_vm.circleR),function(r){return _c('circle',{key:r,attrs:{"r":r,"cx":_vm.x,"cy":_vm.y,"stroke":_vm.mergedColor[1],"stroke-width":0.5,"fill":"transparent"}})}),_vm._v(" "),_c('circle',{attrs:{"r":"1","cx":_vm.x,"cy":_vm.y,"stroke":"transparent","fill":("url(#" + _vm.gradientId + ")")}},[_c('animate',{attrs:{"attributeName":"r","values":("1;" + (_vm.width / 2)),"dur":(_vm.haloDur + "s"),"repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"opacity","values":"1;0","dur":(_vm.haloDur + "s"),"repeatCount":"indefinite"}})]),_vm._v(" "),_c('circle',{attrs:{"r":"2","cx":_vm.x,"cy":_vm.y,"fill":_vm.mergedColor[1]}}),_vm._v(" "),(_vm.showSplitLine)?_c('g',_vm._l((_vm.splitLinePoints),function(p){return _c('polyline',{key:p,attrs:{"points":p,"stroke":_vm.mergedColor[1],"stroke-width":0.5,"opacity":"0.5"}})}),0):_vm._e(),_vm._v(" "),_vm._l((_vm.arcD),function(d){return _c('path',{key:d,attrs:{"d":d,"stroke":_vm.mergedColor[1],"stroke-width":"2","fill":"transparent"}})}),_vm._v(" "),_c('use',{attrs:{"xlink:href":("#" + _vm.gId)}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","values":("0, " + _vm.x + " " + _vm.y + ";360, " + _vm.x + " " + _vm.y),"dur":(_vm.scanDur + "s"),"repeatCount":"indefinite"}})],1)],2),_vm._v(" "),_c('div',{staticClass:"decoration-content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var decoration12_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/decoration12/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  decoration12_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_decoration12_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I/zu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "In5b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J1Kv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JYXt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JeZZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app',
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app',
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c8b3ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("dR5y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MDGh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MFQN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MPgH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/set.js
var set = __webpack_require__("lHA8");
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/array/from.js
var from = __webpack_require__("c/Tr");
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/capsuleChart/src/main.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var main = ({
  name: 'DvCapsuleChart',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      defaultConfig: {
        /**
         * @description Capsule chart data
         * @type {Array<Object>}
         * @default data = []
         * @example data = [{ name: 'foo1', value: 100 }, { name: 'foo2', value: 100 }]
         */
        data: [],
        /**
         * @description Colors (hex|rgb|rgba|color keywords)
         * @type {Array<String>}
         * @default color = ['#37a2da', '#32c5e9', '#67e0e3', '#9fe6b8', '#ffdb5c', '#ff9f7f', '#fb7293']
         * @example color = ['#000', 'rgb(0, 0, 0)', 'rgba(0, 0, 0, 1)', 'red']
         */
        colors: ['#37a2da', '#32c5e9', '#67e0e3', '#9fe6b8', '#ffdb5c', '#ff9f7f', '#fb7293'],
        /**
         * @description Chart unit
         * @type {String}
         * @default unit = ''
         */
        unit: '',
        /**
         * @description Show item value
         * @type {Boolean}
         * @default showValue = false
         */
        showValue: false
      },

      mergedConfig: null,

      capsuleLength: [],
      capsuleValue: [],
      labelData: [],
      labelDataLength: []
    };
  },

  watch: {
    config: function config() {
      var calcData = this.calcData;


      calcData();
    }
  },
  methods: {
    calcData: function calcData() {
      var mergeConfig = this.mergeConfig,
          calcCapsuleLengthAndLabelData = this.calcCapsuleLengthAndLabelData;


      mergeConfig();

      calcCapsuleLengthAndLabelData();
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      this.mergedConfig = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config || {});
    },
    calcCapsuleLengthAndLabelData: function calcCapsuleLengthAndLabelData() {
      var data = this.mergedConfig.data;


      if (!data.length) return;

      var capsuleValue = data.map(function (_ref) {
        var value = _ref.value;
        return value;
      });

      var maxValue = Math.max.apply(Math, toConsumableArray_default()(capsuleValue));

      this.capsuleValue = capsuleValue;

      this.capsuleLength = capsuleValue.map(function (v) {
        return maxValue ? v / maxValue : 0;
      });

      var oneFifth = maxValue / 5;

      var labelData = from_default()(new set_default.a(new Array(6).fill(0).map(function (v, i) {
        return Math.ceil(i * oneFifth);
      })));

      this.labelData = labelData;

      this.labelDataLength = from_default()(labelData).map(function (v) {
        return maxValue ? v / maxValue : 0;
      });
    }
  },
  mounted: function mounted() {
    var calcData = this.calcData;


    calcData();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/capsuleChart/src/main.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var src_main = ({
  name: 'DvCapsuleChart',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      defaultConfig: {
        /**
         * @description Capsule chart data
         * @type {Array<Object>}
         * @default data = []
         * @example data = [{ name: 'foo1', value: 100 }, { name: 'foo2', value: 100 }]
         */
        data: [],
        /**
         * @description Colors (hex|rgb|rgba|color keywords)
         * @type {Array<String>}
         * @default color = ['#37a2da', '#32c5e9', '#67e0e3', '#9fe6b8', '#ffdb5c', '#ff9f7f', '#fb7293']
         * @example color = ['#000', 'rgb(0, 0, 0)', 'rgba(0, 0, 0, 1)', 'red']
         */
        colors: ['#37a2da', '#32c5e9', '#67e0e3', '#9fe6b8', '#ffdb5c', '#ff9f7f', '#fb7293'],
        /**
         * @description Chart unit
         * @type {String}
         * @default unit = ''
         */
        unit: '',
        /**
         * @description Show item value
         * @type {Boolean}
         * @default showValue = false
         */
        showValue: false
      },

      mergedConfig: null,

      capsuleLength: [],
      capsuleValue: [],
      labelData: [],
      labelDataLength: []
    };
  },

  watch: {
    config: function config() {
      var calcData = this.calcData;


      calcData();
    }
  },
  methods: {
    calcData: function calcData() {
      var mergeConfig = this.mergeConfig,
          calcCapsuleLengthAndLabelData = this.calcCapsuleLengthAndLabelData;


      mergeConfig();

      calcCapsuleLengthAndLabelData();
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      this.mergedConfig = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config || {});
    },
    calcCapsuleLengthAndLabelData: function calcCapsuleLengthAndLabelData() {
      var data = this.mergedConfig.data;


      if (!data.length) return;

      var capsuleValue = data.map(function (_ref) {
        var value = _ref.value;
        return value;
      });

      var maxValue = Math.max.apply(Math, toConsumableArray_default()(capsuleValue));

      this.capsuleValue = capsuleValue;

      this.capsuleLength = capsuleValue.map(function (v) {
        return maxValue ? v / maxValue : 0;
      });

      var oneFifth = maxValue / 5;

      var labelData = from_default()(new set_default.a(new Array(6).fill(0).map(function (v, i) {
        return Math.ceil(i * oneFifth);
      })));

      this.labelData = labelData;

      this.labelDataLength = from_default()(labelData).map(function (v) {
        return maxValue ? v / maxValue : 0;
      });
    }
  },
  mounted: function mounted() {
    var calcData = this.calcData;


    calcData();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-058edf2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/capsuleChart/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dv-capsule-chart"},[(_vm.mergedConfig)?[_c('div',{staticClass:"label-column"},[_vm._l((_vm.mergedConfig.data),function(item){return _c('div',{key:item.name},[_vm._v(_vm._s(item.name))])}),_vm._v(" "),_c('div',[_vm._v(" ")])],2),_vm._v(" "),_c('div',{staticClass:"capsule-container"},[_vm._l((_vm.capsuleLength),function(capsule,index){return _c('div',{key:index,staticClass:"capsule-item"},[_c('div',{staticClass:"capsule-item-column",style:(("width: " + (capsule * 100) + "%; background-color: " + (_vm.mergedConfig.colors[index % _vm.mergedConfig.colors.length]) + ";"))},[(_vm.mergedConfig.showValue)?_c('div',{staticClass:"capsule-item-value"},[_vm._v(_vm._s(_vm.capsuleValue[index]))]):_vm._e()])])}),_vm._v(" "),_c('div',{staticClass:"unit-label"},_vm._l((_vm.labelData),function(label,index){return _c('div',{key:label + index},[_vm._v(_vm._s(label))])}),0)],2),_vm._v(" "),(_vm.mergedConfig.unit)?_c('div',{staticClass:"unit-text"},[_vm._v(_vm._s(_vm.mergedConfig.unit))]):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var capsuleChart_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/capsuleChart/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  capsuleChart_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_capsuleChart_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MU2+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _fastclick = __webpack_require__("v5o6");

var _fastclick2 = _interopRequireDefault(_fastclick);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _index = __webpack_require__("YaEn");

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__("3BeM");

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__("Y+qm");

var _index6 = _interopRequireDefault(_index5);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _clipboard = __webpack_require__("TQvf");

var _clipboard2 = _interopRequireDefault(_clipboard);

var _dataView = __webpack_require__("5wnc");

var _dataView2 = _interopRequireDefault(_dataView);

var _elementUi = __webpack_require__("zL8q");

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__("tvR6");

var _vueAmap = __webpack_require__("4Fxi");

var _vueAmap2 = _interopRequireDefault(_vueAmap);

__webpack_require__("8epE");

var _three = __webpack_require__("djUY");

var _three2 = _interopRequireDefault(_three);

__webpack_require__("5iwl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default);

_vue2.default.use(_vueAmap2.default);
_vueAmap2.default.initAMapApiLoader({
  key: '135a80ff9deaf86a9ca021217fc4879e',
  securityJsCode: '245304fd2aae393e05450c1b53c8f6fb'
});

_vue2.default.use(_three2.default);

_vue2.default.use(_dataView2.default);

_vue2.default.use(_index4.default);
_vue2.default.use(_index6.default);

_vue2.default.prototype.clipboard = _clipboard2.default;

_vue2.default.prototype.$http = _axios2.default;

_fastclick2.default.attach(document.body);

_vue2.default.config.productionTip = false;

_vue2.default.use(_vueRouter2.default);

new _vue2.default({
  router: _index2.default, //-----router文件
  el: '#app-box',
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),

/***/ "OmSs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Oo05":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PC80":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RFQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/util/index.js
var util = __webpack_require__("3e7c");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var lib_util = __webpack_require__("9A4f");
var lib_util_default = /*#__PURE__*/__webpack_require__.n(lib_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration6/src/main.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var main = ({
  name: 'DvDecoration6',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var rectWidth = 7;

    return {
      ref: 'decoration-6',

      svgWH: [300, 35],

      svgScale: [1, 1],

      rowNum: 1,
      rowPoints: 40,

      rectWidth: rectWidth,
      halfRectWidth: rectWidth / 2,

      points: [],
      heights: [],
      minHeights: [],
      randoms: [],

      defaultColor: ['#7acaec', '#7acaec'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    calcSVGData: function calcSVGData() {
      var calcPointsPosition = this.calcPointsPosition,
          calcScale = this.calcScale;


      calcPointsPosition();

      calcScale();
    },
    calcPointsPosition: function calcPointsPosition() {
      var svgWH = this.svgWH,
          rowNum = this.rowNum,
          rowPoints = this.rowPoints;

      var _svgWH = slicedToArray_default()(svgWH, 2),
          w = _svgWH[0],
          h = _svgWH[1];

      var horizontalGap = w / (rowPoints + 1);
      var verticalGap = h / (rowNum + 1);

      var points = new Array(rowNum).fill(0).map(function (foo, i) {
        return new Array(rowPoints).fill(0).map(function (foo, j) {
          return [horizontalGap * (j + 1), verticalGap * (i + 1)];
        });
      });

      this.points = points.reduce(function (all, item) {
        return [].concat(toConsumableArray_default()(all), toConsumableArray_default()(item));
      }, []);
      var heights = this.heights = new Array(rowNum * rowPoints).fill(0).map(function (foo) {
        return Math.random() > 0.8 ? Object(util["randomExtend"])(0.7 * h, h) : Object(util["randomExtend"])(0.2 * h, 0.5 * h);
      });

      this.minHeights = new Array(rowNum * rowPoints).fill(0).map(function (foo, i) {
        return heights[i] * Math.random();
      });

      this.randoms = new Array(rowNum * rowPoints).fill(0).map(function (foo) {
        return Math.random() + 1.5;
      });
    },
    calcScale: function calcScale() {
      var width = this.width,
          height = this.height,
          svgWH = this.svgWH;

      var _svgWH2 = slicedToArray_default()(svgWH, 2),
          w = _svgWH2[0],
          h = _svgWH2[1];

      this.svgScale = [width / w, height / h];
    },
    onResize: function onResize() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration6/src/main.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var src_main = ({
  name: 'DvDecoration6',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var rectWidth = 7;

    return {
      ref: 'decoration-6',

      svgWH: [300, 35],

      svgScale: [1, 1],

      rowNum: 1,
      rowPoints: 40,

      rectWidth: rectWidth,
      halfRectWidth: rectWidth / 2,

      points: [],
      heights: [],
      minHeights: [],
      randoms: [],

      defaultColor: ['#7acaec', '#7acaec'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    calcSVGData: function calcSVGData() {
      var calcPointsPosition = this.calcPointsPosition,
          calcScale = this.calcScale;


      calcPointsPosition();

      calcScale();
    },
    calcPointsPosition: function calcPointsPosition() {
      var svgWH = this.svgWH,
          rowNum = this.rowNum,
          rowPoints = this.rowPoints;

      var _svgWH = slicedToArray_default()(svgWH, 2),
          w = _svgWH[0],
          h = _svgWH[1];

      var horizontalGap = w / (rowPoints + 1);
      var verticalGap = h / (rowNum + 1);

      var points = new Array(rowNum).fill(0).map(function (foo, i) {
        return new Array(rowPoints).fill(0).map(function (foo, j) {
          return [horizontalGap * (j + 1), verticalGap * (i + 1)];
        });
      });

      this.points = points.reduce(function (all, item) {
        return [].concat(toConsumableArray_default()(all), toConsumableArray_default()(item));
      }, []);
      var heights = this.heights = new Array(rowNum * rowPoints).fill(0).map(function (foo) {
        return Math.random() > 0.8 ? Object(util["randomExtend"])(0.7 * h, h) : Object(util["randomExtend"])(0.2 * h, 0.5 * h);
      });

      this.minHeights = new Array(rowNum * rowPoints).fill(0).map(function (foo, i) {
        return heights[i] * Math.random();
      });

      this.randoms = new Array(rowNum * rowPoints).fill(0).map(function (foo) {
        return Math.random() + 1.5;
      });
    },
    calcScale: function calcScale() {
      var width = this.width,
          height = this.height,
          svgWH = this.svgWH;

      var _svgWH2 = slicedToArray_default()(svgWH, 2),
          w = _svgWH2[0],
          h = _svgWH2[1];

      this.svgScale = [width / w, height / h];
    },
    onResize: function onResize() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9ebb10e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration6/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-decoration-6"},[_c('svg',{style:(("transform:scale(" + (_vm.svgScale[0]) + "," + (_vm.svgScale[1]) + ");")),attrs:{"width":((_vm.svgWH[0]) + "px"),"height":((_vm.svgWH[1]) + "px")}},[_vm._l((_vm.points),function(point,i){return [_c('rect',{key:i,attrs:{"fill":_vm.mergedColor[Math.random() > 0.5 ? 0 : 1],"x":point[0] - _vm.halfRectWidth,"y":point[1] - _vm.heights[i] / 2,"width":_vm.rectWidth,"height":_vm.heights[i]}},[_c('animate',{attrs:{"attributeName":"y","values":((point[1] - _vm.minHeights[i] / 2) + ";" + (point[1] - _vm.heights[i] / 2) + ";" + (point[1] - _vm.minHeights[i] / 2)),"dur":((_vm.randoms[i]) + "s"),"keyTimes":"0;0.5;1","calcMode":"spline","keySplines":"0.42,0,0.58,1;0.42,0,0.58,1","begin":"0s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"height","values":((_vm.minHeights[i]) + ";" + (_vm.heights[i]) + ";" + (_vm.minHeights[i])),"dur":((_vm.randoms[i]) + "s"),"keyTimes":"0;0.5;1","calcMode":"spline","keySplines":"0.42,0,0.58,1;0.42,0,0.58,1","begin":"0s","repeatCount":"indefinite"}})])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var decoration6_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/decoration6/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  decoration6_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_decoration6_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RWIN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SS1b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SvTU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox7/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvBorderBox7',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-7',

      defaultColor: ['rgba(128,128,128,0.3)', 'rgba(128,128,128,0.5)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox7/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvBorderBox7',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-7',

      defaultColor: ['rgba(128,128,128,0.3)', 'rgba(128,128,128,0.5)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3897f12e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox7/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-border-box-7",style:(("box-shadow: inset 0 0 40px " + (_vm.mergedColor[0]) + "; border: 1px solid " + (_vm.mergedColor[0]) + "; background-color: " + _vm.backgroundColor))},[_c('svg',{staticClass:"dv-border-svg-container",attrs:{"width":_vm.width,"height":_vm.height}},[_c('polyline',{staticClass:"dv-bb7-line-width-2",attrs:{"stroke":_vm.mergedColor[0],"points":"0, 25 0, 0 25, 0"}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb7-line-width-2",attrs:{"stroke":_vm.mergedColor[0],"points":((_vm.width - 25) + ", 0 " + _vm.width + ", 0 " + _vm.width + ", 25")}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb7-line-width-2",attrs:{"stroke":_vm.mergedColor[0],"points":((_vm.width - 25) + ", " + _vm.height + " " + _vm.width + ", " + _vm.height + " " + _vm.width + ", " + (_vm.height - 25))}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb7-line-width-2",attrs:{"stroke":_vm.mergedColor[0],"points":("0, " + (_vm.height - 25) + " 0, " + _vm.height + " 25, " + _vm.height)}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb7-line-width-5",attrs:{"stroke":_vm.mergedColor[1],"points":"0, 10 0, 0 10, 0"}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb7-line-width-5",attrs:{"stroke":_vm.mergedColor[1],"points":((_vm.width - 10) + ", 0 " + _vm.width + ", 0 " + _vm.width + ", 10")}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb7-line-width-5",attrs:{"stroke":_vm.mergedColor[1],"points":((_vm.width - 10) + ", " + _vm.height + " " + _vm.width + ", " + _vm.height + " " + _vm.width + ", " + (_vm.height - 10))}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb7-line-width-5",attrs:{"stroke":_vm.mergedColor[1],"points":("0, " + (_vm.height - 10) + " 0, " + _vm.height + " 10, " + _vm.height)}})]),_vm._v(" "),_c('div',{staticClass:"border-box-content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var borderBox7_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/borderBox7/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  borderBox7_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_borderBox7_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UsbJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/util/index.js
var util = __webpack_require__("3e7c");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var lib_util = __webpack_require__("9A4f");
var lib_util_default = /*#__PURE__*/__webpack_require__.n(lib_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/color/lib/index.js
var lib = __webpack_require__("glc7");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration9/src/main.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var main = ({
  name: 'DvDecoration9',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dur: {
      type: Number,
      default: 3
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      ref: 'decoration-9',

      polygonId: 'decoration-9-polygon-' + id,

      svgWH: [100, 100],

      svgScale: [1, 1],

      defaultColor: ['rgba(3, 166, 224, 0.8)', 'rgba(3, 166, 224, 0.5)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcScale = this.calcScale;


      calcScale();
    },
    calcScale: function calcScale() {
      var width = this.width,
          height = this.height,
          svgWH = this.svgWH;

      var _svgWH = slicedToArray_default()(svgWH, 2),
          w = _svgWH[0],
          h = _svgWH[1];

      this.svgScale = [width / w, height / h];
    },
    onResize: function onResize() {
      var calcScale = this.calcScale;


      calcScale();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    },

    fade: lib["fade"]
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration9/src/main.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var src_main = ({
  name: 'DvDecoration9',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dur: {
      type: Number,
      default: 3
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      ref: 'decoration-9',

      polygonId: 'decoration-9-polygon-' + id,

      svgWH: [100, 100],

      svgScale: [1, 1],

      defaultColor: ['rgba(3, 166, 224, 0.8)', 'rgba(3, 166, 224, 0.5)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcScale = this.calcScale;


      calcScale();
    },
    calcScale: function calcScale() {
      var width = this.width,
          height = this.height,
          svgWH = this.svgWH;

      var _svgWH = slicedToArray_default()(svgWH, 2),
          w = _svgWH[0],
          h = _svgWH[1];

      this.svgScale = [width / w, height / h];
    },
    onResize: function onResize() {
      var calcScale = this.calcScale;


      calcScale();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    },

    fade: lib["fade"]
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8ad0d4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration9/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-decoration-9"},[_c('svg',{style:(("transform:scale(" + (_vm.svgScale[0]) + "," + (_vm.svgScale[1]) + ");")),attrs:{"width":((_vm.svgWH[0]) + "px"),"height":((_vm.svgWH[1]) + "px")}},[_c('defs',[_c('polygon',{attrs:{"id":_vm.polygonId,"points":"15, 46.5, 21, 47.5, 21, 52.5, 15, 53.5"}})]),_vm._v(" "),_c('circle',{attrs:{"cx":"50","cy":"50","r":"45","fill":"transparent","stroke":_vm.mergedColor[1],"stroke-width":"10","stroke-dasharray":"80, 100, 30, 100"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","values":"0 50 50;360 50 50","dur":(_vm.dur + "s"),"repeatCount":"indefinite"}})],1),_vm._v(" "),_c('circle',{attrs:{"cx":"50","cy":"50","r":"45","fill":"transparent","stroke":_vm.mergedColor[0],"stroke-width":"6","stroke-dasharray":"50, 66, 100, 66"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","values":"0 50 50;-360 50 50","dur":(_vm.dur + "s"),"repeatCount":"indefinite"}})],1),_vm._v(" "),_c('circle',{attrs:{"cx":"50","cy":"50","r":"38","fill":"transparent","stroke":_vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 30),"stroke-width":"1","stroke-dasharray":"5, 1"}}),_vm._v(" "),_vm._l((new Array(20).fill(0)),function(foo,i){return _c('use',{key:i,attrs:{"xlink:href":("#" + _vm.polygonId),"stroke":_vm.mergedColor[1],"fill":Math.random() > 0.4 ? 'transparent' : _vm.mergedColor[0]}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","values":"0 50 50;360 50 50","dur":(_vm.dur + "s"),"begin":((i * _vm.dur / 20) + "s"),"repeatCount":"indefinite"}})],1)}),_vm._v(" "),_c('circle',{attrs:{"cx":"50","cy":"50","r":"26","fill":"transparent","stroke":_vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 30),"stroke-width":"1","stroke-dasharray":"5, 1"}})],2),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var decoration9_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/decoration9/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  decoration9_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_decoration9_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Vyt+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration3/src/main.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvDecoration3',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var pointSideLength = 7;

    return {
      ref: 'decoration-3',

      svgWH: [300, 35],

      svgScale: [1, 1],

      rowNum: 2,
      rowPoints: 25,

      pointSideLength: pointSideLength,
      halfPointSideLength: pointSideLength / 2,

      points: [],

      defaultColor: ['#7acaec', 'transparent'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    calcSVGData: function calcSVGData() {
      var calcPointsPosition = this.calcPointsPosition,
          calcScale = this.calcScale;


      calcPointsPosition();

      calcScale();
    },
    calcPointsPosition: function calcPointsPosition() {
      var svgWH = this.svgWH,
          rowNum = this.rowNum,
          rowPoints = this.rowPoints;

      var _svgWH = slicedToArray_default()(svgWH, 2),
          w = _svgWH[0],
          h = _svgWH[1];

      var horizontalGap = w / (rowPoints + 1);
      var verticalGap = h / (rowNum + 1);

      var points = new Array(rowNum).fill(0).map(function (foo, i) {
        return new Array(rowPoints).fill(0).map(function (foo, j) {
          return [horizontalGap * (j + 1), verticalGap * (i + 1)];
        });
      });

      this.points = points.reduce(function (all, item) {
        return [].concat(toConsumableArray_default()(all), toConsumableArray_default()(item));
      }, []);
    },
    calcScale: function calcScale() {
      var width = this.width,
          height = this.height,
          svgWH = this.svgWH;

      var _svgWH2 = slicedToArray_default()(svgWH, 2),
          w = _svgWH2[0],
          h = _svgWH2[1];

      this.svgScale = [width / w, height / h];
    },
    onResize: function onResize() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration3/src/main.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvDecoration3',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var pointSideLength = 7;

    return {
      ref: 'decoration-3',

      svgWH: [300, 35],

      svgScale: [1, 1],

      rowNum: 2,
      rowPoints: 25,

      pointSideLength: pointSideLength,
      halfPointSideLength: pointSideLength / 2,

      points: [],

      defaultColor: ['#7acaec', 'transparent'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    calcSVGData: function calcSVGData() {
      var calcPointsPosition = this.calcPointsPosition,
          calcScale = this.calcScale;


      calcPointsPosition();

      calcScale();
    },
    calcPointsPosition: function calcPointsPosition() {
      var svgWH = this.svgWH,
          rowNum = this.rowNum,
          rowPoints = this.rowPoints;

      var _svgWH = slicedToArray_default()(svgWH, 2),
          w = _svgWH[0],
          h = _svgWH[1];

      var horizontalGap = w / (rowPoints + 1);
      var verticalGap = h / (rowNum + 1);

      var points = new Array(rowNum).fill(0).map(function (foo, i) {
        return new Array(rowPoints).fill(0).map(function (foo, j) {
          return [horizontalGap * (j + 1), verticalGap * (i + 1)];
        });
      });

      this.points = points.reduce(function (all, item) {
        return [].concat(toConsumableArray_default()(all), toConsumableArray_default()(item));
      }, []);
    },
    calcScale: function calcScale() {
      var width = this.width,
          height = this.height,
          svgWH = this.svgWH;

      var _svgWH2 = slicedToArray_default()(svgWH, 2),
          w = _svgWH2[0],
          h = _svgWH2[1];

      this.svgScale = [width / w, height / h];
    },
    onResize: function onResize() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-455c74d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration3/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-decoration-3"},[_c('svg',{style:(("transform:scale(" + (_vm.svgScale[0]) + "," + (_vm.svgScale[1]) + ");")),attrs:{"width":((_vm.svgWH[0]) + "px"),"height":((_vm.svgWH[1]) + "px")}},[_vm._l((_vm.points),function(point,i){return [_c('rect',{key:i,attrs:{"fill":_vm.mergedColor[0],"x":point[0] - _vm.halfPointSideLength,"y":point[1] - _vm.halfPointSideLength,"width":_vm.pointSideLength,"height":_vm.pointSideLength}},[(Math.random() > 0.6)?_c('animate',{attrs:{"attributeName":"fill","values":("" + (_vm.mergedColor.join(';'))),"dur":Math.random() + 1 + 's',"begin":Math.random() * 2,"repeatCount":"indefinite"}}):_vm._e()])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var decoration3_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/decoration3/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  decoration3_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_decoration3_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WO7A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/index.js
var lib = __webpack_require__("z0b2");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/components/digitalFlop/src/main.vue + 3 modules
var main = __webpack_require__("XMhG");

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/activeRingChart/src/main.vue


//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var src_main = ({
  name: 'DvActiveRingChart',
  components: {
    dvDigitalFlop: main["a" /* default */]
  },
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      defaultConfig: {
        /**
         * @description Ring radius
         * @type {String|Number}
         * @default radius = '50%'
         * @example radius = '50%' | 100
         */
        radius: '50%',
        /**
         * @description Active ring radius
         * @type {String|Number}
         * @default activeRadius = '55%'
         * @example activeRadius = '55%' | 110
         */
        activeRadius: '55%',
        /**
         * @description Ring data
         * @type {Array<Object>}
         * @default data = [{ name: '', value: 0 }]
         */
        data: [{ name: '', value: 0 }],
        /**
         * @description Ring line width
         * @type {Number}
         * @default lineWidth = 20
         */
        lineWidth: 20,
        /**
         * @description Active time gap (ms)
         * @type {Number}
         * @default activeTimeGap = 3000
         */
        activeTimeGap: 3000,
        /**
         * @description Ring color (hex|rgb|rgba|color keywords)
         * @type {Array<String>}
         * @default color = [Charts Default Color]
         * @example color = ['#000', 'rgb(0, 0, 0)', 'rgba(0, 0, 0, 1)', 'red']
         */
        color: [],
        /**
         * @description Digital flop style
         * @type {Object}
         */
        digitalFlopStyle: {
          fontSize: 25,
          fill: '#fff'
        },
        /**
         * @description Digital flop toFixed
         * @type {Number}
         */
        digitalFlopToFixed: 0,
        /**
         * @description Digital flop unit
         * @type {String}
         */
        digitalFlopUnit: '',
        /**
         * @description CRender animationCurve
         * @type {String}
         * @default animationCurve = 'easeOutCubic'
         */
        animationCurve: 'easeOutCubic',
        /**
         * @description CRender animationFrame
         * @type {String}
         * @default animationFrame = 50
         */
        animationFrame: 50,
        /**
         * @description showOriginValue
         * @type {Boolean}
         * @default showOriginValue = false
         */
        showOriginValue: false
      },

      mergedConfig: null,

      chart: null,

      activeIndex: 0,

      animationHandler: ''
    };
  },

  computed: {
    digitalFlop: function digitalFlop() {
      var mergedConfig = this.mergedConfig,
          activeIndex = this.activeIndex;


      if (!mergedConfig) return {};

      var digitalFlopStyle = mergedConfig.digitalFlopStyle,
          digitalFlopToFixed = mergedConfig.digitalFlopToFixed,
          data = mergedConfig.data,
          showOriginValue = mergedConfig.showOriginValue,
          digitalFlopUnit = mergedConfig.digitalFlopUnit;


      var value = data.map(function (_ref) {
        var value = _ref.value;
        return value;
      });

      var displayValue = void 0;

      if (showOriginValue) {
        displayValue = value[activeIndex];
      } else {
        var sum = value.reduce(function (all, v) {
          return all + v;
        }, 0);

        var percent = parseFloat(value[activeIndex] / sum * 100) || 0;

        displayValue = percent;
      }

      return {
        content: showOriginValue ? '{nt}' + digitalFlopUnit : '{nt}' + (digitalFlopUnit || '%'),
        number: [displayValue],
        style: digitalFlopStyle,
        toFixed: digitalFlopToFixed
      };
    },
    ringName: function ringName() {
      var mergedConfig = this.mergedConfig,
          activeIndex = this.activeIndex;


      if (!mergedConfig) return '';

      return mergedConfig.data[activeIndex].name;
    },
    fontSize: function fontSize() {
      var mergedConfig = this.mergedConfig;


      if (!mergedConfig) return '';

      return 'font-size: ' + mergedConfig.digitalFlopStyle.fontSize + 'px;';
    }
  },
  watch: {
    config: function config() {
      var animationHandler = this.animationHandler,
          mergeConfig = this.mergeConfig,
          setRingOption = this.setRingOption;


      clearTimeout(animationHandler);

      this.activeIndex = 0;

      mergeConfig();

      setRingOption();
    }
  },
  methods: {
    init: function init() {
      var initChart = this.initChart,
          mergeConfig = this.mergeConfig,
          setRingOption = this.setRingOption;


      initChart();

      mergeConfig();

      setRingOption();
    },
    initChart: function initChart() {
      var $refs = this.$refs;


      this.chart = new lib_default.a($refs['active-ring-chart']);
    },
    mergeConfig: function mergeConfig() {
      var defaultConfig = this.defaultConfig,
          config = this.config;


      this.mergedConfig = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config || {});
    },
    setRingOption: function setRingOption() {
      var getRingOption = this.getRingOption,
          chart = this.chart,
          ringAnimation = this.ringAnimation;


      var option = getRingOption();

      chart.setOption(option, true);

      ringAnimation();
    },
    getRingOption: function getRingOption() {
      var mergedConfig = this.mergedConfig,
          getRealRadius = this.getRealRadius;


      var radius = getRealRadius();

      mergedConfig.data.forEach(function (dataItem) {
        dataItem.radius = radius;
      });

      return {
        series: [extends_default()({
          type: 'pie'
        }, mergedConfig, {
          outsideLabel: {
            show: false
          }
        })],
        color: mergedConfig.color
      };
    },
    getRealRadius: function getRealRadius() {
      var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var mergedConfig = this.mergedConfig,
          chart = this.chart;
      var radius = mergedConfig.radius,
          activeRadius = mergedConfig.activeRadius,
          lineWidth = mergedConfig.lineWidth;


      var maxRadius = Math.min.apply(Math, toConsumableArray_default()(chart.render.area)) / 2;

      var halfLineWidth = lineWidth / 2;

      var realRadius = active ? activeRadius : radius;

      if (typeof realRadius !== 'number') realRadius = parseInt(realRadius) / 100 * maxRadius;

      var insideRadius = realRadius - halfLineWidth;
      var outSideRadius = realRadius + halfLineWidth;

      return [insideRadius, outSideRadius];
    },
    ringAnimation: function ringAnimation() {
      var _this = this;

      var activeIndex = this.activeIndex,
          getRingOption = this.getRingOption,
          chart = this.chart,
          getRealRadius = this.getRealRadius;


      var radius = getRealRadius();
      var active = getRealRadius(true);

      var option = getRingOption();

      var data = option.series[0].data;


      data.forEach(function (dataItem, i) {
        if (i === activeIndex) {
          dataItem.radius = active;
        } else {
          dataItem.radius = radius;
        }
      });

      chart.setOption(option, true);

      var activeTimeGap = option.series[0].activeTimeGap;


      this.animationHandler = setTimeout(function (foo) {
        activeIndex += 1;

        if (activeIndex >= data.length) activeIndex = 0;

        _this.activeIndex = activeIndex;

        _this.ringAnimation();
      }, activeTimeGap);
    }
  },
  mounted: function mounted() {
    var init = this.init;


    init();
  },
  beforeDestroy: function beforeDestroy() {
    var animationHandler = this.animationHandler;


    clearTimeout(animationHandler);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/activeRingChart/src/main.vue


//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var activeRingChart_src_main = ({
  name: 'DvActiveRingChart',
  components: {
    dvDigitalFlop: main["a" /* default */]
  },
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      defaultConfig: {
        /**
         * @description Ring radius
         * @type {String|Number}
         * @default radius = '50%'
         * @example radius = '50%' | 100
         */
        radius: '50%',
        /**
         * @description Active ring radius
         * @type {String|Number}
         * @default activeRadius = '55%'
         * @example activeRadius = '55%' | 110
         */
        activeRadius: '55%',
        /**
         * @description Ring data
         * @type {Array<Object>}
         * @default data = [{ name: '', value: 0 }]
         */
        data: [{ name: '', value: 0 }],
        /**
         * @description Ring line width
         * @type {Number}
         * @default lineWidth = 20
         */
        lineWidth: 20,
        /**
         * @description Active time gap (ms)
         * @type {Number}
         * @default activeTimeGap = 3000
         */
        activeTimeGap: 3000,
        /**
         * @description Ring color (hex|rgb|rgba|color keywords)
         * @type {Array<String>}
         * @default color = [Charts Default Color]
         * @example color = ['#000', 'rgb(0, 0, 0)', 'rgba(0, 0, 0, 1)', 'red']
         */
        color: [],
        /**
         * @description Digital flop style
         * @type {Object}
         */
        digitalFlopStyle: {
          fontSize: 25,
          fill: '#fff'
        },
        /**
         * @description Digital flop toFixed
         * @type {Number}
         */
        digitalFlopToFixed: 0,
        /**
         * @description Digital flop unit
         * @type {String}
         */
        digitalFlopUnit: '',
        /**
         * @description CRender animationCurve
         * @type {String}
         * @default animationCurve = 'easeOutCubic'
         */
        animationCurve: 'easeOutCubic',
        /**
         * @description CRender animationFrame
         * @type {String}
         * @default animationFrame = 50
         */
        animationFrame: 50,
        /**
         * @description showOriginValue
         * @type {Boolean}
         * @default showOriginValue = false
         */
        showOriginValue: false
      },

      mergedConfig: null,

      chart: null,

      activeIndex: 0,

      animationHandler: ''
    };
  },

  computed: {
    digitalFlop: function digitalFlop() {
      var mergedConfig = this.mergedConfig,
          activeIndex = this.activeIndex;


      if (!mergedConfig) return {};

      var digitalFlopStyle = mergedConfig.digitalFlopStyle,
          digitalFlopToFixed = mergedConfig.digitalFlopToFixed,
          data = mergedConfig.data,
          showOriginValue = mergedConfig.showOriginValue,
          digitalFlopUnit = mergedConfig.digitalFlopUnit;


      var value = data.map(function (_ref) {
        var value = _ref.value;
        return value;
      });

      var displayValue = void 0;

      if (showOriginValue) {
        displayValue = value[activeIndex];
      } else {
        var sum = value.reduce(function (all, v) {
          return all + v;
        }, 0);

        var percent = parseFloat(value[activeIndex] / sum * 100) || 0;

        displayValue = percent;
      }

      return {
        content: showOriginValue ? '{nt}' + digitalFlopUnit : '{nt}' + (digitalFlopUnit || '%'),
        number: [displayValue],
        style: digitalFlopStyle,
        toFixed: digitalFlopToFixed
      };
    },
    ringName: function ringName() {
      var mergedConfig = this.mergedConfig,
          activeIndex = this.activeIndex;


      if (!mergedConfig) return '';

      return mergedConfig.data[activeIndex].name;
    },
    fontSize: function fontSize() {
      var mergedConfig = this.mergedConfig;


      if (!mergedConfig) return '';

      return 'font-size: ' + mergedConfig.digitalFlopStyle.fontSize + 'px;';
    }
  },
  watch: {
    config: function config() {
      var animationHandler = this.animationHandler,
          mergeConfig = this.mergeConfig,
          setRingOption = this.setRingOption;


      clearTimeout(animationHandler);

      this.activeIndex = 0;

      mergeConfig();

      setRingOption();
    }
  },
  methods: {
    init: function init() {
      var initChart = this.initChart,
          mergeConfig = this.mergeConfig,
          setRingOption = this.setRingOption;


      initChart();

      mergeConfig();

      setRingOption();
    },
    initChart: function initChart() {
      var $refs = this.$refs;


      this.chart = new lib_default.a($refs['active-ring-chart']);
    },
    mergeConfig: function mergeConfig() {
      var defaultConfig = this.defaultConfig,
          config = this.config;


      this.mergedConfig = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config || {});
    },
    setRingOption: function setRingOption() {
      var getRingOption = this.getRingOption,
          chart = this.chart,
          ringAnimation = this.ringAnimation;


      var option = getRingOption();

      chart.setOption(option, true);

      ringAnimation();
    },
    getRingOption: function getRingOption() {
      var mergedConfig = this.mergedConfig,
          getRealRadius = this.getRealRadius;


      var radius = getRealRadius();

      mergedConfig.data.forEach(function (dataItem) {
        dataItem.radius = radius;
      });

      return {
        series: [extends_default()({
          type: 'pie'
        }, mergedConfig, {
          outsideLabel: {
            show: false
          }
        })],
        color: mergedConfig.color
      };
    },
    getRealRadius: function getRealRadius() {
      var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var mergedConfig = this.mergedConfig,
          chart = this.chart;
      var radius = mergedConfig.radius,
          activeRadius = mergedConfig.activeRadius,
          lineWidth = mergedConfig.lineWidth;


      var maxRadius = Math.min.apply(Math, toConsumableArray_default()(chart.render.area)) / 2;

      var halfLineWidth = lineWidth / 2;

      var realRadius = active ? activeRadius : radius;

      if (typeof realRadius !== 'number') realRadius = parseInt(realRadius) / 100 * maxRadius;

      var insideRadius = realRadius - halfLineWidth;
      var outSideRadius = realRadius + halfLineWidth;

      return [insideRadius, outSideRadius];
    },
    ringAnimation: function ringAnimation() {
      var _this = this;

      var activeIndex = this.activeIndex,
          getRingOption = this.getRingOption,
          chart = this.chart,
          getRealRadius = this.getRealRadius;


      var radius = getRealRadius();
      var active = getRealRadius(true);

      var option = getRingOption();

      var data = option.series[0].data;


      data.forEach(function (dataItem, i) {
        if (i === activeIndex) {
          dataItem.radius = active;
        } else {
          dataItem.radius = radius;
        }
      });

      chart.setOption(option, true);

      var activeTimeGap = option.series[0].activeTimeGap;


      this.animationHandler = setTimeout(function (foo) {
        activeIndex += 1;

        if (activeIndex >= data.length) activeIndex = 0;

        _this.activeIndex = activeIndex;

        _this.ringAnimation();
      }, activeTimeGap);
    }
  },
  mounted: function mounted() {
    var init = this.init;


    init();
  },
  beforeDestroy: function beforeDestroy() {
    var animationHandler = this.animationHandler;


    clearTimeout(animationHandler);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cd75252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/activeRingChart/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dv-active-ring-chart"},[_c('div',{ref:"active-ring-chart",staticClass:"active-ring-chart-container"}),_vm._v(" "),_c('div',{staticClass:"active-ring-info"},[_c('dv-digital-flop',{attrs:{"config":_vm.digitalFlop}}),_vm._v(" "),_c('div',{staticClass:"active-ring-name",style:(_vm.fontSize)},[_vm._v(_vm._s(_vm.ringName))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_activeRingChart_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/activeRingChart/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  activeRingChart_src_main,
  components_activeRingChart_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var lib_components_activeRingChart_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WkBw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XMhG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/index.js
var lib = __webpack_require__("TzJp");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/extend/index.js
var extend = __webpack_require__("5/ib");
var extend_default = /*#__PURE__*/__webpack_require__.n(extend);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/digitalFlop/src/main.vue

//
//
//
//
//
//









/* harmony default export */ var main = ({
  name: 'DvDigitalFlop',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      renderer: null,

      defaultConfig: {
        /**
         * @description Number for digital flop
         * @type {Array<Number>}
         * @default number = []
         * @example number = [10]
         */
        number: [],
        /**
         * @description Content formatter
         * @type {String}
         * @default content = ''
         * @example content = '{nt}个'
         */
        content: '',
        /**
         * @description Number toFixed
         * @type {Number}
         * @default toFixed = 0
         */
        toFixed: 0,
        /**
         * @description Text align
         * @type {String}
         * @default textAlign = 'center'
         * @example textAlign = 'center' | 'left' | 'right'
         */
        textAlign: 'center',
        /**
         * @description rowGap
         * @type {Number}
         @default rowGap = 0
         */
        rowGap: 0,
        /**
         * @description Text style configuration
         * @type {Object} {CRender Class Style}
         */
        style: {
          fontSize: 30,
          fill: '#3de7c9'
        },
        /**
         * @description Number formatter
         * @type {Null|Function}
         */
        formatter: undefined,
        /**
         * @description CRender animationCurve
         * @type {String}
         * @default animationCurve = 'easeOutCubic'
         */
        animationCurve: 'easeOutCubic',
        /**
         * @description CRender animationFrame
         * @type {String}
         * @default animationFrame = 50
         */
        animationFrame: 50
      },

      mergedConfig: null,

      graph: null
    };
  },

  watch: {
    config: function config() {
      var update = this.update;


      update();
    }
  },
  methods: {
    init: function init() {
      var initRender = this.initRender,
          mergeConfig = this.mergeConfig,
          initGraph = this.initGraph;


      initRender();

      mergeConfig();

      initGraph();
    },
    initRender: function initRender() {
      var $refs = this.$refs;


      this.renderer = new lib_default.a($refs['digital-flop']);
    },
    mergeConfig: function mergeConfig() {
      var defaultConfig = this.defaultConfig,
          config = this.config;


      this.mergedConfig = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config || {});
    },
    initGraph: function initGraph() {
      var getShape = this.getShape,
          getStyle = this.getStyle,
          renderer = this.renderer,
          mergedConfig = this.mergedConfig;
      var animationCurve = mergedConfig.animationCurve,
          animationFrame = mergedConfig.animationFrame;


      var shape = getShape();
      var style = getStyle();

      this.graph = renderer.add({
        name: 'numberText',
        animationCurve: animationCurve,
        animationFrame: animationFrame,
        shape: shape,
        style: style
      });
    },
    getShape: function getShape() {
      var _mergedConfig = this.mergedConfig,
          number = _mergedConfig.number,
          content = _mergedConfig.content,
          toFixed = _mergedConfig.toFixed,
          textAlign = _mergedConfig.textAlign,
          rowGap = _mergedConfig.rowGap,
          formatter = _mergedConfig.formatter;

      var _renderer$area = slicedToArray_default()(this.renderer.area, 2),
          w = _renderer$area[0],
          h = _renderer$area[1];

      var position = [w / 2, h / 2];

      if (textAlign === 'left') position[0] = 0;
      if (textAlign === 'right') position[0] = w;

      return {
        number: number,
        content: content,
        toFixed: toFixed,
        position: position,
        rowGap: rowGap,
        formatter: formatter
      };
    },
    getStyle: function getStyle() {
      var _mergedConfig2 = this.mergedConfig,
          style = _mergedConfig2.style,
          textAlign = _mergedConfig2.textAlign;


      return Object(util["deepMerge"])(style, {
        textAlign: textAlign,
        textBaseline: 'middle'
      });
    },
    update: function update() {
      var mergeConfig = this.mergeConfig,
          mergeShape = this.mergeShape,
          getShape = this.getShape,
          getStyle = this.getStyle,
          graph = this.graph,
          mergedConfig = this.mergedConfig;


      graph.animationEnd();

      mergeConfig();

      if (!graph) return;

      var animationCurve = mergedConfig.animationCurve,
          animationFrame = mergedConfig.animationFrame;


      var shape = getShape();
      var style = getStyle();

      mergeShape(graph, shape);

      graph.animationCurve = animationCurve;
      graph.animationFrame = animationFrame;

      graph.animation('style', style, true);
      graph.animation('shape', shape);
    },
    mergeShape: function mergeShape(graph, shape) {
      var cacheNum = graph.shape.number.length;
      var shapeNum = shape.number.length;

      if (cacheNum !== shapeNum) graph.shape.number = shape.number;
    }
  },
  mounted: function mounted() {
    var init = this.init;


    init();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/digitalFlop/src/main.vue

//
//
//
//
//
//









/* harmony default export */ var src_main = ({
  name: 'DvDigitalFlop',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      renderer: null,

      defaultConfig: {
        /**
         * @description Number for digital flop
         * @type {Array<Number>}
         * @default number = []
         * @example number = [10]
         */
        number: [],
        /**
         * @description Content formatter
         * @type {String}
         * @default content = ''
         * @example content = '{nt}个'
         */
        content: '',
        /**
         * @description Number toFixed
         * @type {Number}
         * @default toFixed = 0
         */
        toFixed: 0,
        /**
         * @description Text align
         * @type {String}
         * @default textAlign = 'center'
         * @example textAlign = 'center' | 'left' | 'right'
         */
        textAlign: 'center',
        /**
         * @description rowGap
         * @type {Number}
         @default rowGap = 0
         */
        rowGap: 0,
        /**
         * @description Text style configuration
         * @type {Object} {CRender Class Style}
         */
        style: {
          fontSize: 30,
          fill: '#3de7c9'
        },
        /**
         * @description Number formatter
         * @type {Null|Function}
         */
        formatter: undefined,
        /**
         * @description CRender animationCurve
         * @type {String}
         * @default animationCurve = 'easeOutCubic'
         */
        animationCurve: 'easeOutCubic',
        /**
         * @description CRender animationFrame
         * @type {String}
         * @default animationFrame = 50
         */
        animationFrame: 50
      },

      mergedConfig: null,

      graph: null
    };
  },

  watch: {
    config: function config() {
      var update = this.update;


      update();
    }
  },
  methods: {
    init: function init() {
      var initRender = this.initRender,
          mergeConfig = this.mergeConfig,
          initGraph = this.initGraph;


      initRender();

      mergeConfig();

      initGraph();
    },
    initRender: function initRender() {
      var $refs = this.$refs;


      this.renderer = new lib_default.a($refs['digital-flop']);
    },
    mergeConfig: function mergeConfig() {
      var defaultConfig = this.defaultConfig,
          config = this.config;


      this.mergedConfig = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config || {});
    },
    initGraph: function initGraph() {
      var getShape = this.getShape,
          getStyle = this.getStyle,
          renderer = this.renderer,
          mergedConfig = this.mergedConfig;
      var animationCurve = mergedConfig.animationCurve,
          animationFrame = mergedConfig.animationFrame;


      var shape = getShape();
      var style = getStyle();

      this.graph = renderer.add({
        name: 'numberText',
        animationCurve: animationCurve,
        animationFrame: animationFrame,
        shape: shape,
        style: style
      });
    },
    getShape: function getShape() {
      var _mergedConfig = this.mergedConfig,
          number = _mergedConfig.number,
          content = _mergedConfig.content,
          toFixed = _mergedConfig.toFixed,
          textAlign = _mergedConfig.textAlign,
          rowGap = _mergedConfig.rowGap,
          formatter = _mergedConfig.formatter;

      var _renderer$area = slicedToArray_default()(this.renderer.area, 2),
          w = _renderer$area[0],
          h = _renderer$area[1];

      var position = [w / 2, h / 2];

      if (textAlign === 'left') position[0] = 0;
      if (textAlign === 'right') position[0] = w;

      return {
        number: number,
        content: content,
        toFixed: toFixed,
        position: position,
        rowGap: rowGap,
        formatter: formatter
      };
    },
    getStyle: function getStyle() {
      var _mergedConfig2 = this.mergedConfig,
          style = _mergedConfig2.style,
          textAlign = _mergedConfig2.textAlign;


      return Object(util["deepMerge"])(style, {
        textAlign: textAlign,
        textBaseline: 'middle'
      });
    },
    update: function update() {
      var mergeConfig = this.mergeConfig,
          mergeShape = this.mergeShape,
          getShape = this.getShape,
          getStyle = this.getStyle,
          graph = this.graph,
          mergedConfig = this.mergedConfig;


      graph.animationEnd();

      mergeConfig();

      if (!graph) return;

      var animationCurve = mergedConfig.animationCurve,
          animationFrame = mergedConfig.animationFrame;


      var shape = getShape();
      var style = getStyle();

      mergeShape(graph, shape);

      graph.animationCurve = animationCurve;
      graph.animationFrame = animationFrame;

      graph.animation('style', style, true);
      graph.animation('shape', shape);
    },
    mergeShape: function mergeShape(graph, shape) {
      var cacheNum = graph.shape.number.length;
      var shapeNum = shape.number.length;

      if (cacheNum !== shapeNum) graph.shape.number = shape.number;
    }
  },
  mounted: function mounted() {
    var init = this.init;


    init();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d55478c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/digitalFlop/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dv-digital-flop"},[_c('canvas',{ref:"digital-flop"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var digitalFlop_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/digitalFlop/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  digitalFlop_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_digitalFlop_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @ts-nocheck
_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
  mode: 'hash',
  base: __dirname,
  //路由映射map
  routes: [{ path: '/', redirect: '/index/login' }, { path: '*', redirect: '/index/login' }, {
    path: '/index',
    name: 'index',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dAjm")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    children: [{
      path: '/index/login',
      name: 'login',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("K31e")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/index/home',
      name: 'home',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wUZA")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }]
  }]
});
exports.default = router;
/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ "Zy5R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/util/index.js
var util = __webpack_require__("3e7c");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var lib_util = __webpack_require__("9A4f");
var lib_util_default = /*#__PURE__*/__webpack_require__.n(lib_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/color/lib/index.js
var lib = __webpack_require__("glc7");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox12/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var main = ({
  name: 'DvBorderBox12',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      ref: 'border-box-12',
      filterId: 'borderr-box-12-filterId-' + id,

      defaultColor: ['#2e6099', '#7ce7fd'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    },

    fade: lib["fade"]
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox12/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var src_main = ({
  name: 'DvBorderBox12',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      ref: 'border-box-12',
      filterId: 'borderr-box-12-filterId-' + id,

      defaultColor: ['#2e6099', '#7ce7fd'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    },

    fade: lib["fade"]
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-460c1118","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox12/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-border-box-12"},[_c('svg',{staticClass:"dv-border-svg-container",attrs:{"width":_vm.width,"height":_vm.height}},[_c('defs',[_c('filter',{attrs:{"id":_vm.filterId,"height":"150%","width":"150%","x":"-25%","y":"-25%"}},[_c('feMorphology',{attrs:{"operator":"dilate","radius":"1","in":"SourceAlpha","result":"thicken"}}),_vm._v(" "),_c('feGaussianBlur',{attrs:{"in":"thicken","stdDeviation":"2","result":"blurred"}}),_vm._v(" "),_c('feFlood',{attrs:{"flood-color":_vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 70),"result":"glowColor"}},[_c('animate',{attrs:{"attributeName":"flood-color","values":("\n              " + (_vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 70)) + ";\n              " + (_vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 30)) + ";\n              " + (_vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 70)) + ";\n            "),"dur":"3s","begin":"0s","repeatCount":"indefinite"}})]),_vm._v(" "),_c('feComposite',{attrs:{"in":"glowColor","in2":"blurred","operator":"in","result":"softGlowColored"}}),_vm._v(" "),_c('feMerge',[_c('feMergeNode',{attrs:{"in":"softGlowColored"}}),_vm._v(" "),_c('feMergeNode',{attrs:{"in":"SourceGraphic"}})],1)],1)]),_vm._v(" "),(_vm.width && _vm.height)?_c('path',{attrs:{"fill":_vm.backgroundColor,"stroke-width":"2","stroke":_vm.mergedColor[0],"d":("\n        M15 5 L " + (_vm.width - 15) + " 5 Q " + (_vm.width - 5) + " 5, " + (_vm.width - 5) + " 15\n        L " + (_vm.width - 5) + " " + (_vm.height - 15) + " Q " + (_vm.width - 5) + " " + (_vm.height - 5) + ", " + (_vm.width - 15) + " " + (_vm.height - 5) + "\n        L 15, " + (_vm.height - 5) + " Q 5 " + (_vm.height - 5) + " 5 " + (_vm.height - 15) + " L 5 15\n        Q 5 5 15 5\n      ")}}):_vm._e(),_vm._v(" "),_c('path',{attrs:{"stroke-width":"2","fill":"transparent","stroke-linecap":"round","filter":("url(#" + _vm.filterId + ")"),"stroke":_vm.mergedColor[1],"d":"M 20 5 L 15 5 Q 5 5 5 15 L 5 20"}}),_vm._v(" "),_c('path',{attrs:{"stroke-width":"2","fill":"transparent","stroke-linecap":"round","filter":("url(#" + _vm.filterId + ")"),"stroke":_vm.mergedColor[1],"d":("M " + (_vm.width - 20) + " 5 L " + (_vm.width - 15) + " 5 Q " + (_vm.width - 5) + " 5 " + (_vm.width - 5) + " 15 L " + (_vm.width - 5) + " 20")}}),_vm._v(" "),_c('path',{attrs:{"stroke-width":"2","fill":"transparent","stroke-linecap":"round","filter":("url(#" + _vm.filterId + ")"),"stroke":_vm.mergedColor[1],"d":("\n        M " + (_vm.width - 20) + " " + (_vm.height - 5) + " L " + (_vm.width - 15) + " " + (_vm.height - 5) + "\n        Q " + (_vm.width - 5) + " " + (_vm.height - 5) + " " + (_vm.width - 5) + " " + (_vm.height - 15) + "\n        L " + (_vm.width - 5) + " " + (_vm.height - 20) + "\n      ")}}),_vm._v(" "),_c('path',{attrs:{"stroke-width":"2","fill":"transparent","stroke-linecap":"round","filter":("url(#" + _vm.filterId + ")"),"stroke":_vm.mergedColor[1],"d":("\n        M 20 " + (_vm.height - 5) + " L 15 " + (_vm.height - 5) + "\n        Q 5 " + (_vm.height - 5) + " 5 " + (_vm.height - 15) + "\n        L 5 " + (_vm.height - 20) + "\n      ")}})]),_vm._v(" "),_c('div',{staticClass:"border-box-content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var borderBox12_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/borderBox12/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  borderBox12_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_borderBox12_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aBM5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/color/lib/index.js
var lib = __webpack_require__("glc7");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration11/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var main = ({
  name: 'DvDecoration11',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      ref: 'decoration-11',

      defaultColor: ['#1a98fc', '#2cf7fe'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    },

    fade: lib["fade"]
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration11/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var src_main = ({
  name: 'DvDecoration11',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      ref: 'decoration-11',

      defaultColor: ['#1a98fc', '#2cf7fe'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    },

    fade: lib["fade"]
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3e466e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration11/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-decoration-11"},[_c('svg',{attrs:{"width":_vm.width,"height":_vm.height}},[_c('polygon',{attrs:{"fill":_vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 10),"stroke":_vm.mergedColor[1],"points":"20 10, 25 4, 55 4 60 10"}}),_vm._v(" "),_c('polygon',{attrs:{"fill":_vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 10),"stroke":_vm.mergedColor[1],"points":("20 " + (_vm.height - 10) + ", 25 " + (_vm.height - 4) + ", 55 " + (_vm.height - 4) + " 60 " + (_vm.height - 10))}}),_vm._v(" "),_c('polygon',{attrs:{"fill":_vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 10),"stroke":_vm.mergedColor[1],"points":((_vm.width - 20) + " 10, " + (_vm.width - 25) + " 4, " + (_vm.width - 55) + " 4 " + (_vm.width - 60) + " 10")}}),_vm._v(" "),_c('polygon',{attrs:{"fill":_vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 10),"stroke":_vm.mergedColor[1],"points":((_vm.width - 20) + " " + (_vm.height - 10) + ", " + (_vm.width - 25) + " " + (_vm.height - 4) + ", " + (_vm.width - 55) + " " + (_vm.height - 4) + " " + (_vm.width - 60) + " " + (_vm.height - 10))}}),_vm._v(" "),_c('polygon',{attrs:{"fill":_vm.fade(_vm.mergedColor[0] || _vm.defaultColor[0], 20),"stroke":_vm.mergedColor[0],"points":("\n        20 10, 5 " + (_vm.height / 2) + " 20 " + (_vm.height - 10) + "\n        " + (_vm.width - 20) + " " + (_vm.height - 10) + " " + (_vm.width - 5) + " " + (_vm.height / 2) + " " + (_vm.width - 20) + " 10\n      ")}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"transparent","stroke":_vm.fade(_vm.mergedColor[0] || _vm.defaultColor[0], 70),"points":("25 18, 15 " + (_vm.height / 2) + " 25 " + (_vm.height - 18))}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"transparent","stroke":_vm.fade(_vm.mergedColor[0] || _vm.defaultColor[0], 70),"points":((_vm.width - 25) + " 18, " + (_vm.width - 15) + " " + (_vm.height / 2) + " " + (_vm.width - 25) + " " + (_vm.height - 18))}})]),_vm._v(" "),_c('div',{staticClass:"decoration-content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var decoration11_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/decoration11/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  decoration11_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_decoration11_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "abaV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "acHp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox3/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvBorderBox3',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-3',

      defaultColor: ['#2862b7', '#2862b7'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox3/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvBorderBox3',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-3',

      defaultColor: ['#2862b7', '#2862b7'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-580afe41","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox3/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-border-box-3"},[_c('svg',{staticClass:"dv-border-svg-container",attrs:{"width":_vm.width,"height":_vm.height}},[_c('polygon',{attrs:{"fill":_vm.backgroundColor,"points":("\n      23, 23 " + (_vm.width - 24) + ", 23 " + (_vm.width - 24) + ", " + (_vm.height - 24) + " 23, " + (_vm.height - 24) + "\n    ")}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb3-line1",attrs:{"stroke":_vm.mergedColor[0],"points":("4, 4 " + (_vm.width - 22) + " ,4 " + (_vm.width - 22) + ", " + (_vm.height - 22) + " 4, " + (_vm.height - 22) + " 4, 4")}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb3-line2",attrs:{"stroke":_vm.mergedColor[1],"points":("10, 10 " + (_vm.width - 16) + ", 10 " + (_vm.width - 16) + ", " + (_vm.height - 16) + " 10, " + (_vm.height - 16) + " 10, 10")}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb3-line2",attrs:{"stroke":_vm.mergedColor[1],"points":("16, 16 " + (_vm.width - 10) + ", 16 " + (_vm.width - 10) + ", " + (_vm.height - 10) + " 16, " + (_vm.height - 10) + " 16, 16")}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb3-line2",attrs:{"stroke":_vm.mergedColor[1],"points":("22, 22 " + (_vm.width - 4) + ", 22 " + (_vm.width - 4) + ", " + (_vm.height - 4) + " 22, " + (_vm.height - 4) + " 22, 22")}})]),_vm._v(" "),_c('div',{staticClass:"border-box-content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var borderBox3_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/borderBox3/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  borderBox3_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_borderBox3_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bQSR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bX3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/util/index.js
var util = __webpack_require__("3e7c");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var lib_util = __webpack_require__("9A4f");
var lib_util_default = /*#__PURE__*/__webpack_require__.n(lib_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/index.js
var lib = __webpack_require__("TzJp");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/waterLevelPond/src/main.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var main = ({
  name: 'DvWaterLevelPond',
  props: {
    config: Object,
    default: function _default() {
      return {};
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      gradientId: 'water-level-pond-' + id,

      defaultConfig: {
        /**
         * @description Data
         * @type {Array<Number>}
         * @default data = []
         * @example data = [60, 40]
         */
        data: [],
        /**
         * @description Shape of wanter level pond
         * @type {String}
         * @default shape = 'rect'
         * @example shape = 'rect' | 'roundRect' | 'round'
         */
        shape: 'rect',
        /**
         * @description Water wave number
         * @type {Number}
         * @default waveNum = 3
         */
        waveNum: 3,
        /**
         * @description Water wave height (px)
         * @type {Number}
         * @default waveHeight = 40
         */
        waveHeight: 40,
        /**
         * @description Wave opacity
         * @type {Number}
         * @default waveOpacity = 0.4
         */
        waveOpacity: 0.4,
        /**
         * @description Colors (hex|rgb|rgba|color keywords)
         * @type {Array<String>}
         * @default colors = ['#00BAFF', '#3DE7C9']
         * @example colors = ['#000', 'rgb(0, 0, 0)', 'rgba(0, 0, 0, 1)', 'red']
         */
        colors: ['#3DE7C9', '#00BAFF'],
        /**
         * @description Formatter
         * @type {String}
         * @default formatter = '{value}%'
         */
        formatter: '{value}%'
      },

      mergedConfig: {},

      renderer: null,

      svgBorderGradient: [],

      details: '',

      waves: [],

      animation: false
    };
  },

  computed: {
    radius: function radius() {
      var shape = this.mergedConfig.shape;


      if (shape === 'round') return '50%';

      if (shape === 'rect') return '0';

      if (shape === 'roundRect') return '10px';

      return '0';
    },
    shape: function shape() {
      var shape = this.mergedConfig.shape;


      if (!shape) return 'rect';

      return shape;
    }
  },
  watch: {
    config: function config() {
      var calcData = this.calcData,
          renderer = this.renderer;


      renderer.delAllGraph();

      this.waves = [];

      setTimeout(calcData, 0);
    }
  },
  methods: {
    init: function init() {
      var initRender = this.initRender,
          config = this.config,
          calcData = this.calcData;


      initRender();

      if (!config) return;

      calcData();
    },
    initRender: function initRender() {
      var $refs = this.$refs;


      this.renderer = new lib_default.a($refs['water-pond-level']);
    },
    calcData: function calcData() {
      var mergeConfig = this.mergeConfig,
          calcSvgBorderGradient = this.calcSvgBorderGradient,
          calcDetails = this.calcDetails;


      mergeConfig();

      calcSvgBorderGradient();

      calcDetails();

      var addWave = this.addWave,
          animationWave = this.animationWave;


      addWave();

      animationWave();
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      this.mergedConfig = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config);
    },
    calcSvgBorderGradient: function calcSvgBorderGradient() {
      var colors = this.mergedConfig.colors;


      var colorNum = colors.length;

      var colorOffsetGap = 100 / (colorNum - 1);

      this.svgBorderGradient = colors.map(function (c, i) {
        return [colorOffsetGap * i, c];
      });
    },
    calcDetails: function calcDetails() {
      var _mergedConfig = this.mergedConfig,
          data = _mergedConfig.data,
          formatter = _mergedConfig.formatter;


      if (!data.length) {
        this.details = '';

        return;
      }

      var maxValue = Math.max.apply(Math, toConsumableArray_default()(data));

      this.details = formatter.replace('{value}', maxValue);
    },
    addWave: function addWave() {
      var renderer = this.renderer,
          getWaveShapes = this.getWaveShapes,
          getWaveStyle = this.getWaveStyle,
          drawed = this.drawed;


      var shapes = getWaveShapes();
      var style = getWaveStyle();

      this.waves = shapes.map(function (shape) {
        return renderer.add({
          name: 'smoothline',
          animationFrame: 300,
          shape: shape,
          style: style,
          drawed: drawed
        });
      });
    },
    getWaveShapes: function getWaveShapes() {
      var mergedConfig = this.mergedConfig,
          renderer = this.renderer,
          mergeOffset = this.mergeOffset;
      var waveNum = mergedConfig.waveNum,
          waveHeight = mergedConfig.waveHeight,
          data = mergedConfig.data;

      var _renderer$area = slicedToArray_default()(renderer.area, 2),
          w = _renderer$area[0],
          h = _renderer$area[1];

      var pointsNum = waveNum * 4 + 4;

      var pointXGap = w / waveNum / 2;

      return data.map(function (v) {
        var points = new Array(pointsNum).fill(0).map(function (foo, j) {
          var x = w - pointXGap * j;

          var startY = (1 - v / 100) * h;

          var y = j % 2 === 0 ? startY : startY - waveHeight;

          return [x, y];
        });

        points = points.map(function (p) {
          return mergeOffset(p, [pointXGap * 2, 0]);
        });

        return { points: points };
      });
    },
    mergeOffset: function mergeOffset(_ref, _ref2) {
      var _ref4 = slicedToArray_default()(_ref, 2),
          x = _ref4[0],
          y = _ref4[1];

      var _ref3 = slicedToArray_default()(_ref2, 2),
          ox = _ref3[0],
          oy = _ref3[1];

      return [x + ox, y + oy];
    },
    getWaveStyle: function getWaveStyle() {
      var renderer = this.renderer,
          mergedConfig = this.mergedConfig;


      var h = renderer.area[1];

      return {
        gradientColor: mergedConfig.colors,
        gradientType: 'linear',
        gradientParams: [0, 0, 0, h],
        gradientWith: 'fill',
        opacity: mergedConfig.waveOpacity,
        translate: [0, 0]
      };
    },
    drawed: function drawed(_ref5, _ref6) {
      var points = _ref5.shape.points;
      var ctx = _ref6.ctx,
          area = _ref6.area;

      var firstPoint = points[0];
      var lastPoint = points.slice(-1)[0];

      var h = area[1];

      ctx.lineTo(lastPoint[0], h);
      ctx.lineTo(firstPoint[0], h);

      ctx.closePath();

      ctx.fill();
    },
    animationWave: function animationWave() {
      var _this = this;

      var repeat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var waves, renderer, animation, w;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                waves = _this.waves, renderer = _this.renderer, animation = _this.animation;

                if (!animation) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:

                _this.animation = true;

                w = renderer.area[0];


                waves.forEach(function (graph) {
                  graph.attr('style', { translate: [0, 0] });

                  graph.animation('style', {
                    translate: [w, 0]
                  }, true);
                });

                _context.next = 8;
                return renderer.launchAnimation();

              case 8:

                _this.animation = false;

                if (renderer.graphs.length) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt('return');

              case 11:

                _this.animationWave(repeat + 1);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    var init = this.init;


    init();
  },
  beforeDestroy: function beforeDestroy() {
    var renderer = this.renderer;


    renderer.delAllGraph();

    this.waves = [];
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/waterLevelPond/src/main.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var src_main = ({
  name: 'DvWaterLevelPond',
  props: {
    config: Object,
    default: function _default() {
      return {};
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      gradientId: 'water-level-pond-' + id,

      defaultConfig: {
        /**
         * @description Data
         * @type {Array<Number>}
         * @default data = []
         * @example data = [60, 40]
         */
        data: [],
        /**
         * @description Shape of wanter level pond
         * @type {String}
         * @default shape = 'rect'
         * @example shape = 'rect' | 'roundRect' | 'round'
         */
        shape: 'rect',
        /**
         * @description Water wave number
         * @type {Number}
         * @default waveNum = 3
         */
        waveNum: 3,
        /**
         * @description Water wave height (px)
         * @type {Number}
         * @default waveHeight = 40
         */
        waveHeight: 40,
        /**
         * @description Wave opacity
         * @type {Number}
         * @default waveOpacity = 0.4
         */
        waveOpacity: 0.4,
        /**
         * @description Colors (hex|rgb|rgba|color keywords)
         * @type {Array<String>}
         * @default colors = ['#00BAFF', '#3DE7C9']
         * @example colors = ['#000', 'rgb(0, 0, 0)', 'rgba(0, 0, 0, 1)', 'red']
         */
        colors: ['#3DE7C9', '#00BAFF'],
        /**
         * @description Formatter
         * @type {String}
         * @default formatter = '{value}%'
         */
        formatter: '{value}%'
      },

      mergedConfig: {},

      renderer: null,

      svgBorderGradient: [],

      details: '',

      waves: [],

      animation: false
    };
  },

  computed: {
    radius: function radius() {
      var shape = this.mergedConfig.shape;


      if (shape === 'round') return '50%';

      if (shape === 'rect') return '0';

      if (shape === 'roundRect') return '10px';

      return '0';
    },
    shape: function shape() {
      var shape = this.mergedConfig.shape;


      if (!shape) return 'rect';

      return shape;
    }
  },
  watch: {
    config: function config() {
      var calcData = this.calcData,
          renderer = this.renderer;


      renderer.delAllGraph();

      this.waves = [];

      setTimeout(calcData, 0);
    }
  },
  methods: {
    init: function init() {
      var initRender = this.initRender,
          config = this.config,
          calcData = this.calcData;


      initRender();

      if (!config) return;

      calcData();
    },
    initRender: function initRender() {
      var $refs = this.$refs;


      this.renderer = new lib_default.a($refs['water-pond-level']);
    },
    calcData: function calcData() {
      var mergeConfig = this.mergeConfig,
          calcSvgBorderGradient = this.calcSvgBorderGradient,
          calcDetails = this.calcDetails;


      mergeConfig();

      calcSvgBorderGradient();

      calcDetails();

      var addWave = this.addWave,
          animationWave = this.animationWave;


      addWave();

      animationWave();
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      this.mergedConfig = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config);
    },
    calcSvgBorderGradient: function calcSvgBorderGradient() {
      var colors = this.mergedConfig.colors;


      var colorNum = colors.length;

      var colorOffsetGap = 100 / (colorNum - 1);

      this.svgBorderGradient = colors.map(function (c, i) {
        return [colorOffsetGap * i, c];
      });
    },
    calcDetails: function calcDetails() {
      var _mergedConfig = this.mergedConfig,
          data = _mergedConfig.data,
          formatter = _mergedConfig.formatter;


      if (!data.length) {
        this.details = '';

        return;
      }

      var maxValue = Math.max.apply(Math, toConsumableArray_default()(data));

      this.details = formatter.replace('{value}', maxValue);
    },
    addWave: function addWave() {
      var renderer = this.renderer,
          getWaveShapes = this.getWaveShapes,
          getWaveStyle = this.getWaveStyle,
          drawed = this.drawed;


      var shapes = getWaveShapes();
      var style = getWaveStyle();

      this.waves = shapes.map(function (shape) {
        return renderer.add({
          name: 'smoothline',
          animationFrame: 300,
          shape: shape,
          style: style,
          drawed: drawed
        });
      });
    },
    getWaveShapes: function getWaveShapes() {
      var mergedConfig = this.mergedConfig,
          renderer = this.renderer,
          mergeOffset = this.mergeOffset;
      var waveNum = mergedConfig.waveNum,
          waveHeight = mergedConfig.waveHeight,
          data = mergedConfig.data;

      var _renderer$area = slicedToArray_default()(renderer.area, 2),
          w = _renderer$area[0],
          h = _renderer$area[1];

      var pointsNum = waveNum * 4 + 4;

      var pointXGap = w / waveNum / 2;

      return data.map(function (v) {
        var points = new Array(pointsNum).fill(0).map(function (foo, j) {
          var x = w - pointXGap * j;

          var startY = (1 - v / 100) * h;

          var y = j % 2 === 0 ? startY : startY - waveHeight;

          return [x, y];
        });

        points = points.map(function (p) {
          return mergeOffset(p, [pointXGap * 2, 0]);
        });

        return { points: points };
      });
    },
    mergeOffset: function mergeOffset(_ref, _ref2) {
      var _ref4 = slicedToArray_default()(_ref, 2),
          x = _ref4[0],
          y = _ref4[1];

      var _ref3 = slicedToArray_default()(_ref2, 2),
          ox = _ref3[0],
          oy = _ref3[1];

      return [x + ox, y + oy];
    },
    getWaveStyle: function getWaveStyle() {
      var renderer = this.renderer,
          mergedConfig = this.mergedConfig;


      var h = renderer.area[1];

      return {
        gradientColor: mergedConfig.colors,
        gradientType: 'linear',
        gradientParams: [0, 0, 0, h],
        gradientWith: 'fill',
        opacity: mergedConfig.waveOpacity,
        translate: [0, 0]
      };
    },
    drawed: function drawed(_ref5, _ref6) {
      var points = _ref5.shape.points;
      var ctx = _ref6.ctx,
          area = _ref6.area;

      var firstPoint = points[0];
      var lastPoint = points.slice(-1)[0];

      var h = area[1];

      ctx.lineTo(lastPoint[0], h);
      ctx.lineTo(firstPoint[0], h);

      ctx.closePath();

      ctx.fill();
    },
    animationWave: function animationWave() {
      var _this = this;

      var repeat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var waves, renderer, animation, w;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                waves = _this.waves, renderer = _this.renderer, animation = _this.animation;

                if (!animation) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:

                _this.animation = true;

                w = renderer.area[0];


                waves.forEach(function (graph) {
                  graph.attr('style', { translate: [0, 0] });

                  graph.animation('style', {
                    translate: [w, 0]
                  }, true);
                });

                _context.next = 8;
                return renderer.launchAnimation();

              case 8:

                _this.animation = false;

                if (renderer.graphs.length) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt('return');

              case 11:

                _this.animationWave(repeat + 1);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    var init = this.init;


    init();
  },
  beforeDestroy: function beforeDestroy() {
    var renderer = this.renderer;


    renderer.delAllGraph();

    this.waves = [];
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fde64310","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/waterLevelPond/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dv-water-pond-level"},[(_vm.renderer)?_c('svg',[_c('defs',[_c('linearGradient',{attrs:{"id":_vm.gradientId,"x1":"0%","y1":"0%","x2":"0%","y2":"100%"}},_vm._l((_vm.svgBorderGradient),function(lc){return _c('stop',{key:lc[0],attrs:{"offset":lc[0],"stop-color":lc[1]}})}),1)],1),_vm._v(" "),(_vm.renderer)?_c('text',{attrs:{"stroke":("url(#" + _vm.gradientId + ")"),"fill":("url(#" + _vm.gradientId + ")"),"x":_vm.renderer.area[0] / 2 + 8,"y":_vm.renderer.area[1] / 2 + 8}},[_vm._v("\n      "+_vm._s(_vm.details)+"\n    ")]):_vm._e(),_vm._v(" "),(!_vm.shape || _vm.shape === 'round')?_c('ellipse',{attrs:{"cx":_vm.renderer.area[0] / 2 + 8,"cy":_vm.renderer.area[1] / 2 + 8,"rx":_vm.renderer.area[0] / 2 + 5,"ry":_vm.renderer.area[1] / 2 + 5,"stroke":("url(#" + _vm.gradientId + ")")}}):_c('rect',{attrs:{"x":"2","y":"2","rx":_vm.shape === 'roundRect' ? 10 : 0,"ry":_vm.shape === 'roundRect' ? 10 : 0,"width":_vm.renderer.area[0] + 12,"height":_vm.renderer.area[1] + 12,"stroke":("url(#" + _vm.gradientId + ")")}})]):_vm._e(),_vm._v(" "),_c('canvas',{ref:"water-pond-level",style:(("border-radius: " + _vm.radius + ";"))})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var waterLevelPond_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/waterLevelPond/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  waterLevelPond_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_waterLevelPond_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bxTc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cEED":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cQII":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration4/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvDecoration4',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    reverse: {
      type: Boolean,
      default: false
    },
    dur: {
      type: Number,
      default: 3
    }
  },
  data: function data() {
    return {
      ref: 'decoration-4',

      defaultColor: ['rgba(255, 255, 255, 0.3)', 'rgba(255, 255, 255, 0.3)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration4/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvDecoration4',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    reverse: {
      type: Boolean,
      default: false
    },
    dur: {
      type: Number,
      default: 3
    }
  },
  data: function data() {
    return {
      ref: 'decoration-4',

      defaultColor: ['rgba(255, 255, 255, 0.3)', 'rgba(255, 255, 255, 0.3)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29f329c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration4/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-decoration-4"},[_c('div',{class:("container " + (_vm.reverse ? 'reverse' : 'normal')),style:(_vm.reverse ? ("width:" + _vm.width + "px;height:5px;animation-duration:" + _vm.dur + "s") : ("width:5px;height:" + _vm.height + "px;animation-duration:" + _vm.dur + "s"))},[_c('svg',{attrs:{"width":_vm.reverse ? _vm.width : 5,"height":_vm.reverse ? 5 : _vm.height}},[_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"points":_vm.reverse ? ("0, 2.5 " + _vm.width + ", 2.5") : ("2.5, 0 2.5, " + _vm.height)}}),_vm._v(" "),_c('polyline',{staticClass:"bold-line",attrs:{"stroke":_vm.mergedColor[1],"stroke-width":"3","stroke-dasharray":"20, 80","stroke-dashoffset":"-30","points":_vm.reverse ? ("0, 2.5 " + _vm.width + ", 2.5") : ("2.5, 0 2.5, " + _vm.height)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var decoration4_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/decoration4/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  decoration4_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_decoration4_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cgqx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/scrollRankingBoard/src/main.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvScrollRankingBoard',
  mixins: [autoResize_default.a],
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      ref: 'scroll-ranking-board',

      defaultConfig: {
        /**
         * @description Board data
         * @type {Array<Object>}
         * @default data = []
         */
        data: [],
        /**
         * @description Row num
         * @type {Number}
         * @default rowNum = 5
         */
        rowNum: 5,
        /**
         * @description Scroll wait time
         * @type {Number}
         * @default waitTime = 2000
         */
        waitTime: 2000,
        /**
         * @description Carousel type
         * @type {String}
         * @default carousel = 'single'
         * @example carousel = 'single' | 'page'
         */
        carousel: 'single',
        /**
         * @description Value unit
         * @type {String}
         * @default unit = ''
         * @example unit = 'ton'
         */
        unit: '',
        /**
         * @description Auto sort by value
         * @type {Boolean}
         * @default sort = true
         */
        sort: true,
        /**
         * @description Value formatter
         * @type {Function}
         * @default valueFormatter = null
         */
        valueFormatter: null
      },

      mergedConfig: null,

      rowsData: [],

      rows: [],

      heights: [],

      animationIndex: 0,

      animationHandler: '',

      updater: 0
    };
  },

  watch: {
    config: function config() {
      var stopAnimation = this.stopAnimation,
          calcData = this.calcData;


      stopAnimation();

      calcData();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcData = this.calcData;


      calcData();
    },
    onResize: function onResize() {
      var mergedConfig = this.mergedConfig,
          calcHeights = this.calcHeights;


      if (!mergedConfig) return;

      calcHeights(true);
    },
    calcData: function calcData() {
      var mergeConfig = this.mergeConfig,
          calcRowsData = this.calcRowsData;


      mergeConfig();

      calcRowsData();

      var calcHeights = this.calcHeights;


      calcHeights();

      var animation = this.animation;


      animation(true);
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      this.mergedConfig = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config || {});
    },
    calcRowsData: function calcRowsData() {
      var _mergedConfig = this.mergedConfig,
          data = _mergedConfig.data,
          rowNum = _mergedConfig.rowNum,
          sort = _mergedConfig.sort;


      sort && data.sort(function (_ref, _ref2) {
        var a = _ref.value;
        var b = _ref2.value;

        if (a > b) return -1;
        if (a < b) return 1;
        if (a === b) return 0;
      });

      var value = data.map(function (_ref3) {
        var value = _ref3.value;
        return value;
      });

      var min = Math.min.apply(Math, toConsumableArray_default()(value)) || 0;

      // abs of min
      var minAbs = Math.abs(min);

      var max = Math.max.apply(Math, toConsumableArray_default()(value)) || 0;

      // abs of max
      var maxAbs = Math.abs(max);

      var total = max + minAbs;

      data = data.map(function (row, i) {
        return extends_default()({}, row, { ranking: i + 1, percent: (row.value + minAbs) / total * 100 });
      });

      var rowLength = data.length;

      if (rowLength > rowNum && rowLength < 2 * rowNum) {
        data = [].concat(toConsumableArray_default()(data), toConsumableArray_default()(data));
      }

      data = data.map(function (d, i) {
        return extends_default()({}, d, { scroll: i });
      });

      this.rowsData = data;
      this.rows = data;
    },
    calcHeights: function calcHeights() {
      var onresize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var height = this.height,
          mergedConfig = this.mergedConfig;
      var rowNum = mergedConfig.rowNum,
          data = mergedConfig.data;


      var avgHeight = height / rowNum;

      this.avgHeight = avgHeight;

      if (!onresize) this.heights = new Array(data.length).fill(avgHeight);
    },
    animation: function animation() {
      var _this = this;

      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _heights;

        var avgHeight, animationIndex, mergedConfig, rowsData, animation, updater, waitTime, carousel, rowNum, rowLength, animationNum, rows, back;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                avgHeight = _this.avgHeight, animationIndex = _this.animationIndex, mergedConfig = _this.mergedConfig, rowsData = _this.rowsData, animation = _this.animation, updater = _this.updater;
                waitTime = mergedConfig.waitTime, carousel = mergedConfig.carousel, rowNum = mergedConfig.rowNum;
                rowLength = rowsData.length;

                if (!(rowNum >= rowLength)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                if (!start) {
                  _context.next = 10;
                  break;
                }

                _context.next = 8;
                return new promise_default.a(function (resolve) {
                  return setTimeout(resolve, waitTime);
                });

              case 8:
                if (!(updater !== _this.updater)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return');

              case 10:
                animationNum = carousel === 'single' ? 1 : rowNum;
                rows = rowsData.slice(animationIndex);

                rows.push.apply(rows, toConsumableArray_default()(rowsData.slice(0, animationIndex)));

                _this.rows = rows.slice(0, rowNum + 1);
                _this.heights = new Array(rowLength).fill(avgHeight);

                _context.next = 17;
                return new promise_default.a(function (resolve) {
                  return setTimeout(resolve, 300);
                });

              case 17:
                if (!(updater !== _this.updater)) {
                  _context.next = 19;
                  break;
                }

                return _context.abrupt('return');

              case 19:

                (_heights = _this.heights).splice.apply(_heights, [0, animationNum].concat(toConsumableArray_default()(new Array(animationNum).fill(0))));

                animationIndex += animationNum;

                back = animationIndex - rowLength;

                if (back >= 0) animationIndex = back;

                _this.animationIndex = animationIndex;
                _this.animationHandler = setTimeout(animation, waitTime - 300);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    stopAnimation: function stopAnimation() {
      var animationHandler = this.animationHandler,
          updater = this.updater;


      this.updater = (updater + 1) % 999999;

      if (!animationHandler) return;

      clearTimeout(animationHandler);
    }
  },
  destroyed: function destroyed() {
    var stopAnimation = this.stopAnimation;


    stopAnimation();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/scrollRankingBoard/src/main.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvScrollRankingBoard',
  mixins: [autoResize_default.a],
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      ref: 'scroll-ranking-board',

      defaultConfig: {
        /**
         * @description Board data
         * @type {Array<Object>}
         * @default data = []
         */
        data: [],
        /**
         * @description Row num
         * @type {Number}
         * @default rowNum = 5
         */
        rowNum: 5,
        /**
         * @description Scroll wait time
         * @type {Number}
         * @default waitTime = 2000
         */
        waitTime: 2000,
        /**
         * @description Carousel type
         * @type {String}
         * @default carousel = 'single'
         * @example carousel = 'single' | 'page'
         */
        carousel: 'single',
        /**
         * @description Value unit
         * @type {String}
         * @default unit = ''
         * @example unit = 'ton'
         */
        unit: '',
        /**
         * @description Auto sort by value
         * @type {Boolean}
         * @default sort = true
         */
        sort: true,
        /**
         * @description Value formatter
         * @type {Function}
         * @default valueFormatter = null
         */
        valueFormatter: null
      },

      mergedConfig: null,

      rowsData: [],

      rows: [],

      heights: [],

      animationIndex: 0,

      animationHandler: '',

      updater: 0
    };
  },

  watch: {
    config: function config() {
      var stopAnimation = this.stopAnimation,
          calcData = this.calcData;


      stopAnimation();

      calcData();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcData = this.calcData;


      calcData();
    },
    onResize: function onResize() {
      var mergedConfig = this.mergedConfig,
          calcHeights = this.calcHeights;


      if (!mergedConfig) return;

      calcHeights(true);
    },
    calcData: function calcData() {
      var mergeConfig = this.mergeConfig,
          calcRowsData = this.calcRowsData;


      mergeConfig();

      calcRowsData();

      var calcHeights = this.calcHeights;


      calcHeights();

      var animation = this.animation;


      animation(true);
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      this.mergedConfig = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config || {});
    },
    calcRowsData: function calcRowsData() {
      var _mergedConfig = this.mergedConfig,
          data = _mergedConfig.data,
          rowNum = _mergedConfig.rowNum,
          sort = _mergedConfig.sort;


      sort && data.sort(function (_ref, _ref2) {
        var a = _ref.value;
        var b = _ref2.value;

        if (a > b) return -1;
        if (a < b) return 1;
        if (a === b) return 0;
      });

      var value = data.map(function (_ref3) {
        var value = _ref3.value;
        return value;
      });

      var min = Math.min.apply(Math, toConsumableArray_default()(value)) || 0;

      // abs of min
      var minAbs = Math.abs(min);

      var max = Math.max.apply(Math, toConsumableArray_default()(value)) || 0;

      // abs of max
      var maxAbs = Math.abs(max);

      var total = max + minAbs;

      data = data.map(function (row, i) {
        return extends_default()({}, row, { ranking: i + 1, percent: (row.value + minAbs) / total * 100 });
      });

      var rowLength = data.length;

      if (rowLength > rowNum && rowLength < 2 * rowNum) {
        data = [].concat(toConsumableArray_default()(data), toConsumableArray_default()(data));
      }

      data = data.map(function (d, i) {
        return extends_default()({}, d, { scroll: i });
      });

      this.rowsData = data;
      this.rows = data;
    },
    calcHeights: function calcHeights() {
      var onresize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var height = this.height,
          mergedConfig = this.mergedConfig;
      var rowNum = mergedConfig.rowNum,
          data = mergedConfig.data;


      var avgHeight = height / rowNum;

      this.avgHeight = avgHeight;

      if (!onresize) this.heights = new Array(data.length).fill(avgHeight);
    },
    animation: function animation() {
      var _this = this;

      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _heights;

        var avgHeight, animationIndex, mergedConfig, rowsData, animation, updater, waitTime, carousel, rowNum, rowLength, animationNum, rows, back;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                avgHeight = _this.avgHeight, animationIndex = _this.animationIndex, mergedConfig = _this.mergedConfig, rowsData = _this.rowsData, animation = _this.animation, updater = _this.updater;
                waitTime = mergedConfig.waitTime, carousel = mergedConfig.carousel, rowNum = mergedConfig.rowNum;
                rowLength = rowsData.length;

                if (!(rowNum >= rowLength)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                if (!start) {
                  _context.next = 10;
                  break;
                }

                _context.next = 8;
                return new promise_default.a(function (resolve) {
                  return setTimeout(resolve, waitTime);
                });

              case 8:
                if (!(updater !== _this.updater)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return');

              case 10:
                animationNum = carousel === 'single' ? 1 : rowNum;
                rows = rowsData.slice(animationIndex);

                rows.push.apply(rows, toConsumableArray_default()(rowsData.slice(0, animationIndex)));

                _this.rows = rows.slice(0, rowNum + 1);
                _this.heights = new Array(rowLength).fill(avgHeight);

                _context.next = 17;
                return new promise_default.a(function (resolve) {
                  return setTimeout(resolve, 300);
                });

              case 17:
                if (!(updater !== _this.updater)) {
                  _context.next = 19;
                  break;
                }

                return _context.abrupt('return');

              case 19:

                (_heights = _this.heights).splice.apply(_heights, [0, animationNum].concat(toConsumableArray_default()(new Array(animationNum).fill(0))));

                animationIndex += animationNum;

                back = animationIndex - rowLength;

                if (back >= 0) animationIndex = back;

                _this.animationIndex = animationIndex;
                _this.animationHandler = setTimeout(animation, waitTime - 300);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    stopAnimation: function stopAnimation() {
      var animationHandler = this.animationHandler,
          updater = this.updater;


      this.updater = (updater + 1) % 999999;

      if (!animationHandler) return;

      clearTimeout(animationHandler);
    }
  },
  destroyed: function destroyed() {
    var stopAnimation = this.stopAnimation;


    stopAnimation();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-045d0900","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/scrollRankingBoard/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-scroll-ranking-board"},_vm._l((_vm.rows),function(item,i){return _c('div',{key:item.toString() + item.scroll,staticClass:"row-item",style:(("height: " + (_vm.heights[i]) + "px;"))},[_c('div',{staticClass:"ranking-info"},[_c('div',{staticClass:"rank"},[_vm._v("No."+_vm._s(item.ranking))]),_vm._v(" "),_c('div',{staticClass:"info-name",domProps:{"innerHTML":_vm._s(item.name)}}),_vm._v(" "),_c('div',{staticClass:"ranking-value"},[_vm._v(_vm._s(_vm.mergedConfig.valueFormatter ? _vm.mergedConfig.valueFormatter(item) : item.value + _vm.mergedConfig.unit))])]),_vm._v(" "),_c('div',{staticClass:"ranking-column"},[_c('div',{staticClass:"inside-column",style:(("width: " + (item.percent) + "%;"))},[_c('div',{staticClass:"shine"})])])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var scrollRankingBoard_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/scrollRankingBoard/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  scrollRankingBoard_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_scrollRankingBoard_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ctr7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d5Tr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration2/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvDecoration2',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    reverse: {
      type: Boolean,
      default: false
    },
    dur: {
      type: Number,
      default: 6
    }
  },
  data: function data() {
    return {
      ref: 'decoration-2',

      x: 0,
      y: 0,

      w: 0,
      h: 0,

      defaultColor: ['#3faacb', '#fff'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    },
    reverse: function reverse() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    calcSVGData: function calcSVGData() {
      var reverse = this.reverse,
          width = this.width,
          height = this.height;


      if (reverse) {
        this.w = 1;
        this.h = height;
        this.x = width / 2;
        this.y = 0;
      } else {
        this.w = width;
        this.h = 1;
        this.x = 0;
        this.y = height / 2;
      }
    },
    onResize: function onResize() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration2/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvDecoration2',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    reverse: {
      type: Boolean,
      default: false
    },
    dur: {
      type: Number,
      default: 6
    }
  },
  data: function data() {
    return {
      ref: 'decoration-2',

      x: 0,
      y: 0,

      w: 0,
      h: 0,

      defaultColor: ['#3faacb', '#fff'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    },
    reverse: function reverse() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    calcSVGData: function calcSVGData() {
      var reverse = this.reverse,
          width = this.width,
          height = this.height;


      if (reverse) {
        this.w = 1;
        this.h = height;
        this.x = width / 2;
        this.y = 0;
      } else {
        this.w = width;
        this.h = 1;
        this.x = 0;
        this.y = height / 2;
      }
    },
    onResize: function onResize() {
      var calcSVGData = this.calcSVGData;


      calcSVGData();
    },
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc7f366c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration2/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-decoration-2"},[_c('svg',{attrs:{"width":(_vm.width + "px"),"height":(_vm.height + "px")}},[_c('rect',{attrs:{"x":_vm.x,"y":_vm.y,"width":_vm.w,"height":_vm.h,"fill":_vm.mergedColor[0]}},[_c('animate',{attrs:{"attributeName":_vm.reverse ? 'height' : 'width',"from":"0","to":_vm.reverse ? _vm.height : _vm.width,"dur":(_vm.dur + "s"),"calcMode":"spline","keyTimes":"0;1","keySplines":".42,0,.58,1","repeatCount":"indefinite"}})]),_vm._v(" "),_c('rect',{attrs:{"x":_vm.x,"y":_vm.y,"width":"1","height":"1","fill":_vm.mergedColor[1]}},[_c('animate',{attrs:{"attributeName":_vm.reverse ? 'y' : 'x',"from":"0","to":_vm.reverse ? _vm.height : _vm.width,"dur":(_vm.dur + "s"),"calcMode":"spline","keyTimes":"0;1","keySplines":"0.42,0,0.58,1","repeatCount":"indefinite"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var decoration2_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/decoration2/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  decoration2_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_decoration2_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dCKE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/loading/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var main = ({
  name: 'DvLoading'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/loading/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var src_main = ({
  name: 'DvLoading'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05f6cd58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/loading/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dv-loading"},[_c('svg',{attrs:{"width":"50px","height":"50px"}},[_c('circle',{attrs:{"cx":"25","cy":"25","r":"20","fill":"transparent","stroke-width":"3","stroke-dasharray":"31.415, 31.415","stroke":"#02bcfe","stroke-linecap":"round"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","values":"0, 25 25;360, 25 25","dur":"1.5s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"stroke","values":"#02bcfe;#3be6cb;#02bcfe","dur":"3s","repeatCount":"indefinite"}})],1),_vm._v(" "),_c('circle',{attrs:{"cx":"25","cy":"25","r":"10","fill":"transparent","stroke-width":"3","stroke-dasharray":"15.7, 15.7","stroke":"#3be6cb","stroke-linecap":"round"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","values":"360, 25 25;0, 25 25","dur":"1.5s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"stroke","values":"#3be6cb;#02bcfe;#3be6cb","dur":"3s","repeatCount":"indefinite"}})],1)]),_vm._v(" "),_c('div',{staticClass:"loading-tip"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var loading_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/loading/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  loading_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_loading_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dR5y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f2hL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fKJ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox6/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvBorderBox6',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-6',

      defaultColor: ['rgba(255, 255, 255, 0.35)', 'gray'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox6/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvBorderBox6',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-6',

      defaultColor: ['rgba(255, 255, 255, 0.35)', 'gray'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7de3177e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox6/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-border-box-6"},[_c('svg',{staticClass:"dv-border-svg-container",attrs:{"width":_vm.width,"height":_vm.height}},[_c('polygon',{attrs:{"fill":_vm.backgroundColor,"points":("\n      9, 7 " + (_vm.width - 9) + ", 7 " + (_vm.width - 9) + ", " + (_vm.height - 7) + " 9, " + (_vm.height - 7) + "\n    ")}}),_vm._v(" "),_c('circle',{attrs:{"fill":_vm.mergedColor[1],"cx":"5","cy":"5","r":"2"}}),_vm._v(" "),_c('circle',{attrs:{"fill":_vm.mergedColor[1],"cx":_vm.width - 5,"cy":"5","r":"2"}}),_vm._v(" "),_c('circle',{attrs:{"fill":_vm.mergedColor[1],"cx":_vm.width - 5,"cy":_vm.height - 5,"r":"2"}}),_vm._v(" "),_c('circle',{attrs:{"fill":_vm.mergedColor[1],"cx":"5","cy":_vm.height - 5,"r":"2"}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"points":("10, 4 " + (_vm.width - 10) + ", 4")}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"points":("10, " + (_vm.height - 4) + " " + (_vm.width - 10) + ", " + (_vm.height - 4))}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"points":("5, 70 5, " + (_vm.height - 70))}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"points":((_vm.width - 5) + ", 70 " + (_vm.width - 5) + ", " + (_vm.height - 70))}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"points":"3, 10, 3, 50"}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"points":"7, 30 7, 80"}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"points":((_vm.width - 3) + ", 10 " + (_vm.width - 3) + ", 50")}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"points":((_vm.width - 7) + ", 30 " + (_vm.width - 7) + ", 80")}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"points":("3, " + (_vm.height - 10) + " 3, " + (_vm.height - 50))}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"points":("7, " + (_vm.height - 30) + " 7, " + (_vm.height - 80))}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"points":((_vm.width - 3) + ", " + (_vm.height - 10) + " " + (_vm.width - 3) + ", " + (_vm.height - 50))}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"points":((_vm.width - 7) + ", " + (_vm.height - 30) + " " + (_vm.width - 7) + ", " + (_vm.height - 80))}})]),_vm._v(" "),_c('div',{staticClass:"border-box-content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var borderBox6_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/borderBox6/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  borderBox6_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_borderBox6_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fli6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g3jD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gUFK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hi57":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jWDM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mwHJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/util/index.js
var util = __webpack_require__("3e7c");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/index.js
var lib = __webpack_require__("z0b2");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/charts/src/main.vue
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvCharts',
  mixins: [autoResize_default.a],
  props: {
    option: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      ref: 'charts-container-' + id,
      chartRef: 'chart-' + id,

      chart: null
    };
  },

  watch: {
    option: function option() {
      var chart = this.chart,
          option = this.option;


      if (!chart) return;

      if (!option) option = {};

      chart.setOption(option, true);
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var initChart = this.initChart;


      initChart();
    },
    initChart: function initChart() {
      var $refs = this.$refs,
          chartRef = this.chartRef,
          option = this.option;


      var chart = this.chart = new lib_default.a($refs[chartRef]);

      if (!option) return;

      chart.setOption(option);
    },
    onResize: function onResize() {
      var chart = this.chart;


      if (!chart) return;

      chart.resize();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/charts/src/main.vue
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvCharts',
  mixins: [autoResize_default.a],
  props: {
    option: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      ref: 'charts-container-' + id,
      chartRef: 'chart-' + id,

      chart: null
    };
  },

  watch: {
    option: function option() {
      var chart = this.chart,
          option = this.option;


      if (!chart) return;

      if (!option) option = {};

      chart.setOption(option, true);
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var initChart = this.initChart;


      initChart();
    },
    initChart: function initChart() {
      var $refs = this.$refs,
          chartRef = this.chartRef,
          option = this.option;


      var chart = this.chart = new lib_default.a($refs[chartRef]);

      if (!option) return;

      chart.setOption(option);
    },
    onResize: function onResize() {
      var chart = this.chart;


      if (!chart) return;

      chart.resize();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d283f50a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/charts/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-charts-container"},[_c('div',{ref:_vm.chartRef,staticClass:"charts-canvas-container"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var charts_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/charts/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  charts_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_charts_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n4z2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/util/index.js
var util = __webpack_require__("3e7c");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var lib_util = __webpack_require__("9A4f");
var lib_util_default = /*#__PURE__*/__webpack_require__.n(lib_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox9/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var main = ({
  name: 'DvBorderBox9',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      ref: 'border-box-9',

      gradientId: 'border-box-9-gradient-' + id,
      maskId: 'border-box-9-mask-' + id,

      defaultColor: ['#11eefd', '#0078d2'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox9/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var src_main = ({
  name: 'DvBorderBox9',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      ref: 'border-box-9',

      gradientId: 'border-box-9-gradient-' + id,
      maskId: 'border-box-9-mask-' + id,

      defaultColor: ['#11eefd', '#0078d2'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8ec3610","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox9/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-border-box-9"},[_c('svg',{staticClass:"dv-border-svg-container",attrs:{"width":_vm.width,"height":_vm.height}},[_c('defs',[_c('linearGradient',{attrs:{"id":_vm.gradientId,"x1":"0%","y1":"0%","x2":"100%","y2":"100%"}},[_c('animate',{attrs:{"attributeName":"x1","values":"0%;100%;0%","dur":"10s","begin":"0s","repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"x2","values":"100%;0%;100%","dur":"10s","begin":"0s","repeatCount":"indefinite"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"0%","stop-color":_vm.mergedColor[0]}},[_c('animate',{attrs:{"attributeName":"stop-color","values":((_vm.mergedColor[0]) + ";" + (_vm.mergedColor[1]) + ";" + (_vm.mergedColor[0])),"dur":"10s","begin":"0s","repeatCount":"indefinite"}})]),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":_vm.mergedColor[1]}},[_c('animate',{attrs:{"attributeName":"stop-color","values":((_vm.mergedColor[1]) + ";" + (_vm.mergedColor[0]) + ";" + (_vm.mergedColor[1])),"dur":"10s","begin":"0s","repeatCount":"indefinite"}})])],1),_vm._v(" "),_c('mask',{attrs:{"id":_vm.maskId}},[_c('polyline',{attrs:{"stroke":"#fff","stroke-width":"3","fill":"transparent","points":("8, " + (_vm.height * 0.4) + " 8, 3, " + (_vm.width * 0.4 + 7) + ", 3")}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#fff","points":("8, " + (_vm.height * 0.15) + " 8, 3, " + (_vm.width * 0.1 + 7) + ", 3\n            " + (_vm.width * 0.1) + ", 8 14, 8 14, " + (_vm.height * 0.15 - 7) + "\n          ")}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":"#fff","stroke-width":"3","fill":"transparent","points":((_vm.width * 0.5) + ", 3 " + (_vm.width - 3) + ", 3, " + (_vm.width - 3) + ", " + (_vm.height * 0.25))}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#fff","points":("\n            " + (_vm.width * 0.52) + ", 3 " + (_vm.width * 0.58) + ", 3\n            " + (_vm.width * 0.58 - 7) + ", 9 " + (_vm.width * 0.52 + 7) + ", 9\n          ")}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#fff","points":("\n            " + (_vm.width * 0.9) + ", 3 " + (_vm.width - 3) + ", 3 " + (_vm.width - 3) + ", " + (_vm.height * 0.1) + "\n            " + (_vm.width - 9) + ", " + (_vm.height * 0.1 - 7) + " " + (_vm.width - 9) + ", 9 " + (_vm.width * 0.9 + 7) + ", 9\n          ")}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":"#fff","stroke-width":"3","fill":"transparent","points":("8, " + (_vm.height * 0.5) + " 8, " + (_vm.height - 3) + " " + (_vm.width * 0.3 + 7) + ", " + (_vm.height - 3))}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#fff","points":("\n            8, " + (_vm.height * 0.55) + " 8, " + (_vm.height * 0.7) + "\n            2, " + (_vm.height * 0.7 - 7) + " 2, " + (_vm.height * 0.55 + 7) + "\n          ")}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":"#fff","stroke-width":"3","fill":"transparent","points":((_vm.width * 0.35) + ", " + (_vm.height - 3) + " " + (_vm.width - 3) + ", " + (_vm.height - 3) + " " + (_vm.width - 3) + ", " + (_vm.height * 0.35))}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#fff","points":("\n            " + (_vm.width * 0.92) + ", " + (_vm.height - 3) + " " + (_vm.width - 3) + ", " + (_vm.height - 3) + " " + (_vm.width - 3) + ", " + (_vm.height * 0.8) + "\n            " + (_vm.width - 9) + ", " + (_vm.height * 0.8 + 7) + " " + (_vm.width - 9) + ", " + (_vm.height - 9) + " " + (_vm.width * 0.92 + 7) + ", " + (_vm.height - 9) + "\n          ")}})])],1),_vm._v(" "),_c('polygon',{attrs:{"fill":_vm.backgroundColor,"points":("\n      15, 9 " + (_vm.width * 0.1 + 1) + ", 9 " + (_vm.width * 0.1 + 4) + ", 6 " + (_vm.width * 0.52 + 2) + ", 6\n      " + (_vm.width * 0.52 + 6) + ", 10 " + (_vm.width * 0.58 - 7) + ", 10 " + (_vm.width * 0.58 - 2) + ", 6\n      " + (_vm.width * 0.9 + 2) + ", 6 " + (_vm.width * 0.9 + 6) + ", 10 " + (_vm.width - 10) + ", 10 " + (_vm.width - 10) + ", " + (_vm.height * 0.1 - 6) + "\n      " + (_vm.width - 6) + ", " + (_vm.height * 0.1 - 1) + " " + (_vm.width - 6) + ", " + (_vm.height * 0.8 + 1) + " " + (_vm.width - 10) + ", " + (_vm.height * 0.8 + 6) + "\n      " + (_vm.width - 10) + ", " + (_vm.height - 10) + " " + (_vm.width * 0.92 + 7) + ", " + (_vm.height - 10) + "  " + (_vm.width * 0.92 + 2) + ", " + (_vm.height - 6) + "\n      11, " + (_vm.height - 6) + " 11, " + (_vm.height * 0.15 - 2) + " 15, " + (_vm.height * 0.15 - 7) + "\n    ")}}),_vm._v(" "),_c('rect',{attrs:{"x":"0","y":"0","width":_vm.width,"height":_vm.height,"fill":("url(#" + _vm.gradientId + ")"),"mask":("url(#" + _vm.maskId + ")")}})]),_vm._v(" "),_c('div',{staticClass:"border-box-content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var borderBox9_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/borderBox9/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  borderBox9_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_borderBox9_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nHoh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/util/index.js
var util = __webpack_require__("3e7c");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var lib_util = __webpack_require__("9A4f");
var lib_util_default = /*#__PURE__*/__webpack_require__.n(lib_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/color/lib/index.js
var lib = __webpack_require__("glc7");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox11/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var main = ({
  name: 'DvBorderBox11',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    titleWidth: {
      type: Number,
      default: 250
    },
    title: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      ref: 'border-box-11',
      filterId: 'border-box-11-filterId-' + id,

      defaultColor: ['#8aaafb', '#1f33a2'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    },

    fade: lib["fade"]
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox11/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var src_main = ({
  name: 'DvBorderBox11',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    titleWidth: {
      type: Number,
      default: 250
    },
    title: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      ref: 'border-box-11',
      filterId: 'border-box-11-filterId-' + id,

      defaultColor: ['#8aaafb', '#1f33a2'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    },

    fade: lib["fade"]
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3ee2428","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox11/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-border-box-11"},[_c('svg',{staticClass:"dv-border-svg-container",attrs:{"width":_vm.width,"height":_vm.height}},[_c('defs',[_c('filter',{attrs:{"id":_vm.filterId,"height":"150%","width":"150%","x":"-25%","y":"-25%"}},[_c('feMorphology',{attrs:{"operator":"dilate","radius":"2","in":"SourceAlpha","result":"thicken"}}),_vm._v(" "),_c('feGaussianBlur',{attrs:{"in":"thicken","stdDeviation":"3","result":"blurred"}}),_vm._v(" "),_c('feFlood',{attrs:{"flood-color":_vm.mergedColor[1],"result":"glowColor"}}),_vm._v(" "),_c('feComposite',{attrs:{"in":"glowColor","in2":"blurred","operator":"in","result":"softGlowColored"}}),_vm._v(" "),_c('feMerge',[_c('feMergeNode',{attrs:{"in":"softGlowColored"}}),_vm._v(" "),_c('feMergeNode',{attrs:{"in":"SourceGraphic"}})],1)],1)]),_vm._v(" "),_c('polygon',{attrs:{"fill":_vm.backgroundColor,"points":("\n      20, 32 " + (_vm.width * 0.5 - _vm.titleWidth / 2) + ", 32 " + (_vm.width * 0.5 - _vm.titleWidth / 2 + 20) + ", 53\n      " + (_vm.width * 0.5 + _vm.titleWidth / 2 - 20) + ", 53 " + (_vm.width * 0.5 + _vm.titleWidth / 2) + ", 32\n      " + (_vm.width - 20) + ", 32 " + (_vm.width - 8) + ", 48 " + (_vm.width - 8) + ", " + (_vm.height - 25) + " " + (_vm.width - 20) + ", " + (_vm.height - 8) + "\n      20, " + (_vm.height - 8) + " 8, " + (_vm.height - 25) + " 8, 50\n    ")}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"filter":("url(#" + _vm.filterId + ")"),"points":("\n        " + ((_vm.width - _vm.titleWidth) / 2) + ", 30\n        20, 30 7, 50 7, " + (50 + (_vm.height - 167) / 2) + "\n        13, " + (55 + (_vm.height - 167) / 2) + " 13, " + (135 + (_vm.height - 167) / 2) + "\n        7, " + (140 + (_vm.height - 167) / 2) + " 7, " + (_vm.height - 27) + "\n        20, " + (_vm.height - 7) + " " + (_vm.width - 20) + ", " + (_vm.height - 7) + " " + (_vm.width - 7) + ", " + (_vm.height - 27) + "\n        " + (_vm.width - 7) + ", " + (140 + (_vm.height - 167) / 2) + " " + (_vm.width - 13) + ", " + (135 + (_vm.height - 167) / 2) + "\n        " + (_vm.width - 13) + ", " + (55 + (_vm.height - 167) / 2) + " " + (_vm.width - 7) + ", " + (50 + (_vm.height - 167) / 2) + "\n        " + (_vm.width - 7) + ", 50 " + (_vm.width - 20) + ", 30 " + ((_vm.width + _vm.titleWidth) / 2) + ", 30\n        " + ((_vm.width + _vm.titleWidth) / 2 - 20) + ", 7 " + ((_vm.width - _vm.titleWidth) / 2 + 20) + ", 7\n        " + ((_vm.width - _vm.titleWidth) / 2) + ", 30 " + ((_vm.width - _vm.titleWidth) / 2 + 20) + ", 52\n        " + ((_vm.width + _vm.titleWidth) / 2 - 20) + ", 52 " + ((_vm.width + _vm.titleWidth) / 2) + ", 30\n      ")}}),_vm._v(" "),_c('polygon',{attrs:{"stroke":_vm.mergedColor[0],"fill":"transparent","points":("\n        " + ((_vm.width + _vm.titleWidth) / 2 - 5) + ", 30 " + ((_vm.width + _vm.titleWidth) / 2 - 21) + ", 11\n        " + ((_vm.width + _vm.titleWidth) / 2 - 27) + ", 11 " + ((_vm.width + _vm.titleWidth) / 2 - 8) + ", 34\n      ")}}),_vm._v(" "),_c('polygon',{attrs:{"stroke":_vm.mergedColor[0],"fill":"transparent","points":("\n        " + ((_vm.width - _vm.titleWidth) / 2 + 5) + ", 30 " + ((_vm.width - _vm.titleWidth) / 2 + 22) + ", 49\n        " + ((_vm.width - _vm.titleWidth) / 2 + 28) + ", 49 " + ((_vm.width - _vm.titleWidth) / 2 + 8) + ", 26\n      ")}}),_vm._v(" "),_c('polygon',{attrs:{"stroke":_vm.mergedColor[0],"fill":_vm.fade(_vm.mergedColor[1] || _vm.defaultColor[1], 30),"filter":("url(#" + _vm.filterId + ")"),"points":("\n        " + ((_vm.width + _vm.titleWidth) / 2 - 11) + ", 37 " + ((_vm.width + _vm.titleWidth) / 2 - 32) + ", 11\n        " + ((_vm.width - _vm.titleWidth) / 2 + 23) + ", 11 " + ((_vm.width - _vm.titleWidth) / 2 + 11) + ", 23\n        " + ((_vm.width - _vm.titleWidth) / 2 + 33) + ", 49 " + ((_vm.width + _vm.titleWidth) / 2 - 22) + ", 49\n      ")}}),_vm._v(" "),_c('polygon',{attrs:{"filter":("url(#" + _vm.filterId + ")"),"fill":_vm.mergedColor[0],"opacity":"1","points":("\n        " + ((_vm.width - _vm.titleWidth) / 2 - 10) + ", 37 " + ((_vm.width - _vm.titleWidth) / 2 - 31) + ", 37\n        " + ((_vm.width - _vm.titleWidth) / 2 - 25) + ", 46 " + ((_vm.width - _vm.titleWidth) / 2 - 4) + ", 46\n      ")}},[_c('animate',{attrs:{"attributeName":"opacity","values":"1;0.7;1","dur":"2s","begin":"0s","repeatCount":"indefinite"}})]),_vm._v(" "),_c('polygon',{attrs:{"filter":("url(#" + _vm.filterId + ")"),"fill":_vm.mergedColor[0],"opacity":"0.7","points":("\n        " + ((_vm.width - _vm.titleWidth) / 2 - 40) + ", 37 " + ((_vm.width - _vm.titleWidth) / 2 - 61) + ", 37\n        " + ((_vm.width - _vm.titleWidth) / 2 - 55) + ", 46 " + ((_vm.width - _vm.titleWidth) / 2 - 34) + ", 46\n      ")}},[_c('animate',{attrs:{"attributeName":"opacity","values":"0.7;0.4;0.7","dur":"2s","begin":"0s","repeatCount":"indefinite"}})]),_vm._v(" "),_c('polygon',{attrs:{"filter":("url(#" + _vm.filterId + ")"),"fill":_vm.mergedColor[0],"opacity":"0.5","points":("\n        " + ((_vm.width - _vm.titleWidth) / 2 - 70) + ", 37 " + ((_vm.width - _vm.titleWidth) / 2 - 91) + ", 37\n        " + ((_vm.width - _vm.titleWidth) / 2 - 85) + ", 46 " + ((_vm.width - _vm.titleWidth) / 2 - 64) + ", 46\n      ")}},[_c('animate',{attrs:{"attributeName":"opacity","values":"0.5;0.2;0.5","dur":"2s","begin":"0s","repeatCount":"indefinite"}})]),_vm._v(" "),_c('polygon',{attrs:{"filter":("url(#" + _vm.filterId + ")"),"fill":_vm.mergedColor[0],"opacity":"1","points":("\n        " + ((_vm.width + _vm.titleWidth) / 2 + 30) + ", 37 " + ((_vm.width + _vm.titleWidth) / 2 + 9) + ", 37\n        " + ((_vm.width + _vm.titleWidth) / 2 + 3) + ", 46 " + ((_vm.width + _vm.titleWidth) / 2 + 24) + ", 46\n      ")}},[_c('animate',{attrs:{"attributeName":"opacity","values":"1;0.7;1","dur":"2s","begin":"0s","repeatCount":"indefinite"}})]),_vm._v(" "),_c('polygon',{attrs:{"filter":("url(#" + _vm.filterId + ")"),"fill":_vm.mergedColor[0],"opacity":"0.7","points":("\n        " + ((_vm.width + _vm.titleWidth) / 2 + 60) + ", 37 " + ((_vm.width + _vm.titleWidth) / 2 + 39) + ", 37\n        " + ((_vm.width + _vm.titleWidth) / 2 + 33) + ", 46 " + ((_vm.width + _vm.titleWidth) / 2 + 54) + ", 46\n      ")}},[_c('animate',{attrs:{"attributeName":"opacity","values":"0.7;0.4;0.7","dur":"2s","begin":"0s","repeatCount":"indefinite"}})]),_vm._v(" "),_c('polygon',{attrs:{"filter":("url(#" + _vm.filterId + ")"),"fill":_vm.mergedColor[0],"opacity":"0.5","points":("\n        " + ((_vm.width + _vm.titleWidth) / 2 + 90) + ", 37 " + ((_vm.width + _vm.titleWidth) / 2 + 69) + ", 37\n        " + ((_vm.width + _vm.titleWidth) / 2 + 63) + ", 46 " + ((_vm.width + _vm.titleWidth) / 2 + 84) + ", 46\n      ")}},[_c('animate',{attrs:{"attributeName":"opacity","values":"0.5;0.2;0.5","dur":"2s","begin":"0s","repeatCount":"indefinite"}})]),_vm._v(" "),_c('text',{staticClass:"dv-border-box-11-title",attrs:{"x":("" + (_vm.width / 2)),"y":"32","fill":"#fff","font-size":"18","text-anchor":"middle","dominant-baseline":"middle"}},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('polygon',{attrs:{"fill":_vm.mergedColor[0],"filter":("url(#" + _vm.filterId + ")"),"points":("\n        7, " + (53 + (_vm.height - 167) / 2) + " 11, " + (57 + (_vm.height - 167) / 2) + "\n        11, " + (133 + (_vm.height - 167) / 2) + " 7, " + (137 + (_vm.height - 167) / 2) + "\n      ")}}),_vm._v(" "),_c('polygon',{attrs:{"fill":_vm.mergedColor[0],"filter":("url(#" + _vm.filterId + ")"),"points":("\n        " + (_vm.width - 7) + ", " + (53 + (_vm.height - 167) / 2) + " " + (_vm.width - 11) + ", " + (57 + (_vm.height - 167) / 2) + "\n        " + (_vm.width - 11) + ", " + (133 + (_vm.height - 167) / 2) + " " + (_vm.width - 7) + ", " + (137 + (_vm.height - 167) / 2) + "\n      ")}})]),_vm._v(" "),_c('div',{staticClass:"border-box-content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var borderBox11_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/borderBox11/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  borderBox11_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_borderBox11_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oKBY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "phTY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rF/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/util/index.js
var lib_util = __webpack_require__("3e7c");
var lib_util_default = /*#__PURE__*/__webpack_require__.n(lib_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/flylineChart/src/main.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var main = ({
  name: 'DvFlylineChart',
  mixins: [autoResize_default.a],
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    dev: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var id = Object(lib_util["uuid"])();
    return {
      ref: 'dv-flyline-chart',
      unique: Math.random(),
      maskId: 'flyline-mask-id-' + id,
      maskCircleId: 'mask-circle-id-' + id,
      gradientId: 'gradient-id-' + id,
      gradient2Id: 'gradient2-id-' + id,

      defaultConfig: {
        /**
         * @description Flyline chart center point
         * @type {Array<Number>}
         * @default centerPoint = [0, 0]
         */
        centerPoint: [0, 0],
        /**
         * @description Flyline start points
         * @type {Array<Array<Number>>}
         * @default points = []
         * @example points = [[10, 10], [100, 100]]
         */
        points: [],
        /**
         * @description Flyline width
         * @type {Number}
         * @default lineWidth = 1
         */
        lineWidth: 1,
        /**
         * @description Orbit color
         * @type {String}
         * @default orbitColor = 'rgba(103, 224, 227, .2)'
         */
        orbitColor: 'rgba(103, 224, 227, .2)',
        /**
         * @description Flyline color
         * @type {String}
         * @default orbitColor = '#ffde93'
         */
        flylineColor: '#ffde93',
        /**
         * @description K value
         * @type {Number}
         * @default k = -0.5
         * @example k = -1 ~ 1
         */
        k: -0.5,
        /**
         * @description Flyline curvature
         * @type {Number}
         * @default curvature = 5
         */
        curvature: 5,
        /**
         * @description Flyline radius
         * @type {Number}
         * @default flylineRadius = 100
         */
        flylineRadius: 100,
        /**
         * @description Flyline animation duration
         * @type {Array<Number>}
         * @default duration = [20, 30]
         */
        duration: [20, 30],
        /**
         * @description Relative points position
         * @type {Boolean}
         * @default relative = true
         */
        relative: true,
        /**
         * @description Back ground image url
         * @type {String}
         * @default bgImgUrl = ''
         * @example bgImgUrl = './img/bg.jpg'
         */
        bgImgUrl: '',
        /**
         * @description Text configuration
         * @type {Object}
         */
        text: {
          /**
           * @description Text offset
           * @type {Array<Number>}
           * @default offset = [0, 15]
           */
          offset: [0, 15],
          /**
           * @description Text color
           * @type {String}
           * @default color = '#ffdb5c'
           */
          color: '#ffdb5c',
          /**
           * @description Text font size
           * @type {Number}
           * @default fontSize = 12
           */
          fontSize: 12
        },
        /**
         * @description Halo configuration
         * @type {Object}
         */
        halo: {
          /**
           * @description Weather to show halo
           * @type {Boolean}
           * @default show = true
           * @example show = true | false
           */
          show: true,
          /**
           * @description Halo animation duration (10 = 1s)
           * @type {Number}
           * @default duration = 30
           */
          duration: 30,
          /**
           * @description Halo color
           * @type {String}
           * @default color = '#fb7293'
           */
          color: '#fb7293',
          /**
           * @description Halo max radius
           * @type {Number}
           * @default radius = 120
           */
          radius: 120
        },
        /**
         * @description Center point img configuration
         * @type {Object}
         */
        centerPointImg: {
          /**
           * @description Center point img width
           * @type {Number}
           * @default width = 40
           */
          width: 40,
          /**
           * @description Center point img height
           * @type {Number}
           * @default height = 40
           */
          height: 40,
          /**
           * @description Center point img url
           * @type {String}
           * @default url = ''
           */
          url: ''
        },
        /**
         * @description Points img configuration
         * @type {Object}
         * @default radius = 120
         */
        pointsImg: {
          /**
           * @description Points img width
           * @type {Number}
           * @default width = 15
           */
          width: 15,
          /**
           * @description Points img height
           * @type {Number}
           * @default height = 15
           */
          height: 15,
          /**
           * @description Points img url
           * @type {String}
           * @default url = ''
           */
          url: ''
        }
      },

      mergedConfig: null,

      paths: [],
      lengths: [],
      times: [],
      texts: []
    };
  },

  watch: {
    config: function config() {
      var calcData = this.calcData;


      calcData();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcData = this.calcData;


      calcData();
    },
    onResize: function onResize() {
      var calcData = this.calcData;


      calcData();
    },
    calcData: function calcData() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var mergeConfig, createFlylinePaths, calcLineLengths, calcTimes, calcTexts;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                mergeConfig = _this.mergeConfig, createFlylinePaths = _this.createFlylinePaths, calcLineLengths = _this.calcLineLengths;


                mergeConfig();

                createFlylinePaths();

                _context.next = 5;
                return calcLineLengths();

              case 5:
                calcTimes = _this.calcTimes, calcTexts = _this.calcTexts;


                calcTimes();

                calcTexts();

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      var mergedConfig = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config || {});

      var points = mergedConfig.points;


      mergedConfig.points = points.map(function (item) {
        if (item instanceof Array) {
          return { position: item, text: '' };
        }

        return item;
      });

      this.mergedConfig = mergedConfig;
    },
    createFlylinePaths: function createFlylinePaths() {
      var getPath = this.getPath,
          mergedConfig = this.mergedConfig,
          width = this.width,
          height = this.height;
      var centerPoint = mergedConfig.centerPoint,
          points = mergedConfig.points,
          relative = mergedConfig.relative;


      points = points.map(function (_ref) {
        var position = _ref.position;
        return position;
      });

      if (relative) {
        centerPoint = [width * centerPoint[0], height * centerPoint[1]];
        points = points.map(function (_ref2) {
          var _ref3 = slicedToArray_default()(_ref2, 2),
              x = _ref3[0],
              y = _ref3[1];

          return [width * x, height * y];
        });
      }

      this.paths = points.map(function (point) {
        return getPath(centerPoint, point);
      });
    },
    getPath: function getPath(center, point) {
      var getControlPoint = this.getControlPoint;


      var controlPoint = getControlPoint(center, point);

      return [point, controlPoint, center];
    },
    getControlPoint: function getControlPoint(_ref4, _ref5) {
      var _ref7 = slicedToArray_default()(_ref4, 2),
          sx = _ref7[0],
          sy = _ref7[1];

      var _ref6 = slicedToArray_default()(_ref5, 2),
          ex = _ref6[0],
          ey = _ref6[1];

      var getKLinePointByx = this.getKLinePointByx,
          mergedConfig = this.mergedConfig;
      var curvature = mergedConfig.curvature,
          k = mergedConfig.k;
      var mx = (sx + ex) / 2,
          my = (sy + ey) / 2;


      var distance = Object(lib_util["getPointDistance"])([sx, sy], [ex, ey]);

      var targetLength = distance / curvature;
      var disDived = targetLength / 2;

      var dx = mx,
          dy = my;


      do {
        dx += disDived;
        dy = getKLinePointByx(k, [mx, my], dx)[1];
      } while (Object(lib_util["getPointDistance"])([mx, my], [dx, dy]) < targetLength);

      return [dx, dy];
    },
    getKLinePointByx: function getKLinePointByx(k, _ref8, x) {
      var _ref9 = slicedToArray_default()(_ref8, 2),
          lx = _ref9[0],
          ly = _ref9[1];

      var y = ly - k * lx + k * x;

      return [x, y];
    },
    calcLineLengths: function calcLineLengths() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var $nextTick, paths, $refs;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                $nextTick = _this2.$nextTick, paths = _this2.paths, $refs = _this2.$refs;
                _context2.next = 3;
                return $nextTick();

              case 3:

                _this2.lengths = paths.map(function (foo, i) {
                  return $refs['path' + i][0].getTotalLength();
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    calcTimes: function calcTimes() {
      var _mergedConfig = this.mergedConfig,
          duration = _mergedConfig.duration,
          points = _mergedConfig.points;


      this.times = points.map(function (foo) {
        return lib_util["randomExtend"].apply(undefined, toConsumableArray_default()(duration)) / 10;
      });
    },
    calcTexts: function calcTexts() {
      var points = this.mergedConfig.points;


      this.texts = points.map(function (_ref10) {
        var text = _ref10.text;
        return text;
      });
    },
    consoleClickPos: function consoleClickPos(_ref11) {
      var offsetX = _ref11.offsetX,
          offsetY = _ref11.offsetY;
      var width = this.width,
          height = this.height,
          dev = this.dev;


      if (!dev) return;

      var relativeX = (offsetX / width).toFixed(2);
      var relativeY = (offsetY / height).toFixed(2);

      console.warn('dv-flyline-chart DEV: \n Click Position is [' + offsetX + ', ' + offsetY + '] \n Relative Position is [' + relativeX + ', ' + relativeY + ']');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/flylineChart/src/main.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var src_main = ({
  name: 'DvFlylineChart',
  mixins: [autoResize_default.a],
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    dev: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var id = Object(lib_util["uuid"])();
    return {
      ref: 'dv-flyline-chart',
      unique: Math.random(),
      maskId: 'flyline-mask-id-' + id,
      maskCircleId: 'mask-circle-id-' + id,
      gradientId: 'gradient-id-' + id,
      gradient2Id: 'gradient2-id-' + id,

      defaultConfig: {
        /**
         * @description Flyline chart center point
         * @type {Array<Number>}
         * @default centerPoint = [0, 0]
         */
        centerPoint: [0, 0],
        /**
         * @description Flyline start points
         * @type {Array<Array<Number>>}
         * @default points = []
         * @example points = [[10, 10], [100, 100]]
         */
        points: [],
        /**
         * @description Flyline width
         * @type {Number}
         * @default lineWidth = 1
         */
        lineWidth: 1,
        /**
         * @description Orbit color
         * @type {String}
         * @default orbitColor = 'rgba(103, 224, 227, .2)'
         */
        orbitColor: 'rgba(103, 224, 227, .2)',
        /**
         * @description Flyline color
         * @type {String}
         * @default orbitColor = '#ffde93'
         */
        flylineColor: '#ffde93',
        /**
         * @description K value
         * @type {Number}
         * @default k = -0.5
         * @example k = -1 ~ 1
         */
        k: -0.5,
        /**
         * @description Flyline curvature
         * @type {Number}
         * @default curvature = 5
         */
        curvature: 5,
        /**
         * @description Flyline radius
         * @type {Number}
         * @default flylineRadius = 100
         */
        flylineRadius: 100,
        /**
         * @description Flyline animation duration
         * @type {Array<Number>}
         * @default duration = [20, 30]
         */
        duration: [20, 30],
        /**
         * @description Relative points position
         * @type {Boolean}
         * @default relative = true
         */
        relative: true,
        /**
         * @description Back ground image url
         * @type {String}
         * @default bgImgUrl = ''
         * @example bgImgUrl = './img/bg.jpg'
         */
        bgImgUrl: '',
        /**
         * @description Text configuration
         * @type {Object}
         */
        text: {
          /**
           * @description Text offset
           * @type {Array<Number>}
           * @default offset = [0, 15]
           */
          offset: [0, 15],
          /**
           * @description Text color
           * @type {String}
           * @default color = '#ffdb5c'
           */
          color: '#ffdb5c',
          /**
           * @description Text font size
           * @type {Number}
           * @default fontSize = 12
           */
          fontSize: 12
        },
        /**
         * @description Halo configuration
         * @type {Object}
         */
        halo: {
          /**
           * @description Weather to show halo
           * @type {Boolean}
           * @default show = true
           * @example show = true | false
           */
          show: true,
          /**
           * @description Halo animation duration (10 = 1s)
           * @type {Number}
           * @default duration = 30
           */
          duration: 30,
          /**
           * @description Halo color
           * @type {String}
           * @default color = '#fb7293'
           */
          color: '#fb7293',
          /**
           * @description Halo max radius
           * @type {Number}
           * @default radius = 120
           */
          radius: 120
        },
        /**
         * @description Center point img configuration
         * @type {Object}
         */
        centerPointImg: {
          /**
           * @description Center point img width
           * @type {Number}
           * @default width = 40
           */
          width: 40,
          /**
           * @description Center point img height
           * @type {Number}
           * @default height = 40
           */
          height: 40,
          /**
           * @description Center point img url
           * @type {String}
           * @default url = ''
           */
          url: ''
        },
        /**
         * @description Points img configuration
         * @type {Object}
         * @default radius = 120
         */
        pointsImg: {
          /**
           * @description Points img width
           * @type {Number}
           * @default width = 15
           */
          width: 15,
          /**
           * @description Points img height
           * @type {Number}
           * @default height = 15
           */
          height: 15,
          /**
           * @description Points img url
           * @type {String}
           * @default url = ''
           */
          url: ''
        }
      },

      mergedConfig: null,

      paths: [],
      lengths: [],
      times: [],
      texts: []
    };
  },

  watch: {
    config: function config() {
      var calcData = this.calcData;


      calcData();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcData = this.calcData;


      calcData();
    },
    onResize: function onResize() {
      var calcData = this.calcData;


      calcData();
    },
    calcData: function calcData() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var mergeConfig, createFlylinePaths, calcLineLengths, calcTimes, calcTexts;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                mergeConfig = _this.mergeConfig, createFlylinePaths = _this.createFlylinePaths, calcLineLengths = _this.calcLineLengths;


                mergeConfig();

                createFlylinePaths();

                _context.next = 5;
                return calcLineLengths();

              case 5:
                calcTimes = _this.calcTimes, calcTexts = _this.calcTexts;


                calcTimes();

                calcTexts();

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      var mergedConfig = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config || {});

      var points = mergedConfig.points;


      mergedConfig.points = points.map(function (item) {
        if (item instanceof Array) {
          return { position: item, text: '' };
        }

        return item;
      });

      this.mergedConfig = mergedConfig;
    },
    createFlylinePaths: function createFlylinePaths() {
      var getPath = this.getPath,
          mergedConfig = this.mergedConfig,
          width = this.width,
          height = this.height;
      var centerPoint = mergedConfig.centerPoint,
          points = mergedConfig.points,
          relative = mergedConfig.relative;


      points = points.map(function (_ref) {
        var position = _ref.position;
        return position;
      });

      if (relative) {
        centerPoint = [width * centerPoint[0], height * centerPoint[1]];
        points = points.map(function (_ref2) {
          var _ref3 = slicedToArray_default()(_ref2, 2),
              x = _ref3[0],
              y = _ref3[1];

          return [width * x, height * y];
        });
      }

      this.paths = points.map(function (point) {
        return getPath(centerPoint, point);
      });
    },
    getPath: function getPath(center, point) {
      var getControlPoint = this.getControlPoint;


      var controlPoint = getControlPoint(center, point);

      return [point, controlPoint, center];
    },
    getControlPoint: function getControlPoint(_ref4, _ref5) {
      var _ref7 = slicedToArray_default()(_ref4, 2),
          sx = _ref7[0],
          sy = _ref7[1];

      var _ref6 = slicedToArray_default()(_ref5, 2),
          ex = _ref6[0],
          ey = _ref6[1];

      var getKLinePointByx = this.getKLinePointByx,
          mergedConfig = this.mergedConfig;
      var curvature = mergedConfig.curvature,
          k = mergedConfig.k;
      var mx = (sx + ex) / 2,
          my = (sy + ey) / 2;


      var distance = Object(lib_util["getPointDistance"])([sx, sy], [ex, ey]);

      var targetLength = distance / curvature;
      var disDived = targetLength / 2;

      var dx = mx,
          dy = my;


      do {
        dx += disDived;
        dy = getKLinePointByx(k, [mx, my], dx)[1];
      } while (Object(lib_util["getPointDistance"])([mx, my], [dx, dy]) < targetLength);

      return [dx, dy];
    },
    getKLinePointByx: function getKLinePointByx(k, _ref8, x) {
      var _ref9 = slicedToArray_default()(_ref8, 2),
          lx = _ref9[0],
          ly = _ref9[1];

      var y = ly - k * lx + k * x;

      return [x, y];
    },
    calcLineLengths: function calcLineLengths() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var $nextTick, paths, $refs;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                $nextTick = _this2.$nextTick, paths = _this2.paths, $refs = _this2.$refs;
                _context2.next = 3;
                return $nextTick();

              case 3:

                _this2.lengths = paths.map(function (foo, i) {
                  return $refs['path' + i][0].getTotalLength();
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    calcTimes: function calcTimes() {
      var _mergedConfig = this.mergedConfig,
          duration = _mergedConfig.duration,
          points = _mergedConfig.points;


      this.times = points.map(function (foo) {
        return lib_util["randomExtend"].apply(undefined, toConsumableArray_default()(duration)) / 10;
      });
    },
    calcTexts: function calcTexts() {
      var points = this.mergedConfig.points;


      this.texts = points.map(function (_ref10) {
        var text = _ref10.text;
        return text;
      });
    },
    consoleClickPos: function consoleClickPos(_ref11) {
      var offsetX = _ref11.offsetX,
          offsetY = _ref11.offsetY;
      var width = this.width,
          height = this.height,
          dev = this.dev;


      if (!dev) return;

      var relativeX = (offsetX / width).toFixed(2);
      var relativeY = (offsetY / height).toFixed(2);

      console.warn('dv-flyline-chart DEV: \n Click Position is [' + offsetX + ', ' + offsetY + '] \n Relative Position is [' + relativeX + ', ' + relativeY + ']');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f2d20f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/flylineChart/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dv-flyline-chart",staticClass:"dv-flyline-chart",style:(("background-image: url(" + (_vm.mergedConfig ? _vm.mergedConfig.bgImgUrl : '') + ")")),on:{"click":_vm.consoleClickPos}},[(_vm.mergedConfig)?_c('svg',{attrs:{"width":_vm.width,"height":_vm.height}},[_c('defs',[_c('radialGradient',{attrs:{"id":_vm.gradientId,"cx":"50%","cy":"50%","r":"50%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#fff","stop-opacity":"1"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#fff","stop-opacity":"0"}})],1),_vm._v(" "),_c('radialGradient',{attrs:{"id":_vm.gradient2Id,"cx":"50%","cy":"50%","r":"50%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#fff","stop-opacity":"0"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#fff","stop-opacity":"1"}})],1),_vm._v(" "),(_vm.paths[0])?_c('circle',{attrs:{"id":("circle" + (_vm.paths[0].toString())),"cx":_vm.paths[0][2][0],"cy":_vm.paths[0][2][1]}},[_c('animate',{attrs:{"attributeName":"r","values":("1;" + (_vm.mergedConfig.halo.radius)),"dur":_vm.mergedConfig.halo.duration / 10 + 's',"repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"opacity","values":"1;0","dur":_vm.mergedConfig.halo.duration / 10 + 's',"repeatCount":"indefinite"}})]):_vm._e()],1),_vm._v(" "),(_vm.paths[0])?_c('image',{attrs:{"xlink:href":_vm.mergedConfig.centerPointImg.url,"width":_vm.mergedConfig.centerPointImg.width,"height":_vm.mergedConfig.centerPointImg.height,"x":_vm.paths[0][2][0] - _vm.mergedConfig.centerPointImg.width / 2,"y":_vm.paths[0][2][1] - _vm.mergedConfig.centerPointImg.height / 2}}):_vm._e(),_vm._v(" "),_c('mask',{attrs:{"id":("maskhalo" + (_vm.paths[0].toString()))}},[(_vm.paths[0])?_c('use',{attrs:{"xlink:href":("#circle" + (_vm.paths[0].toString())),"fill":("url(#" + _vm.gradient2Id + ")")}}):_vm._e()]),_vm._v(" "),(_vm.paths[0] && _vm.mergedConfig.halo.show)?_c('use',{attrs:{"xlink:href":("#circle" + (_vm.paths[0].toString())),"fill":_vm.mergedConfig.halo.color,"mask":("url(#maskhalo" + (_vm.paths[0].toString()) + ")")}}):_vm._e(),_vm._v(" "),_vm._l((_vm.paths),function(path,i){return _c('g',{key:i},[_c('defs',[_c('path',{ref:("path" + i),refInFor:true,attrs:{"id":("path" + (path.toString())),"d":("M" + (path[0].toString()) + " Q" + (path[1].toString()) + " " + (path[2].toString())),"fill":"transparent"}})]),_vm._v(" "),_c('use',{attrs:{"xlink:href":("#path" + (path.toString())),"stroke-width":_vm.mergedConfig.lineWidth,"stroke":_vm.mergedConfig.orbitColor}}),_vm._v(" "),(_vm.lengths[i])?_c('use',{attrs:{"xlink:href":("#path" + (path.toString())),"stroke-width":_vm.mergedConfig.lineWidth,"stroke":_vm.mergedConfig.flylineColor,"mask":("url(#mask" + _vm.unique + (path.toString()) + ")")}},[_c('animate',{attrs:{"attributeName":"stroke-dasharray","from":("0, " + (_vm.lengths[i])),"to":((_vm.lengths[i]) + ", 0"),"dur":_vm.times[i] || 0,"repeatCount":"indefinite"}})]):_vm._e(),_vm._v(" "),_c('mask',{attrs:{"id":("mask" + _vm.unique + (path.toString()))}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":_vm.mergedConfig.flylineRadius,"fill":("url(#" + _vm.gradientId + ")")}},[_c('animateMotion',{attrs:{"dur":_vm.times[i] || 0,"path":("M" + (path[0].toString()) + " Q" + (path[1].toString()) + " " + (path[2].toString())),"rotate":"auto","repeatCount":"indefinite"}})],1)]),_vm._v(" "),_c('image',{attrs:{"xlink:href":_vm.mergedConfig.pointsImg.url,"width":_vm.mergedConfig.pointsImg.width,"height":_vm.mergedConfig.pointsImg.height,"x":path[0][0] - _vm.mergedConfig.pointsImg.width / 2,"y":path[0][1] - _vm.mergedConfig.pointsImg.height / 2}}),_vm._v(" "),_c('text',{style:(("fontSize:" + (_vm.mergedConfig.text.fontSize) + "px;")),attrs:{"fill":_vm.mergedConfig.text.color,"x":path[0][0] + _vm.mergedConfig.text.offset[0],"y":path[0][1] + _vm.mergedConfig.text.offset[1]}},[_vm._v("\n        "+_vm._s(_vm.texts[i])+"\n      ")])])})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var flylineChart_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/flylineChart/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  flylineChart_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_flylineChart_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25afd1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Gh+6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sSQA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vA0W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/util/index.js
var util = __webpack_require__("3e7c");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var lib_util = __webpack_require__("9A4f");
var lib_util_default = /*#__PURE__*/__webpack_require__.n(lib_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration10/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var main = ({
  name: 'DvDecoration10',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      ref: 'decoration-10',

      animationId1: 'd10ani1' + id,
      animationId2: 'd10ani2' + id,
      animationId3: 'd10ani3' + id,
      animationId4: 'd10ani4' + id,
      animationId5: 'd10ani5' + id,
      animationId6: 'd10ani6' + id,
      animationId7: 'd10ani7' + id,

      defaultColor: ['#00c2ff', 'rgba(0, 194, 255, 0.3)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration10/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var src_main = ({
  name: 'DvDecoration10',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var id = Object(util["uuid"])();
    return {
      ref: 'decoration-10',

      animationId1: 'd10ani1' + id,
      animationId2: 'd10ani2' + id,
      animationId3: 'd10ani3' + id,
      animationId4: 'd10ani4' + id,
      animationId5: 'd10ani5' + id,
      animationId6: 'd10ani6' + id,
      animationId7: 'd10ani7' + id,

      defaultColor: ['#00c2ff', 'rgba(0, 194, 255, 0.3)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(lib_util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69543fb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/decoration10/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-decoration-10"},[_c('svg',{attrs:{"width":_vm.width,"height":_vm.height}},[_c('polyline',{attrs:{"stroke":_vm.mergedColor[1],"stroke-width":"2","points":("0, " + (_vm.height / 2) + " " + _vm.width + ", " + (_vm.height / 2))}}),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"stroke-width":"2","points":("5, " + (_vm.height / 2) + " " + (_vm.width * 0.2 - 3) + ", " + (_vm.height / 2)),"stroke-dasharray":("0, " + (_vm.width * 0.2)),"fill":"freeze"}},[_c('animate',{attrs:{"id":_vm.animationId2,"attributeName":"stroke-dasharray","values":("0, " + (_vm.width * 0.2) + ";" + (_vm.width * 0.2) + ", 0;"),"dur":"3s","begin":(_vm.animationId1 + ".end"),"fill":"freeze"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"stroke-dasharray","values":((_vm.width * 0.2) + ", 0;0, " + (_vm.width * 0.2)),"dur":"0.01s","begin":(_vm.animationId7 + ".end"),"fill":"freeze"}})]),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"stroke-width":"2","points":((_vm.width * 0.2 + 3) + ", " + (_vm.height / 2) + " " + (_vm.width * 0.8 - 3) + ", " + (_vm.height / 2)),"stroke-dasharray":("0, " + (_vm.width * 0.6))}},[_c('animate',{attrs:{"id":_vm.animationId4,"attributeName":"stroke-dasharray","values":("0, " + (_vm.width * 0.6) + ";" + (_vm.width * 0.6) + ", 0"),"dur":"3s","begin":(_vm.animationId3 + ".end + 1s"),"fill":"freeze"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"stroke-dasharray","values":((_vm.width * 0.6) + ", 0;0, " + (_vm.width * 0.6)),"dur":"0.01s","begin":(_vm.animationId7 + ".end"),"fill":"freeze"}})]),_vm._v(" "),_c('polyline',{attrs:{"stroke":_vm.mergedColor[0],"stroke-width":"2","points":((_vm.width * 0.8 + 3) + ", " + (_vm.height / 2) + " " + (_vm.width - 5) + ", " + (_vm.height / 2)),"stroke-dasharray":("0, " + (_vm.width * 0.2))}},[_c('animate',{attrs:{"id":_vm.animationId6,"attributeName":"stroke-dasharray","values":("0, " + (_vm.width * 0.2) + ";" + (_vm.width * 0.2) + ", 0"),"dur":"3s","begin":(_vm.animationId5 + ".end + 1s"),"fill":"freeze"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"stroke-dasharray","values":((_vm.width * 0.2) + ", 0;0, " + (_vm.width * 0.3)),"dur":"0.01s","begin":(_vm.animationId7 + ".end"),"fill":"freeze"}})]),_vm._v(" "),_c('circle',{attrs:{"cx":"2","cy":_vm.height / 2,"r":"2","fill":_vm.mergedColor[1]}},[_c('animate',{attrs:{"id":_vm.animationId1,"attributeName":"fill","values":((_vm.mergedColor[1]) + ";" + (_vm.mergedColor[0])),"begin":("0s;" + _vm.animationId7 + ".end"),"dur":"0.3s","fill":"freeze"}})]),_vm._v(" "),_c('circle',{attrs:{"cx":_vm.width * 0.2,"cy":_vm.height / 2,"r":"2","fill":_vm.mergedColor[1]}},[_c('animate',{attrs:{"id":_vm.animationId3,"attributeName":"fill","values":((_vm.mergedColor[1]) + ";" + (_vm.mergedColor[0])),"begin":(_vm.animationId2 + ".end"),"dur":"0.3s","fill":"freeze"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill","values":((_vm.mergedColor[1]) + ";" + (_vm.mergedColor[1])),"dur":"0.01s","begin":(_vm.animationId7 + ".end"),"fill":"freeze"}})]),_vm._v(" "),_c('circle',{attrs:{"cx":_vm.width * 0.8,"cy":_vm.height / 2,"r":"2","fill":_vm.mergedColor[1]}},[_c('animate',{attrs:{"id":_vm.animationId5,"attributeName":"fill","values":((_vm.mergedColor[1]) + ";" + (_vm.mergedColor[0])),"begin":(_vm.animationId4 + ".end"),"dur":"0.3s","fill":"freeze"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill","values":((_vm.mergedColor[1]) + ";" + (_vm.mergedColor[1])),"dur":"0.01s","begin":(_vm.animationId7 + ".end"),"fill":"freeze"}})]),_vm._v(" "),_c('circle',{attrs:{"cx":_vm.width - 2,"cy":_vm.height / 2,"r":"2","fill":_vm.mergedColor[1]}},[_c('animate',{attrs:{"id":_vm.animationId7,"attributeName":"fill","values":((_vm.mergedColor[1]) + ";" + (_vm.mergedColor[0])),"begin":(_vm.animationId6 + ".end"),"dur":"0.3s","fill":"freeze"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"fill","values":((_vm.mergedColor[1]) + ";" + (_vm.mergedColor[1])),"dur":"0.01s","begin":(_vm.animationId7 + ".end"),"fill":"freeze"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var decoration10_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/decoration10/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  decoration10_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_decoration10_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vQuI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vThT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox1/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvBorderBox1',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-1',

      border: ['left-top', 'right-top', 'left-bottom', 'right-bottom'],

      defaultColor: ['#4fd2dd', '#235fa7'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox1/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvBorderBox1',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-1',

      border: ['left-top', 'right-top', 'left-bottom', 'right-bottom'],

      defaultColor: ['#4fd2dd', '#235fa7'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-205f0004","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox1/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-border-box-1"},[_c('svg',{staticClass:"border",attrs:{"width":_vm.width,"height":_vm.height}},[_c('polygon',{attrs:{"fill":_vm.backgroundColor,"points":("10, 27 10, " + (_vm.height - 27) + " 13, " + (_vm.height - 24) + " 13, " + (_vm.height - 21) + " 24, " + (_vm.height - 11) + "\n    38, " + (_vm.height - 11) + " 41, " + (_vm.height - 8) + " 73, " + (_vm.height - 8) + " 75, " + (_vm.height - 10) + " 81, " + (_vm.height - 10) + "\n    85, " + (_vm.height - 6) + " " + (_vm.width - 85) + ", " + (_vm.height - 6) + " " + (_vm.width - 81) + ", " + (_vm.height - 10) + " " + (_vm.width - 75) + ", " + (_vm.height - 10) + "\n    " + (_vm.width - 73) + ", " + (_vm.height - 8) + " " + (_vm.width - 41) + ", " + (_vm.height - 8) + " " + (_vm.width - 38) + ", " + (_vm.height - 11) + "\n    " + (_vm.width - 24) + ", " + (_vm.height - 11) + " " + (_vm.width - 13) + ", " + (_vm.height - 21) + " " + (_vm.width - 13) + ", " + (_vm.height - 24) + "\n    " + (_vm.width - 10) + ", " + (_vm.height - 27) + " " + (_vm.width - 10) + ", 27 " + (_vm.width - 13) + ", 25 " + (_vm.width - 13) + ", 21\n    " + (_vm.width - 24) + ", 11 " + (_vm.width - 38) + ", 11 " + (_vm.width - 41) + ", 8 " + (_vm.width - 73) + ", 8 " + (_vm.width - 75) + ", 10\n    " + (_vm.width - 81) + ", 10 " + (_vm.width - 85) + ", 6 85, 6 81, 10 75, 10 73, 8 41, 8 38, 11 24, 11 13, 21 13, 24")}})]),_vm._v(" "),_vm._l((_vm.border),function(item){return _c('svg',{key:item,class:(item + " border"),attrs:{"width":"150px","height":"150px"}},[_c('polygon',{attrs:{"fill":_vm.mergedColor[0],"points":"6,66 6,18 12,12 18,12 24,6 27,6 30,9 36,9 39,6 84,6 81,9 75,9 73.2,7 40.8,7 37.8,10.2 24,10.2 12,21 12,24 9,27 9,51 7.8,54 7.8,63"}},[_c('animate',{attrs:{"attributeName":"fill","values":((_vm.mergedColor[0]) + ";" + (_vm.mergedColor[1]) + ";" + (_vm.mergedColor[0])),"dur":"0.5s","begin":"0s","repeatCount":"indefinite"}})]),_vm._v(" "),_c('polygon',{attrs:{"fill":_vm.mergedColor[1],"points":"27.599999999999998,4.8 38.4,4.8 35.4,7.8 30.599999999999998,7.8"}},[_c('animate',{attrs:{"attributeName":"fill","values":((_vm.mergedColor[1]) + ";" + (_vm.mergedColor[0]) + ";" + (_vm.mergedColor[1])),"dur":"0.5s","begin":"0s","repeatCount":"indefinite"}})]),_vm._v(" "),_c('polygon',{attrs:{"fill":_vm.mergedColor[0],"points":"9,54 9,63 7.199999999999999,66 7.199999999999999,75 7.8,78 7.8,110 8.4,110 8.4,66 9.6,66 9.6,54"}},[_c('animate',{attrs:{"attributeName":"fill","values":((_vm.mergedColor[0]) + ";" + (_vm.mergedColor[1]) + ";transparent"),"dur":"1s","begin":"0s","repeatCount":"indefinite"}})])])}),_vm._v(" "),_c('div',{staticClass:"border-box-content"},[_vm._t("default")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var borderBox1_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/borderBox1/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  borderBox1_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_borderBox1_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xF9X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox5/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var main = ({
  name: 'DvBorderBox5',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    reverse: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-5',

      defaultColor: ['rgba(255, 255, 255, 0.35)', 'rgba(255, 255, 255, 0.20)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox5/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var src_main = ({
  name: 'DvBorderBox5',
  mixins: [autoResize_default.a],
  props: {
    color: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    reverse: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      ref: 'border-box-5',

      defaultColor: ['rgba(255, 255, 255, 0.35)', 'rgba(255, 255, 255, 0.20)'],

      mergedColor: []
    };
  },

  watch: {
    color: function color() {
      var mergeColor = this.mergeColor;


      mergeColor();
    }
  },
  methods: {
    mergeColor: function mergeColor() {
      var color = this.color,
          defaultColor = this.defaultColor;


      this.mergedColor = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultColor, true), color || []);
    }
  },
  mounted: function mounted() {
    var mergeColor = this.mergeColor;


    mergeColor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-435731f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/borderBox5/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-border-box-5"},[_c('svg',{class:("dv-border-svg-container  " + (_vm.reverse && 'dv-reverse')),attrs:{"width":_vm.width,"height":_vm.height}},[_c('polygon',{attrs:{"fill":_vm.backgroundColor,"points":("\n      10, 22 " + (_vm.width - 22) + ", 22 " + (_vm.width - 22) + ", " + (_vm.height - 86) + " " + (_vm.width - 84) + ", " + (_vm.height - 24) + " 10, " + (_vm.height - 24) + "\n    ")}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb5-line-1",attrs:{"stroke":_vm.mergedColor[0],"points":("8, 5 " + (_vm.width - 5) + ", 5 " + (_vm.width - 5) + ", " + (_vm.height - 100) + "\n        " + (_vm.width - 100) + ", " + (_vm.height - 5) + " 8, " + (_vm.height - 5) + " 8, 5")}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb5-line-2",attrs:{"stroke":_vm.mergedColor[1],"points":("3, 5 " + (_vm.width - 20) + ", 5 " + (_vm.width - 20) + ", " + (_vm.height - 60) + "\n        " + (_vm.width - 74) + ", " + (_vm.height - 5) + " 3, " + (_vm.height - 5) + " 3, 5")}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb5-line-3",attrs:{"stroke":_vm.mergedColor[1],"points":("50, 13 " + (_vm.width - 35) + ", 13")}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb5-line-4",attrs:{"stroke":_vm.mergedColor[1],"points":("15, 20 " + (_vm.width - 35) + ", 20")}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb5-line-5",attrs:{"stroke":_vm.mergedColor[1],"points":("15, " + (_vm.height - 20) + " " + (_vm.width - 110) + ", " + (_vm.height - 20))}}),_vm._v(" "),_c('polyline',{staticClass:"dv-bb5-line-6",attrs:{"stroke":_vm.mergedColor[1],"points":("15, " + (_vm.height - 13) + " " + (_vm.width - 110) + ", " + (_vm.height - 13))}})]),_vm._v(" "),_c('div',{staticClass:"border-box-content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var borderBox5_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/borderBox5/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  borderBox5_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_borderBox5_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yFI5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/charts/lib/util/index.js
var util = __webpack_require__("9A4f");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/c-render/lib/plugin/util.js
var plugin_util = __webpack_require__("qf0b");
var plugin_util_default = /*#__PURE__*/__webpack_require__.n(plugin_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/util/index.js
var lib_util = __webpack_require__("3e7c");
var lib_util_default = /*#__PURE__*/__webpack_require__.n(lib_util);

// EXTERNAL MODULE: ./node_modules/@jiaminghi/data-view/lib/mixin/autoResize.js
var autoResize = __webpack_require__("kN6d");
var autoResize_default = /*#__PURE__*/__webpack_require__.n(autoResize);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/flylineChartEnhanced/src/main.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var main = ({
  name: 'DvFlylineChartEnhanced',
  mixins: [autoResize_default.a],
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    dev: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var id = Object(lib_util["uuid"])();
    return {
      ref: 'dv-flyline-chart-enhanced',
      unique: Math.random(),
      flylineGradientId: 'flyline-gradient-id-' + id,
      haloGradientId: 'halo-gradient-id-' + id,
      /**
       * @description Type Declaration
       * 
       * interface Halo {
       *    show?: boolean
       *    duration?: [number, number]
       *    color?: string
       *    radius?: number
       * }
       * 
       * interface Text {
       *    show?: boolean
       *    offset?: [number, number]
       *    color?: string
       *    fontSize?: number
       * }
       * 
       * interface Icon {
       *    show?: boolean
       *    src?: string
       *    width?: number
       *    height?: number
       * }
       * 
       * interface Point {
       *    name: string
       *    coordinate: [number, number]
       *    halo?: Halo
       *    text?: Text
       *    icon?: Icon
       * }
       * 
       * interface Line {
       *    width?: number
       *    color?: string
       *    orbitColor?: string
       *    duration?: [number, number]
       *    radius?: string
       * }
       * 
       * interface Flyline extends Line {
       *    source: string
       *    target: string
       * }
       * 
       * interface FlylineWithPath extends Flyline {
       *    d: string
       *    path: [[number, number], [number, number], [number, number]]
       *    key: string
       * }
       */
      defaultConfig: {
        /**
         * @description Flyline chart points
         * @type {Point[]}
         * @default points = []
         */
        points: [],
        /**
         * @description Lines
         * @type {Flyline[]}
         * @default lines = []
         */
        lines: [],
        /**
         * @description Global halo configuration
         * @type {Halo}
         */
        halo: {
          /**
           * @description Whether to show halo
           * @type {Boolean}
           * @default show = false
           */
          show: false,
          /**
           * @description Halo animation duration (1s = 10)
           * @type {[number, number]}
           */
          duration: [20, 30],
          /**
           * @description Halo color
           * @type {String}
           * @default color = '#fb7293'
           */
          color: '#fb7293',
          /**
           * @description Halo radius
           * @type {Number}
           * @default radius = 120
           */
          radius: 120
        },
        /**
         * @description Global text configuration
         * @type {Text}
         */
        text: {
          /**
           * @description Whether to show text
           * @type {Boolean}
           * @default show = false
           */
          show: false,
          /**
           * @description Text offset
           * @type {[number, number]}
           * @default offset = [0, 15]
           */
          offset: [0, 15],
          /**
           * @description Text color
           * @type {String}
           * @default color = '#ffdb5c'
           */
          color: '#ffdb5c',
          /**
           * @description Text font size
           * @type {Number}
           * @default fontSize = 12
           */
          fontSize: 12
        },
        /**
         * @description Global icon configuration
         * @type {Icon}
         */
        icon: {
          /**
           * @description Whether to show icon
           * @type {Boolean}
           * @default show = false
           */
          show: false,
          /**
           * @description Icon src
           * @type {String}
           * @default src = ''
           */
          src: '',
          /**
           * @description Icon width
           * @type {Number}
           * @default width = 15
           */
          width: 15,
          /**
           * @description Icon height
           * @type {Number}
           * @default width = 15
           */
          height: 15
        },
        /**
         * @description Global line configuration
         * @type {Line}
         */
        line: {
          /**
           * @description Line width
           * @type {Number}
           * @default width = 1
           */
          width: 1,
          /**
           * @description Flyline color
           * @type {String}
           * @default color = '#ffde93'
           */
          color: '#ffde93',
          /**
           * @description Orbit color
           * @type {String}
           * @default orbitColor = 'rgba(103, 224, 227, .2)'
           */
          orbitColor: 'rgba(103, 224, 227, .2)',
          /**
           * @description Flyline animation duration
           * @type {[number, number]}
           * @default duration = [20, 30]
           */
          duration: [20, 30],
          /**
           * @description Flyline radius
           * @type {Number}
           * @default radius = 100
           */
          radius: 100
        },
        /**
         * @description Back ground image url
         * @type {String}
         * @default bgImgSrc = ''
         */
        bgImgSrc: '',
        /**
         * @description K value
         * @type {Number}
         * @default k = -0.5
         * @example k = -1 ~ 1
         */
        k: -0.5,
        /**
         * @description Flyline curvature
         * @type {Number}
         * @default curvature = 5
         */
        curvature: 5,
        /**
         * @description Relative points position
         * @type {Boolean}
         * @default relative = true
         */
        relative: true
      },
      /**
       * @description Fly line data
       * @type {FlylineWithPath[]}
       * @default flylines = []
       */
      flylines: [],
      /**
       * @description Fly line lengths
       * @type {Number[]}
       * @default flylineLengths = []
       */
      flylineLengths: [],
      /**
       * @description Fly line points
       * @default flylinePoints = []
       */
      flylinePoints: [],

      mergedConfig: null
    };
  },

  watch: {
    config: function config() {
      var calcData = this.calcData;


      calcData();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcData = this.calcData;


      calcData();
    },
    onResize: function onResize() {
      var calcData = this.calcData;


      calcData();
    },
    calcData: function calcData() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var mergeConfig, calcflylinePoints, calcLinePaths, calcLineLengths;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                mergeConfig = _this.mergeConfig, calcflylinePoints = _this.calcflylinePoints, calcLinePaths = _this.calcLinePaths;


                mergeConfig();

                calcflylinePoints();

                calcLinePaths();

                calcLineLengths = _this.calcLineLengths;
                _context.next = 7;
                return calcLineLengths();

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      var mergedConfig = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config || {});

      var points = mergedConfig.points,
          lines = mergedConfig.lines,
          halo = mergedConfig.halo,
          text = mergedConfig.text,
          icon = mergedConfig.icon,
          line = mergedConfig.line;


      mergedConfig.points = points.map(function (item) {
        item.halo = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(halo, true), item.halo || {});
        item.text = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(text, true), item.text || {});
        item.icon = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(icon, true), item.icon || {});

        return item;
      });

      mergedConfig.lines = lines.map(function (item) {
        return Object(util["deepMerge"])(Object(plugin_util["deepClone"])(line, true), item);
      });

      this.mergedConfig = mergedConfig;
    },
    calcflylinePoints: function calcflylinePoints() {
      var mergedConfig = this.mergedConfig,
          width = this.width,
          height = this.height;
      var relative = mergedConfig.relative,
          points = mergedConfig.points;


      this.flylinePoints = points.map(function (item, i) {
        var _item$coordinate = slicedToArray_default()(item.coordinate, 2),
            x = _item$coordinate[0],
            y = _item$coordinate[1],
            halo = item.halo,
            icon = item.icon,
            text = item.text;

        if (relative) item.coordinate = [x * width, y * height];

        item.halo.time = lib_util["randomExtend"].apply(undefined, toConsumableArray_default()(halo.duration)) / 10;

        var iw = icon.width,
            ih = icon.height;

        item.icon.x = item.coordinate[0] - iw / 2;
        item.icon.y = item.coordinate[1] - ih / 2;

        var _text$offset = slicedToArray_default()(text.offset, 2),
            ox = _text$offset[0],
            oy = _text$offset[1];

        item.text.x = item.coordinate[0] + ox;
        item.text.y = item.coordinate[1] + oy;

        item.key = '' + item.coordinate.toString() + i;

        return item;
      });
    },
    calcLinePaths: function calcLinePaths() {
      var getPath = this.getPath,
          mergedConfig = this.mergedConfig;
      var points = mergedConfig.points,
          lines = mergedConfig.lines;


      this.flylines = lines.map(function (item) {
        var source = item.source,
            target = item.target,
            duration = item.duration;


        var sourcePoint = points.find(function (_ref) {
          var name = _ref.name;
          return name === source;
        }).coordinate;
        var targetPoint = points.find(function (_ref2) {
          var name = _ref2.name;
          return name === target;
        }).coordinate;

        var path = getPath(sourcePoint, targetPoint).map(function (item) {
          return item.map(function (v) {
            return parseFloat(v.toFixed(10));
          });
        });
        var d = 'M' + path[0].toString() + ' Q' + path[1].toString() + ' ' + path[2].toString();
        var key = 'path' + path.toString();
        var time = lib_util["randomExtend"].apply(undefined, toConsumableArray_default()(duration)) / 10;

        return extends_default()({}, item, { path: path, key: key, d: d, time: time });
      });
    },
    getPath: function getPath(start, end) {
      var getControlPoint = this.getControlPoint;


      var controlPoint = getControlPoint(start, end);

      return [start, controlPoint, end];
    },
    getControlPoint: function getControlPoint(_ref3, _ref4) {
      var _ref6 = slicedToArray_default()(_ref3, 2),
          sx = _ref6[0],
          sy = _ref6[1];

      var _ref5 = slicedToArray_default()(_ref4, 2),
          ex = _ref5[0],
          ey = _ref5[1];

      var getKLinePointByx = this.getKLinePointByx,
          mergedConfig = this.mergedConfig;
      var curvature = mergedConfig.curvature,
          k = mergedConfig.k;
      var mx = (sx + ex) / 2,
          my = (sy + ey) / 2;


      var distance = Object(lib_util["getPointDistance"])([sx, sy], [ex, ey]);

      var targetLength = distance / curvature;
      var disDived = targetLength / 2;

      var dx = mx,
          dy = my;


      do {
        dx += disDived;
        dy = getKLinePointByx(k, [mx, my], dx)[1];
      } while (Object(lib_util["getPointDistance"])([mx, my], [dx, dy]) < targetLength);

      return [dx, dy];
    },
    getKLinePointByx: function getKLinePointByx(k, _ref7, x) {
      var _ref8 = slicedToArray_default()(_ref7, 2),
          lx = _ref8[0],
          ly = _ref8[1];

      var y = ly - k * lx + k * x;

      return [x, y];
    },
    calcLineLengths: function calcLineLengths() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var $nextTick, flylines, $refs;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                $nextTick = _this2.$nextTick, flylines = _this2.flylines, $refs = _this2.$refs;
                _context2.next = 3;
                return $nextTick();

              case 3:

                _this2.flylineLengths = flylines.map(function (_ref9) {
                  var key = _ref9.key;
                  return $refs[key][0].getTotalLength();
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    consoleClickPos: function consoleClickPos(_ref10) {
      var offsetX = _ref10.offsetX,
          offsetY = _ref10.offsetY;
      var width = this.width,
          height = this.height,
          dev = this.dev;


      if (!dev) return;

      var relativeX = (offsetX / width).toFixed(2);
      var relativeY = (offsetY / height).toFixed(2);

      console.warn('dv-flyline-chart-enhanced DEV: \n Click Position is [' + offsetX + ', ' + offsetY + '] \n Relative Position is [' + relativeX + ', ' + relativeY + ']');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@jiaminghi/data-view/lib/components/flylineChartEnhanced/src/main.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var src_main = ({
  name: 'DvFlylineChartEnhanced',
  mixins: [autoResize_default.a],
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    dev: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var id = Object(lib_util["uuid"])();
    return {
      ref: 'dv-flyline-chart-enhanced',
      unique: Math.random(),
      flylineGradientId: 'flyline-gradient-id-' + id,
      haloGradientId: 'halo-gradient-id-' + id,
      /**
       * @description Type Declaration
       * 
       * interface Halo {
       *    show?: boolean
       *    duration?: [number, number]
       *    color?: string
       *    radius?: number
       * }
       * 
       * interface Text {
       *    show?: boolean
       *    offset?: [number, number]
       *    color?: string
       *    fontSize?: number
       * }
       * 
       * interface Icon {
       *    show?: boolean
       *    src?: string
       *    width?: number
       *    height?: number
       * }
       * 
       * interface Point {
       *    name: string
       *    coordinate: [number, number]
       *    halo?: Halo
       *    text?: Text
       *    icon?: Icon
       * }
       * 
       * interface Line {
       *    width?: number
       *    color?: string
       *    orbitColor?: string
       *    duration?: [number, number]
       *    radius?: string
       * }
       * 
       * interface Flyline extends Line {
       *    source: string
       *    target: string
       * }
       * 
       * interface FlylineWithPath extends Flyline {
       *    d: string
       *    path: [[number, number], [number, number], [number, number]]
       *    key: string
       * }
       */
      defaultConfig: {
        /**
         * @description Flyline chart points
         * @type {Point[]}
         * @default points = []
         */
        points: [],
        /**
         * @description Lines
         * @type {Flyline[]}
         * @default lines = []
         */
        lines: [],
        /**
         * @description Global halo configuration
         * @type {Halo}
         */
        halo: {
          /**
           * @description Whether to show halo
           * @type {Boolean}
           * @default show = false
           */
          show: false,
          /**
           * @description Halo animation duration (1s = 10)
           * @type {[number, number]}
           */
          duration: [20, 30],
          /**
           * @description Halo color
           * @type {String}
           * @default color = '#fb7293'
           */
          color: '#fb7293',
          /**
           * @description Halo radius
           * @type {Number}
           * @default radius = 120
           */
          radius: 120
        },
        /**
         * @description Global text configuration
         * @type {Text}
         */
        text: {
          /**
           * @description Whether to show text
           * @type {Boolean}
           * @default show = false
           */
          show: false,
          /**
           * @description Text offset
           * @type {[number, number]}
           * @default offset = [0, 15]
           */
          offset: [0, 15],
          /**
           * @description Text color
           * @type {String}
           * @default color = '#ffdb5c'
           */
          color: '#ffdb5c',
          /**
           * @description Text font size
           * @type {Number}
           * @default fontSize = 12
           */
          fontSize: 12
        },
        /**
         * @description Global icon configuration
         * @type {Icon}
         */
        icon: {
          /**
           * @description Whether to show icon
           * @type {Boolean}
           * @default show = false
           */
          show: false,
          /**
           * @description Icon src
           * @type {String}
           * @default src = ''
           */
          src: '',
          /**
           * @description Icon width
           * @type {Number}
           * @default width = 15
           */
          width: 15,
          /**
           * @description Icon height
           * @type {Number}
           * @default width = 15
           */
          height: 15
        },
        /**
         * @description Global line configuration
         * @type {Line}
         */
        line: {
          /**
           * @description Line width
           * @type {Number}
           * @default width = 1
           */
          width: 1,
          /**
           * @description Flyline color
           * @type {String}
           * @default color = '#ffde93'
           */
          color: '#ffde93',
          /**
           * @description Orbit color
           * @type {String}
           * @default orbitColor = 'rgba(103, 224, 227, .2)'
           */
          orbitColor: 'rgba(103, 224, 227, .2)',
          /**
           * @description Flyline animation duration
           * @type {[number, number]}
           * @default duration = [20, 30]
           */
          duration: [20, 30],
          /**
           * @description Flyline radius
           * @type {Number}
           * @default radius = 100
           */
          radius: 100
        },
        /**
         * @description Back ground image url
         * @type {String}
         * @default bgImgSrc = ''
         */
        bgImgSrc: '',
        /**
         * @description K value
         * @type {Number}
         * @default k = -0.5
         * @example k = -1 ~ 1
         */
        k: -0.5,
        /**
         * @description Flyline curvature
         * @type {Number}
         * @default curvature = 5
         */
        curvature: 5,
        /**
         * @description Relative points position
         * @type {Boolean}
         * @default relative = true
         */
        relative: true
      },
      /**
       * @description Fly line data
       * @type {FlylineWithPath[]}
       * @default flylines = []
       */
      flylines: [],
      /**
       * @description Fly line lengths
       * @type {Number[]}
       * @default flylineLengths = []
       */
      flylineLengths: [],
      /**
       * @description Fly line points
       * @default flylinePoints = []
       */
      flylinePoints: [],

      mergedConfig: null
    };
  },

  watch: {
    config: function config() {
      var calcData = this.calcData;


      calcData();
    }
  },
  methods: {
    afterAutoResizeMixinInit: function afterAutoResizeMixinInit() {
      var calcData = this.calcData;


      calcData();
    },
    onResize: function onResize() {
      var calcData = this.calcData;


      calcData();
    },
    calcData: function calcData() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var mergeConfig, calcflylinePoints, calcLinePaths, calcLineLengths;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                mergeConfig = _this.mergeConfig, calcflylinePoints = _this.calcflylinePoints, calcLinePaths = _this.calcLinePaths;


                mergeConfig();

                calcflylinePoints();

                calcLinePaths();

                calcLineLengths = _this.calcLineLengths;
                _context.next = 7;
                return calcLineLengths();

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    mergeConfig: function mergeConfig() {
      var config = this.config,
          defaultConfig = this.defaultConfig;


      var mergedConfig = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(defaultConfig, true), config || {});

      var points = mergedConfig.points,
          lines = mergedConfig.lines,
          halo = mergedConfig.halo,
          text = mergedConfig.text,
          icon = mergedConfig.icon,
          line = mergedConfig.line;


      mergedConfig.points = points.map(function (item) {
        item.halo = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(halo, true), item.halo || {});
        item.text = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(text, true), item.text || {});
        item.icon = Object(util["deepMerge"])(Object(plugin_util["deepClone"])(icon, true), item.icon || {});

        return item;
      });

      mergedConfig.lines = lines.map(function (item) {
        return Object(util["deepMerge"])(Object(plugin_util["deepClone"])(line, true), item);
      });

      this.mergedConfig = mergedConfig;
    },
    calcflylinePoints: function calcflylinePoints() {
      var mergedConfig = this.mergedConfig,
          width = this.width,
          height = this.height;
      var relative = mergedConfig.relative,
          points = mergedConfig.points;


      this.flylinePoints = points.map(function (item, i) {
        var _item$coordinate = slicedToArray_default()(item.coordinate, 2),
            x = _item$coordinate[0],
            y = _item$coordinate[1],
            halo = item.halo,
            icon = item.icon,
            text = item.text;

        if (relative) item.coordinate = [x * width, y * height];

        item.halo.time = lib_util["randomExtend"].apply(undefined, toConsumableArray_default()(halo.duration)) / 10;

        var iw = icon.width,
            ih = icon.height;

        item.icon.x = item.coordinate[0] - iw / 2;
        item.icon.y = item.coordinate[1] - ih / 2;

        var _text$offset = slicedToArray_default()(text.offset, 2),
            ox = _text$offset[0],
            oy = _text$offset[1];

        item.text.x = item.coordinate[0] + ox;
        item.text.y = item.coordinate[1] + oy;

        item.key = '' + item.coordinate.toString() + i;

        return item;
      });
    },
    calcLinePaths: function calcLinePaths() {
      var getPath = this.getPath,
          mergedConfig = this.mergedConfig;
      var points = mergedConfig.points,
          lines = mergedConfig.lines;


      this.flylines = lines.map(function (item) {
        var source = item.source,
            target = item.target,
            duration = item.duration;


        var sourcePoint = points.find(function (_ref) {
          var name = _ref.name;
          return name === source;
        }).coordinate;
        var targetPoint = points.find(function (_ref2) {
          var name = _ref2.name;
          return name === target;
        }).coordinate;

        var path = getPath(sourcePoint, targetPoint).map(function (item) {
          return item.map(function (v) {
            return parseFloat(v.toFixed(10));
          });
        });
        var d = 'M' + path[0].toString() + ' Q' + path[1].toString() + ' ' + path[2].toString();
        var key = 'path' + path.toString();
        var time = lib_util["randomExtend"].apply(undefined, toConsumableArray_default()(duration)) / 10;

        return extends_default()({}, item, { path: path, key: key, d: d, time: time });
      });
    },
    getPath: function getPath(start, end) {
      var getControlPoint = this.getControlPoint;


      var controlPoint = getControlPoint(start, end);

      return [start, controlPoint, end];
    },
    getControlPoint: function getControlPoint(_ref3, _ref4) {
      var _ref6 = slicedToArray_default()(_ref3, 2),
          sx = _ref6[0],
          sy = _ref6[1];

      var _ref5 = slicedToArray_default()(_ref4, 2),
          ex = _ref5[0],
          ey = _ref5[1];

      var getKLinePointByx = this.getKLinePointByx,
          mergedConfig = this.mergedConfig;
      var curvature = mergedConfig.curvature,
          k = mergedConfig.k;
      var mx = (sx + ex) / 2,
          my = (sy + ey) / 2;


      var distance = Object(lib_util["getPointDistance"])([sx, sy], [ex, ey]);

      var targetLength = distance / curvature;
      var disDived = targetLength / 2;

      var dx = mx,
          dy = my;


      do {
        dx += disDived;
        dy = getKLinePointByx(k, [mx, my], dx)[1];
      } while (Object(lib_util["getPointDistance"])([mx, my], [dx, dy]) < targetLength);

      return [dx, dy];
    },
    getKLinePointByx: function getKLinePointByx(k, _ref7, x) {
      var _ref8 = slicedToArray_default()(_ref7, 2),
          lx = _ref8[0],
          ly = _ref8[1];

      var y = ly - k * lx + k * x;

      return [x, y];
    },
    calcLineLengths: function calcLineLengths() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var $nextTick, flylines, $refs;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                $nextTick = _this2.$nextTick, flylines = _this2.flylines, $refs = _this2.$refs;
                _context2.next = 3;
                return $nextTick();

              case 3:

                _this2.flylineLengths = flylines.map(function (_ref9) {
                  var key = _ref9.key;
                  return $refs[key][0].getTotalLength();
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    consoleClickPos: function consoleClickPos(_ref10) {
      var offsetX = _ref10.offsetX,
          offsetY = _ref10.offsetY;
      var width = this.width,
          height = this.height,
          dev = this.dev;


      if (!dev) return;

      var relativeX = (offsetX / width).toFixed(2);
      var relativeY = (offsetY / height).toFixed(2);

      console.warn('dv-flyline-chart-enhanced DEV: \n Click Position is [' + offsetX + ', ' + offsetY + '] \n Relative Position is [' + relativeX + ', ' + relativeY + ']');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-600be252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@jiaminghi/data-view/lib/components/flylineChartEnhanced/src/main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-flyline-chart-enhanced",style:(("background-image: url(" + (_vm.mergedConfig ? _vm.mergedConfig.bgImgSrc : '') + ")")),on:{"click":_vm.consoleClickPos}},[(_vm.flylines.length)?_c('svg',{attrs:{"width":_vm.width,"height":_vm.height}},[_c('defs',[_c('radialGradient',{attrs:{"id":_vm.flylineGradientId,"cx":"50%","cy":"50%","r":"50%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#fff","stop-opacity":"1"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#fff","stop-opacity":"0"}})],1),_vm._v(" "),_c('radialGradient',{attrs:{"id":_vm.haloGradientId,"cx":"50%","cy":"50%","r":"50%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#fff","stop-opacity":"0"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#fff","stop-opacity":"1"}})],1)],1),_vm._v(" "),_vm._l((_vm.flylinePoints),function(point){return _c('g',{key:point.key + Math.random()},[_c('defs',[(point.halo.show)?_c('circle',{attrs:{"id":("halo" + _vm.unique + (point.key)),"cx":point.coordinate[0],"cy":point.coordinate[1]}},[_c('animate',{attrs:{"attributeName":"r","values":("1;" + (point.halo.radius)),"dur":((point.halo.time) + "s"),"repeatCount":"indefinite"}}),_vm._v(" "),_c('animate',{attrs:{"attributeName":"opacity","values":"1;0","dur":((point.halo.time) + "s"),"repeatCount":"indefinite"}})]):_vm._e()]),_vm._v(" "),_c('mask',{attrs:{"id":("mask" + _vm.unique + (point.key))}},[(point.halo.show)?_c('use',{attrs:{"xlink:href":("#halo" + _vm.unique + (point.key)),"fill":("url(#" + _vm.haloGradientId + ")")}}):_vm._e()]),_vm._v(" "),(point.halo.show)?_c('use',{attrs:{"xlink:href":("#halo" + _vm.unique + (point.key)),"fill":point.halo.color,"mask":("url(#mask" + _vm.unique + (point.key) + ")")}}):_vm._e(),_vm._v(" "),(point.icon.show)?_c('image',{attrs:{"xlink:href":point.icon.src,"width":point.icon.width,"height":point.icon.height,"x":point.icon.x,"y":point.icon.y}}):_vm._e(),_vm._v(" "),(point.text.show)?_c('text',{style:(("fontSize:" + (point.text.fontSize) + "px;color:" + (point.text.color))),attrs:{"fill":point.text.color,"x":point.text.x,"y":point.text.y}},[_vm._v("\n        "+_vm._s(point.name)+"\n      ")]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.flylines),function(line,i){return _c('g',{key:line.key + Math.random()},[_c('defs',[_c('path',{ref:line.key,refInFor:true,attrs:{"id":line.key,"d":line.d,"fill":"transparent"}})]),_vm._v(" "),_c('use',{attrs:{"xlink:href":("#" + (line.key)),"stroke-width":line.width,"stroke":line.orbitColor}}),_vm._v(" "),_c('mask',{attrs:{"id":("mask" + _vm.unique + (line.key))}},[_c('circle',{attrs:{"cx":"0","cy":"0","r":line.radius,"fill":("url(#" + _vm.flylineGradientId + ")")}},[_c('animateMotion',{attrs:{"dur":line.time,"path":line.d,"rotate":"auto","repeatCount":"indefinite"}})],1)]),_vm._v(" "),(_vm.flylineLengths[i])?_c('use',{attrs:{"xlink:href":("#" + (line.key)),"stroke-width":line.width,"stroke":line.color,"mask":("url(#mask" + _vm.unique + (line.key) + ")")}},[_c('animate',{attrs:{"attributeName":"stroke-dasharray","from":("0, " + (_vm.flylineLengths[i])),"to":((_vm.flylineLengths[i]) + ", 0"),"dur":line.time,"repeatCount":"indefinite"}})]):_vm._e()])})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var flylineChartEnhanced_src_main = (esExports);
// CONCATENATED MODULE: ./node_modules/@jiaminghi/data-view/lib/components/flylineChartEnhanced/src/main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_main,
  flylineChartEnhanced_src_main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_flylineChartEnhanced_src_main = __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6125a02c4bc65f08c09d.js